import * as React from "react";
import type { SVGProps } from "react";
const SvgSanMarino = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <defs>
      <style>
        {
          ".San_Marino_svg__cls-1{fill:#fff}.San_Marino_svg__cls-11,.San_Marino_svg__cls-12,.San_Marino_svg__cls-13,.San_Marino_svg__cls-3,.San_Marino_svg__cls-4,.San_Marino_svg__cls-6{stroke:#000}.San_Marino_svg__cls-11,.San_Marino_svg__cls-3,.San_Marino_svg__cls-4,.San_Marino_svg__cls-6{stroke-linecap:round}.San_Marino_svg__cls-11,.San_Marino_svg__cls-12,.San_Marino_svg__cls-3,.San_Marino_svg__cls-4,.San_Marino_svg__cls-6{stroke-linejoin:round}.San_Marino_svg__cls-12,.San_Marino_svg__cls-13,.San_Marino_svg__cls-4{fill:none}.San_Marino_svg__cls-11,.San_Marino_svg__cls-5{fill:#658c5c}.San_Marino_svg__cls-6,.San_Marino_svg__cls-7{fill:#a38153}.San_Marino_svg__cls-8{fill:#d89e30}.San_Marino_svg__cls-9{fill:#f0be2e}.San_Marino_svg__cls-10{fill:#476344}.San_Marino_svg__cls-20{fill:#bdbec0}"
        }
      </style>
    </defs>
    <g id="San_Marino_svg__San_Marino" data-name="San Marino">
      <path
        id="San_Marino_svg__polygon10"
        d="M0 719.5h1280V.5H0z"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__polygon12"
        d="M0 360v359.5h1280V360z"
        style={{
          fill: "#5fb5e3",
        }}
      />
      <path
        id="San_Marino_svg__path14"
        d="M509.85 472.36s-4.38-1.77-6.32-2.74c-3.37-1.69-11-11-19.44-15.95-13-7.55-25.62-5.61-37.13-10.55 2.58 12.05 10.7 22.94 24.15 28.71 11 4.74 28.87.66 30.81.83s8.08 2.54 8.08 2.54l-.16-2.84Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path16"
        d="M793 338.83a.9.9 0 0 1 .06-.35 10.4 10.4 0 0 0 .8-1.53 10.2 10.2 0 0 0 .84-3.78 2.6 2.6 0 0 0-.74-1.64s-.16-.77.34-.71l3.47.48c.47.06.57.47.19.74l-.11.09c-.07.08-.18.18-.3.32a3.1 3.1 0 0 0-.64 1.17c-1.84 6.59-1.92 8.93-1.92 8.93a.41.41 0 1 1-.81.11z"
      />
      <path
        id="San_Marino_svg__path18"
        d="M793 338.83a.9.9 0 0 1 .06-.35 10.4 10.4 0 0 0 .8-1.53 10.2 10.2 0 0 0 .84-3.78 2.6 2.6 0 0 0-.74-1.64s-.16-.77.34-.71l3.47.48c.47.06.57.47.19.74l-.11.09c-.07.08-.18.18-.3.32a3.1 3.1 0 0 0-.64 1.17c-1.84 6.59-1.92 8.93-1.92 8.93a.41.41 0 1 1-.81.11z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path20"
        d="M798.92 362.36c1.76-1.16 2.36-4.15 2.47-6.09.19-3.47-2.7-6.54-2.85-9.76-.09-2.07 1.69-2.28 2-3.89.3-1.44-5.29-6.48-3.78-10.45 1.08-2.84 3.34-1.44 4.2-4.41.91-3.15-1.91-7.64 1.72-9.75 1.76-1 4.36.46 5.12-2.29s.16-8.36 4.2-8.76c5.35-.52 6.18 10.44 7.16 11.2s2.39-.66 3.85-.08c3.93 1.56-.28 8.81-1.63 11.23 10 .41.85 6.61-.68 9.36.42 1 3 1.38 3.39 2.91a2.65 2.65 0 0 1-1.18 2.52c-2.23 2-5.56 2.71-8 4.3l-.33.24c-.08.91 2.44 3.58-1 4.71-6.36 2.12-10.4 3.51-12.86 9.93-.66 1.72-.89 7-1 6.46l-.87-7.38Z"
      />
      <path
        id="San_Marino_svg__path22"
        d="M798.92 362.36c1.76-1.16 2.36-4.15 2.47-6.09.19-3.47-2.7-6.54-2.85-9.76-.09-2.07 1.69-2.28 2-3.89.3-1.44-5.29-6.48-3.78-10.45 1.08-2.84 3.34-1.44 4.2-4.41.91-3.15-1.91-7.64 1.72-9.75 1.76-1 4.36.46 5.12-2.29s.16-8.36 4.2-8.76c5.35-.52 6.18 10.44 7.16 11.2s2.39-.66 3.85-.08c3.93 1.56-.28 8.81-1.63 11.23 10 .41.85 6.61-.68 9.36.42 1 3 1.38 3.39 2.91a2.65 2.65 0 0 1-1.18 2.52c-2.23 2-5.56 2.71-8 4.3l-.33.24c-.08.91 2.44 3.58-1 4.71-6.36 2.12-10.4 3.51-12.86 9.93-.66 1.72-.89 7-1 6.46l-.87-7.38Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path24"
        d="m799.88 367.38-1.1-4.86a4 4 0 0 0 .8-.63c1.29-1.24 1.91-4.68 2-6.41.21-3.74-2.5-5.89-2.64-9-.07-1.62 1.72-2.2 2-3.73.37-1.95-5-6.66-3.6-10.35 1-2.5 3.28-1.21 4.22-4.46.81-2.84-1.64-7.9 1.43-9.6 1.85-1 4.51.63 5.41-2.66.68-2.47.15-6.71 3.66-7.06 4.76-.47 5.48 9.09 6.71 10 1.38 1.06 2.47-.31 3.79.21 2 .77 1.5 3.52 1 5.11a36 36 0 0 1-2.18 5.07c-.14.34-.15.66.26.81 1.25.48 2.32.28 2.75 1.92.59 2.23-2.84 4.67-3.59 6.44-.59 1.37 1.72 1.72 2 3.54.43 2.58-8.21 5.46-8.87 6.67-.08 1.68 2.17 3.43-.56 4.34-6.84 2.29-13.67 6.6-13.59 14.62Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path26"
        d="m799.88 367.38-1.1-4.86a4 4 0 0 0 .8-.63c1.29-1.24 1.91-4.68 2-6.41.21-3.74-2.5-5.89-2.64-9-.07-1.62 1.72-2.2 2-3.73.37-1.95-5-6.66-3.6-10.35 1-2.5 3.28-1.21 4.22-4.46.81-2.84-1.64-7.9 1.43-9.6 1.85-1 4.51.63 5.41-2.66.68-2.47.15-6.71 3.66-7.06 4.76-.47 5.48 9.09 6.71 10 1.38 1.06 2.47-.31 3.79.21 2 .77 1.5 3.52 1 5.11a36 36 0 0 1-2.18 5.07c-.14.34-.15.66.26.81 1.25.48 2.32.28 2.75 1.92.59 2.23-2.84 4.67-3.59 6.44-.59 1.37 1.72 1.72 2 3.54.43 2.58-8.21 5.46-8.87 6.67-.08 1.68 2.17 3.43-.56 4.34-6.84 2.29-13.67 6.6-13.59 14.62Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path28"
        d="M799.29 363.09s8.7-15.51 11.22-26.52c1.74-7.62 2.51-19.95 2.51-19.95s-.38 12.29-1.89 19.93c-2.3 11.61-11.3 28-11.3 28z"
      />
      <path
        id="San_Marino_svg__path30"
        d="M799.29 363.09s8.7-15.51 11.22-26.52c1.74-7.62 2.51-19.95 2.51-19.95s-.38 12.29-1.89 19.93c-2.3 11.61-11.3 28-11.3 28z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path32"
        d="M799.57 377.81a.74.74 0 0 1 .1-.35s1.7-1.79 2.71-2.93a4.2 4.2 0 0 0 .79-1.42 5.5 5.5 0 0 0 .19-.74.39.39 0 0 1 .54-.33l2.89.95c.4.13.45.49.11.74a22 22 0 0 0-3 2.52 12.3 12.3 0 0 0-2.94 5.06c-.16.5-.71.46-.8-.06l-.57-3.44Z"
      />
      <path
        id="San_Marino_svg__path34"
        d="M799.57 377.81a.74.74 0 0 1 .1-.35s1.7-1.79 2.71-2.93a4.2 4.2 0 0 0 .79-1.42 5.5 5.5 0 0 0 .19-.74.39.39 0 0 1 .54-.33l2.89.95c.4.13.45.49.11.74a22 22 0 0 0-3 2.52 12.3 12.3 0 0 0-2.94 5.06c-.16.5-.71.46-.8-.06l-.57-3.44Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path36"
        d="M800.55 381.18a12.6 12.6 0 0 1 3-5.19 22 22 0 0 1 3.1-2.6l-2.89-1a5.1 5.1 0 0 1-1.07 2.37c-1 1.15-2.73 2.95-2.73 2.95Z"
        className="San_Marino_svg__cls-6"
      />
      <path
        id="San_Marino_svg__path38"
        d="M789 325.05a113 113 0 0 1 6.77 18.4c6.46 23 7.29 52.89 4.51 69.33-8.55 50.52-54.28 97.75-91.13 105.12-30.94 6.17-49.2 19.36-62.16 33.66-10.09 11.66-14 18.6-23.13 37.23-2.81 5.74-12 6.86-8.06-1.21 7.16-12.66 14-24.36 24.47-36.81 13.66-15.42 33.27-30.56 66.39-37.22 38.09-7.65 82-54.8 90.52-105.32 2.78-16.43 1.92-52.25-7.36-75.3z"
      />
      <path
        id="San_Marino_svg__path40"
        d="M789 325.05a113 113 0 0 1 6.77 18.4c6.46 23 7.29 52.89 4.51 69.33-8.55 50.52-54.28 97.75-91.13 105.12-30.94 6.17-49.2 19.36-62.16 33.66-10.09 11.66-14 18.6-23.13 37.23-2.81 5.74-12 6.86-8.06-1.21 7.16-12.66 14-24.36 24.47-36.81 13.66-15.42 33.27-30.56 66.39-37.22 38.09-7.65 82-54.8 90.52-105.32 2.78-16.43 1.92-52.25-7.36-75.3z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path42"
        d="M769.74 315.7s-10.73-.41-5.57-8.54c-4.91-2.42-10.84-6.8-4.5-10.41-.28-1.24-4-2.42-3.75-5.32.17-1.67 2.28-2.44 2.46-3.16-.7-1.31-5.6-7.6-3.9-9.48 2.61-2.88 8.24.59 10.8 2.13.64-.39 1.59-1.18 2.22-1.6 3.74-2.48 4 3.52 5 5.43.47.88 3.42-1.5 5.42-.44 3.44 1.82 1.92 6.27 2.79 9.28.86-.1 2.1-.8 3-.86 5.59-.37 2.56 9.46 2.32 12.56 8.89-1.28 2.05 7.83 2.54 15.67.14 2.16-.53 6.94-2.2 5.1-5.27-5.79-19.89-4.21-16.63-10.36"
      />
      <path
        id="San_Marino_svg__path44"
        d="M769.74 315.7s-10.73-.41-5.57-8.54c-4.91-2.42-10.84-6.8-4.5-10.41-.28-1.24-4-2.42-3.75-5.32.17-1.67 2.28-2.44 2.46-3.16-.7-1.31-5.6-7.6-3.9-9.48 2.61-2.88 8.24.59 10.8 2.13.64-.39 1.59-1.18 2.22-1.6 3.74-2.48 4 3.52 5 5.43.47.88 3.42-1.5 5.42-.44 3.44 1.82 1.92 6.27 2.79 9.28.86-.1 2.1-.8 3-.86 5.59-.37 2.56 9.46 2.32 12.56 8.89-1.28 2.05 7.83 2.54 15.67.14 2.16-.53 6.94-2.2 5.1-5.27-5.79-19.89-4.21-16.63-10.36"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path46"
        d="M768.5 348c-1.92-.16-6.09-.74-6.91-2.57-1.3-2.89 2.08-3.88 1.91-4.1-1.18-1.58-6.66-2.58-6.7-4.79 0-1.55 2.57-2.66 2.11-4.07-.62-1.93-4.32-4.86-2.88-7 1.73-2.59 5.38.89 7.14.87.83 0 2-1.86 3.62-1.89 2.36 0 3.8 4.55 4.69 4.43s1.59-1.49 2.56-1.78c3-.89 3.8 2.31 4.5 4.39 1.37 4.11 2.86-.77 5.08.2 5.63 2.45 3.31 13.46 4.94 14.78 1 .8 2.83.7 3.55 1.82 1.54 2.39-.57 7.23.61 11.56.48 1.75 5.95 6.84 5.95 6.84s.84 5.09.71 4.82c-2.47-4.73-3-5.86-7.41-9.23-4.23-3.23-10.67-.67-12.16-2.36-1.65-1.89.26-3.62-.6-4.44-.32-.32-5.3.2-6 .12-3.54-.35-6.78-3.56-4.67-7.59Z"
      />
      <path
        id="San_Marino_svg__path48"
        d="M768.5 348c-1.92-.16-6.09-.74-6.91-2.57-1.3-2.89 2.08-3.88 1.91-4.1-1.18-1.58-6.66-2.58-6.7-4.79 0-1.55 2.57-2.66 2.11-4.07-.62-1.93-4.32-4.86-2.88-7 1.73-2.59 5.38.89 7.14.87.83 0 2-1.86 3.62-1.89 2.36 0 3.8 4.55 4.69 4.43s1.59-1.49 2.56-1.78c3-.89 3.8 2.31 4.5 4.39 1.37 4.11 2.86-.77 5.08.2 5.63 2.45 3.31 13.46 4.94 14.78 1 .8 2.83.7 3.55 1.82 1.54 2.39-.57 7.23.61 11.56.48 1.75 5.95 6.84 5.95 6.84s.84 5.09.71 4.82c-2.47-4.73-3-5.86-7.41-9.23-4.23-3.23-10.67-.67-12.16-2.36-1.65-1.89.26-3.62-.6-4.44-.32-.32-5.3.2-6 .12-3.54-.35-6.78-3.56-4.67-7.59Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path50"
        d="m798.1 366.21.57 3.17c-9.06-13-16.46-7.82-18.4-9.93-1.48-1.6.4-2.75-.8-4s-8.9 1.49-11.17-4.43c-.47-1.23 1.22-3.26.36-3.43-1.92-.38-4.52-.32-5.84-2.07-.56-.73-1-1.72-.31-2.51a11 11 0 0 0 1.13-1.22c1.17-1.75-6-3.1-6-5.71 0-1.49 2-2 1.23-3.87-.63-1.61-2.8-4.27-1.69-6 1.34-2.12 4.36.55 6 .74.83.09 2.23-1.85 3.59-1.89 2.17-.06 3.1 4 4.76 3.8s3.45-2.67 5.22-.49c1.23 1.53 1.21 6 4.09 4.69.69-.31 1.72-1.15 2.5-.82 4.62 2 3.44 9.43 4.59 13.38.62 2.12 2.82 1.66 3.61 3a5.06 5.06 0 0 1 .76 2.12 8 8 0 0 1-.13 1.9 18.4 18.4 0 0 0 .54 7.38c.51 2 3.32 5.7 5.36 6.25Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path52"
        d="m798.1 366.21.57 3.17c-9.06-13-16.46-7.82-18.4-9.93-1.48-1.6.4-2.75-.8-4s-8.9 1.49-11.17-4.43c-.47-1.23 1.22-3.26.36-3.43-1.92-.38-4.52-.32-5.84-2.07-.56-.73-1-1.72-.31-2.51a11 11 0 0 0 1.13-1.22c1.17-1.75-6-3.1-6-5.71 0-1.49 2-2 1.23-3.87-.63-1.61-2.8-4.27-1.69-6 1.34-2.12 4.36.55 6 .74.83.09 2.23-1.85 3.59-1.89 2.17-.06 3.1 4 4.76 3.8s3.45-2.67 5.22-.49c1.23 1.53 1.21 6 4.09 4.69.69-.31 1.72-1.15 2.5-.82 4.62 2 3.44 9.43 4.59 13.38.62 2.12 2.82 1.66 3.61 3a5.06 5.06 0 0 1 .76 2.12 8 8 0 0 1-.13 1.9 18.4 18.4 0 0 0 .54 7.38c.51 2 3.32 5.7 5.36 6.25Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path54"
        d="m800.21 405.75.45-.37c1.6 0 2.7-3.33 3.18-4.6 2-5.24-1.59-13.95 4.47-13.93.31-2.17.75-7.5 2.73-8.92 1.43-1 2.83.27 4.2-.14 1-2.05 1.5-5.92 4.41-6.47.92-.17 2.86 1.33 3.18 1.16.79-.39 1.74-4.56 4.07-5.18 1.43-.39 2.79 1.09 3.31.76a13.8 13.8 0 0 0 2.39-2.2c3-3.24 6.83-3.3 6.72 1 0 1.54-1 3.72-1.57 5.13-.19.47 1.91 1.47 2.23 2.09 1.08 2-2.7 4.47-3.55 6.09.06.27 2 .65 2.29 1.06 2.52 3.52-4.76 7.37-6.6 9.54-.73.85 1.76 2.74 1.42 4.21-1.39 5.91-10.49 3.74-12.51 4.65-.7.33-.91 3.49-1.51 4.29-2.56 3.47-12.7-.76-15 1.4-2.1 2-2.8 5.35-4.13 7.76-.29.52-.85.36-.8-.19l.63-7.17Z"
      />
      <path
        id="San_Marino_svg__path56"
        d="m800.21 405.75.45-.37c1.6 0 2.7-3.33 3.18-4.6 2-5.24-1.59-13.95 4.47-13.93.31-2.17.75-7.5 2.73-8.92 1.43-1 2.83.27 4.2-.14 1-2.05 1.5-5.92 4.41-6.47.92-.17 2.86 1.33 3.18 1.16.79-.39 1.74-4.56 4.07-5.18 1.43-.39 2.79 1.09 3.31.76a13.8 13.8 0 0 0 2.39-2.2c3-3.24 6.83-3.3 6.72 1 0 1.54-1 3.72-1.57 5.13-.19.47 1.91 1.47 2.23 2.09 1.08 2-2.7 4.47-3.55 6.09.06.27 2 .65 2.29 1.06 2.52 3.52-4.76 7.37-6.6 9.54-.73.85 1.76 2.74 1.42 4.21-1.39 5.91-10.49 3.74-12.51 4.65-.7.33-.91 3.49-1.51 4.29-2.56 3.47-12.7-.76-15 1.4-2.1 2-2.8 5.35-4.13 7.76-.29.52-.85.36-.8-.19l.63-7.17Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path58"
        d="M800.81 406c1.87-.1 3.05-3.52 3.61-5a18.3 18.3 0 0 0 1.15-5.94c.11-3-2-8.28 2.63-7.57 0 0 1-7 3-8.66 1.31-1 3.66-.45 4.22-.87 1.35-1 .83-5.28 3.72-5.83 1.13-.22 3.14.9 4 .47 1.07-.54 1.45-3.76 3.51-4.3 1.28-.34 3 1 3.82.52 1.76-1.1 3.11-4.59 5.61-3.89 2.82.79 1.82 5.07 1.11 6.82-.52 1.26.91 1.71 1.42 2.63.94 1.73-2.21 4.48-2.6 6-.15.57 1.24 1.26 1.59 1.63 2.1 2.24-3.31 6.2-4.76 7.44-.43.37-1.37 1.11-1.42 1.7-.11 1.25 1.24 2.17.89 3.7-1.18 5.21-8.42 3.67-11.27 4.62-1.14.38-1.31 2.71-2 3.68-2.28 3.13-12.25.11-14.93 2.56a18.9 18.9 0 0 0-3.78 5.94l.5-5.66Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path60"
        d="M800.81 406c1.87-.1 3.05-3.52 3.61-5a18.3 18.3 0 0 0 1.15-5.94c.11-3-2-8.28 2.63-7.57 0 0 1-7 3-8.66 1.31-1 3.66-.45 4.22-.87 1.35-1 .83-5.28 3.72-5.83 1.13-.22 3.14.9 4 .47 1.07-.54 1.45-3.76 3.51-4.3 1.28-.34 3 1 3.82.52 1.76-1.1 3.11-4.59 5.61-3.89 2.82.79 1.82 5.07 1.11 6.82-.52 1.26.91 1.71 1.42 2.63.94 1.73-2.21 4.48-2.6 6-.15.57 1.24 1.26 1.59 1.63 2.1 2.24-3.31 6.2-4.76 7.44-.43.37-1.37 1.11-1.42 1.7-.11 1.25 1.24 2.17.89 3.7-1.18 5.21-8.42 3.67-11.27 4.62-1.14.38-1.31 2.71-2 3.68-2.28 3.13-12.25.11-14.93 2.56a18.9 18.9 0 0 0-3.78 5.94l.5-5.66Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path62"
        d="M802.3 404.67A174 174 0 0 0 821 388a198 198 0 0 0 12.62-16.17s-7.11 10.48-12.41 16.58a192 192 0 0 1-18.92 18.1c-.31.09-.32-1.77 0-1.86Z"
      />
      <path
        id="San_Marino_svg__path64"
        d="M802.3 404.67A174 174 0 0 0 821 388a198 198 0 0 0 12.62-16.17s-7.11 10.48-12.41 16.58a192 192 0 0 1-18.92 18.1c-.31.09-.32-1.77 0-1.86Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path66"
        d="M805 374.54c-2.77-1.61-2.36-10.24 1.7-14.15 3.41-3.29 12.95 6.4 10 10.41-1.64 2.22-8.76 5.44-11.69 3.74Z"
      />
      <path
        id="San_Marino_svg__path68"
        d="M805 374.54c-2.77-1.61-2.36-10.24 1.7-14.15 3.41-3.29 12.95 6.4 10 10.41-1.64 2.22-8.76 5.44-11.69 3.74Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path70"
        d="M816.76 369.32c-1.71 1.41-5.7-.43-7.72-2.45-1.85-1.86-3-4.7-1.87-6 2.19-2.59 8.27-6.32 11.2-3.86s-.06 10.99-1.61 12.31"
      />
      <path
        id="San_Marino_svg__path72"
        d="M816.76 369.32c-1.71 1.41-5.7-.43-7.72-2.45-1.85-1.86-3-4.7-1.87-6 2.19-2.59 8.27-6.32 11.2-3.86s-.06 10.99-1.61 12.31"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path74"
        d="M816.2 370.44c-1.56 2.1-8.35 4.82-10.87 3.36-2.19-1.28-2.17-9.12 1.81-13 2.51-2.42 11.86 5.81 9.06 9.61Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path76"
        d="M816.2 370.44c-1.56 2.1-8.35 4.82-10.87 3.36-2.19-1.28-2.17-9.12 1.81-13 2.51-2.42 11.86 5.81 9.06 9.61Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path78"
        d="M817.76 357.68c2.43 2 .08 9.94-1.4 11.16-1.25 1-4.82-.35-6.88-2.41-1.88-1.89-2.78-4.51-2.05-5.38 2.25-2.66 7.91-5.41 10.33-3.37"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path80"
        d="M814.78 361.2c0-2 .85-3.62 2-4.05a2.9 2.9 0 0 1 1 .53c1.49 1.25 1.18 4.72.37 7.49a1.8 1.8 0 0 1-.75.17c-1.44 0-2.6-1.86-2.6-4.14Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path82"
        d="M817.76 357.68c2.43 2 .08 9.94-1.4 11.16-1.25 1-4.82-.35-6.88-2.41-1.88-1.89-2.78-4.51-2.05-5.38 2.25-2.66 7.91-5.41 10.33-3.37"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path84"
        d="M765.07 377.68c-.77-2.39-4.46-4-4.85-6.92-.17-1.31 1.26-3.53 1.14-3.92-.63-2.08-4.1-4.76-2.32-7.34 2.29-3.34 5.55.11 8.26.9.45-.17.6-1.66 1.66-1.94 4.16-1.11 7.78 5.64 8.87 6.05 3.22 1.22 5.75-4.48 7.51 8 1.37-.32 3.25-.67 4.08.75 3.43 5.88 1.43 18.54 8.28 21.94l.22.45c-.09.49-.31 4.24-1.32 3-1.73-2.1-3.09-5.09-6.11-5.62-3.18-.56-17.08 4.47-17.45-1.84 0-.75 1-1.77.63-2.49-.79-1.74-9.14-1.13-10-5.8-.34-1.83.94-3.5 1.42-5.22Z"
      />
      <path
        id="San_Marino_svg__path86"
        d="M765.07 377.68c-.77-2.39-4.46-4-4.85-6.92-.17-1.31 1.26-3.53 1.14-3.92-.63-2.08-4.1-4.76-2.32-7.34 2.29-3.34 5.55.11 8.26.9.45-.17.6-1.66 1.66-1.94 4.16-1.11 7.78 5.64 8.87 6.05 3.22 1.22 5.75-4.48 7.51 8 1.37-.32 3.25-.67 4.08.75 3.43 5.88 1.43 18.54 8.28 21.94l.22.45c-.09.49-.31 4.24-1.32 3-1.73-2.1-3.09-5.09-6.11-5.62-3.18-.56-17.08 4.47-17.45-1.84 0-.75 1-1.77.63-2.49-.79-1.74-9.14-1.13-10-5.8-.34-1.83.94-3.5 1.42-5.22Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path88"
        d="M796.86 397.88c-5.11-7.93-7.4-4.94-15.16-4.36-1.77.13-7.74.38-7.63-2.61 0-.85.67-1.07.14-2.09-1.12-2.2-8.12-1.8-9.17-5.86-.55-2.1.61-4.94.31-5.73-1-2.64-5.31-5.11-4-8.56a8 8 0 0 0 .51-1.38c.26-1.53-2.86-5-1.48-7.27 1.62-2.62 4.43-.55 6.58.42 1.53.69 1.15-.66 2.16-1 1.77-.59 4 1.11 5.16 2.24a42 42 0 0 0 3.31 3.4c1.25.58 3.38-.08 4.83.43s2.19 5.93 2.38 7.33l.25.17c1.19-.25 2.94-.24 3.66.91 3.24 5.29 1.64 17.91 8.6 21.74l-.43 2.22Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path90"
        d="M796.86 397.88c-5.11-7.93-7.4-4.94-15.16-4.36-1.77.13-7.74.38-7.63-2.61 0-.85.67-1.07.14-2.09-1.12-2.2-8.12-1.8-9.17-5.86-.55-2.1.61-4.94.31-5.73-1-2.64-5.31-5.11-4-8.56a8 8 0 0 0 .51-1.38c.26-1.53-2.86-5-1.48-7.27 1.62-2.62 4.43-.55 6.58.42 1.53.69 1.15-.66 2.16-1 1.77-.59 4 1.11 5.16 2.24a42 42 0 0 0 3.31 3.4c1.25.58 3.38-.08 4.83.43s2.19 5.93 2.38 7.33l.25.17c1.19-.25 2.94-.24 3.66.91 3.24 5.29 1.64 17.91 8.6 21.74l-.43 2.22Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path92"
        d="M796.46 397.51s-9.23-15.26-17.2-23.25c-5.08-5.09-14.2-11.78-14.2-11.78s9.2 7 14.2 12.36c7.27 7.82 15.33 22.67 15.33 22.67Z"
      />
      <path
        id="San_Marino_svg__path94"
        d="M796.46 397.51s-9.23-15.26-17.2-23.25c-5.08-5.09-14.2-11.78-14.2-11.78s9.2 7 14.2 12.36c7.27 7.82 15.33 22.67 15.33 22.67Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path96"
        d="M786.59 421c.41.19 1.29 0 1.84.19 4.07 1.11-1.75 12.9-2.08 15.49a30 30 0 0 0 .31 3.07l-.89 5c-.15.52.1-5-.7-6.37-1.42-2.44-5.89-1.12-8.19-1.48-3.79-.58-.83-3.83-2.48-4.49-2.72-1.09-8.4.47-9.08-3.58-.25-1.52.75-3.14.65-4.43-2-2.26-7-2.76-6.39-6.73.2-1.38 2.21-2.84 2.15-3.73-.07-1.08-4.2-4.11-3.22-6.32.61-1.35 1.78-1.35 1.89-2.14s-3.36-6-.44-7.43c3.5-1.68 6.39 2.26 8.91 2.45 1.28.09 2.4-2 4.33-1.57s2.27 3.19 3.19 4.7c.9 0 1.79-.93 2.79-1 4.26-.45 3.6 6.38 4.7 8.74.14.28 1.42-.49 2-.29a2.6 2.6 0 0 1 1.35 2.21c.37 2.56-1 5.3-.59 7.72Z"
      />
      <path
        id="San_Marino_svg__path98"
        d="M786.59 421c.41.19 1.29 0 1.84.19 4.07 1.11-1.75 12.9-2.08 15.49a30 30 0 0 0 .31 3.07l-.89 5c-.15.52.1-5-.7-6.37-1.42-2.44-5.89-1.12-8.19-1.48-3.79-.58-.83-3.83-2.48-4.49-2.72-1.09-8.4.47-9.08-3.58-.25-1.52.75-3.14.65-4.43-2-2.26-7-2.76-6.39-6.73.2-1.38 2.21-2.84 2.15-3.73-.07-1.08-4.2-4.11-3.22-6.32.61-1.35 1.78-1.35 1.89-2.14s-3.36-6-.44-7.43c3.5-1.68 6.39 2.26 8.91 2.45 1.28.09 2.4-2 4.33-1.57s2.27 3.19 3.19 4.7c.9 0 1.79-.93 2.79-1 4.26-.45 3.6 6.38 4.7 8.74.14.28 1.42-.49 2-.29a2.6 2.6 0 0 1 1.35 2.21c.37 2.56-1 5.3-.59 7.72Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path100"
        d="M813.62 431.25c.8 8.06-10.12.13-16.13 3.33-1.79.95-6 4.16-5.67 3.39l1.51-3.81c.5-.42 2.11-.43 2.67-.68 1.3-.6 3.09-2.66 4.28-4.89 1.65-3.1.53-6.61 1.53-8.88 1.54-3.48 4-.28 5-1 1.92-1.39 2.25-8.43 6.94-8.5 1.24 0 1.22.22 2.07.63 1-1.43 1.29-3.18 3.19-3.77 1.37-.43 2.31.79 3.58.78.9-.71 4.42-6.61 7.31-5.92 3.24.78 1.29 6.55 1 8.67.36.39.81.38 1.38 1.14 2.23 3-1.27 6.18-2.47 8.53.32.71 1.22.67 1.42 1.56.8 3.65-6.14 4.1-6.85 5.08 0 .33.54.72.47 1.49-.35 4.47-10.7 3.27-11.26 2.89Z"
      />
      <path
        id="San_Marino_svg__path102"
        d="M813.62 431.25c.8 8.06-10.12.13-16.13 3.33-1.79.95-6 4.16-5.67 3.39l1.51-3.81c.5-.42 2.11-.43 2.67-.68 1.3-.6 3.09-2.66 4.28-4.89 1.65-3.1.53-6.61 1.53-8.88 1.54-3.48 4-.28 5-1 1.92-1.39 2.25-8.43 6.94-8.5 1.24 0 1.22.22 2.07.63 1-1.43 1.29-3.18 3.19-3.77 1.37-.43 2.31.79 3.58.78.9-.71 4.42-6.61 7.31-5.92 3.24.78 1.29 6.55 1 8.67.36.39.81.38 1.38 1.14 2.23 3-1.27 6.18-2.47 8.53.32.71 1.22.67 1.42 1.56.8 3.65-6.14 4.1-6.85 5.08 0 .33.54.72.47 1.49-.35 4.47-10.7 3.27-11.26 2.89Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path104"
        d="M743.51 457.82c.2-1.53-3-3.84-1.65-5.94 1.09-1.7 3.57-.82 4.57-1.7.86-2.7-.57-6.34 3.18-7.18 1.91-.43 3 1.5 3.57 3 .24.55 1.08 3.92 1.41 4 .7.26 2.57-1.08 3.5-.94 2.54.36.54 5.12 1.31 6.46.54 1 1.9.2 2.76.5 2.57.88.57 5.15.57 7 0 1.12 1.85 1.46 2 3.35.26 3.4-2.61 3.77-4.24 6-.23.31-.28.46 0 .77 2.81 3.43 1.22 5.1-1.89 7.36-3.67 2.66-9.31 4.36-7.24 10.05 0 0-1.85 3.8-2.05 2.53-.3-1.86.61-3.76.09-5.78s-7.15-5-7.42-7.33c-.18-1.64 1.72-1.89 1.87-3.37.17-1.68-5.73-3.23-5-6.56.38-1.8 2.3-2.33 3.14-3.79-.14-1.41-6.72-6.44-.94-7.75a7.3 7.3 0 0 0 2.51-.61Z"
      />
      <path
        id="San_Marino_svg__path106"
        d="M749.28 492.85c.09-.87.38-2.67.92-2.92s.81.29 1.06.73c-.16.32-.53 1-.9 1.63l-1 .9a.6.6 0 0 1-.05-.18Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path108"
        d="M743.51 457.82c.2-1.53-3-3.84-1.65-5.94 1.09-1.7 3.57-.82 4.57-1.7.86-2.7-.57-6.34 3.18-7.18 1.91-.43 3 1.5 3.57 3 .24.55 1.08 3.92 1.41 4 .7.26 2.57-1.08 3.5-.94 2.54.36.54 5.12 1.31 6.46.54 1 1.9.2 2.76.5 2.57.88.57 5.15.57 7 0 1.12 1.85 1.46 2 3.35.26 3.4-2.61 3.77-4.24 6-.23.31-.28.46 0 .77 2.81 3.43 1.22 5.1-1.89 7.36-3.67 2.66-9.31 4.36-7.24 10.05 0 0-1.85 3.8-2.05 2.53-.3-1.86.61-3.76.09-5.78s-7.15-5-7.42-7.33c-.18-1.64 1.72-1.89 1.87-3.37.17-1.68-5.73-3.23-5-6.56.38-1.8 2.3-2.33 3.14-3.79-.14-1.41-6.72-6.44-.94-7.75a7.3 7.3 0 0 0 2.51-.61Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path110"
        d="M749.06 492.57a15.7 15.7 0 0 0 0-5.47c-.61-2.32-5.74-5.25-6-7.27-.15-1.28.83-1.62 1-3.23.27-2.16-5.06-3.55-4.43-6.53.39-1.82 2.67-2.69 2.45-4.31-.12-.91-2.82-3.14-2.24-5.46.47-1.87 2.5-1.12 3.68-2.07s-2.54-4.18-1.32-6.07c1-1.5 3.62-.84 4.37-1.91s-.62-5.69 3.07-6.54c2.92-.68 3.52 5.59 4.76 6.5s1.7-.68 3.53-.44.42 4.66 1.13 6 2 .3 3.25.75c2 .72 0 5 0 6.48s1.64 1.55 1.79 3.39c.24 3-2.61 3.75-4.11 5.59a1 1 0 0 0 0 1.47c2.7 2.92.79 4.67-1.84 6.57-4.08 2.95-8.89 4.59-6.83 10.54l-2.39 2Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path112"
        d="M749.34 492.33c.14-.92.42-2.2.86-2.4s.83.32 1.08.76Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path114"
        d="M749.06 492.57a15.7 15.7 0 0 0 0-5.47c-.61-2.32-5.74-5.25-6-7.27-.15-1.28.83-1.62 1-3.23.27-2.16-5.06-3.55-4.43-6.53.39-1.82 2.67-2.69 2.45-4.31-.12-.91-2.82-3.14-2.24-5.46.47-1.87 2.5-1.12 3.68-2.07s-2.54-4.18-1.32-6.07c1-1.5 3.62-.84 4.37-1.91s-.62-5.69 3.07-6.54c2.92-.68 3.52 5.59 4.76 6.5s1.7-.68 3.53-.44.42 4.66 1.13 6 2 .3 3.25.75c2 .72 0 5 0 6.48s1.64 1.55 1.79 3.39c.24 3-2.61 3.75-4.11 5.59a1 1 0 0 0 0 1.47c2.7 2.92.79 4.67-1.84 6.57-4.08 2.95-8.89 4.59-6.83 10.54l-2.39 2Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path116"
        d="M814.84 444.74c2-.52 4.83-2.51 6.79-.94 3.72 3-2.76 8.19-4 11 0 1 2.07 1.36 1.94 3.41-.24 3.6-5 2.83-7.29 4.12-.18.65.82 1.21.82 1.85 0 5.09-7.69 3.17-10.62 4.12-.93.3.64 3-2.7 4.26-1.44.54-3.5 0-5-.28a23.2 23.2 0 0 0-5.38-.58 17 17 0 0 1-2.26.17c-.32 0-.55-.18-.43-.55l8.41-24.79c.18-.53 3.83.85 4.64.85s1.8-1.9 2.43-2.48c2.19-2 3.25.85 5.08.86 1.34 0 5.09-7.46 7.49-1Z"
      />
      <path
        id="San_Marino_svg__path118"
        d="M814.84 444.74c2-.52 4.83-2.51 6.79-.94 3.72 3-2.76 8.19-4 11 0 1 2.07 1.36 1.94 3.41-.24 3.6-5 2.83-7.29 4.12-.18.65.82 1.21.82 1.85 0 5.09-7.69 3.17-10.62 4.12-.93.3.64 3-2.7 4.26-1.44.54-3.5 0-5-.28a23.2 23.2 0 0 0-5.38-.58 17 17 0 0 1-2.26.17c-.32 0-.55-.18-.43-.55l8.41-24.79c.18-.53 3.83.85 4.64.85s1.8-1.9 2.43-2.48c2.19-2 3.25.85 5.08.86 1.34 0 5.09-7.46 7.49-1Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path120"
        d="M773.18 448.78c-.07-1-2.17 2.14-2.17 2.14s1.49 1.48 2.51 2.35c1.26 1.09 3.37 2.61 3.37 2.61l.2-1.57s-3.72-2.6-3.91-5.53"
      />
      <path
        id="San_Marino_svg__path122"
        d="M773.18 448.78c-.07-1-2.17 2.14-2.17 2.14s1.49 1.48 2.51 2.35c1.26 1.09 3.37 2.61 3.37 2.61l.2-1.57s-3.72-2.6-3.91-5.53"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path124"
        d="M770.94 438.67a2.74 2.74 0 0 1-.18 2.72 11 11 0 0 1-1.26 2.2c-1.92 2.54-6.17 4.81-8.1 3.49-1.75-1.2-5.33-11.71-2.53-13.52s9.58 1.58 12.07 5.11"
      />
      <path
        id="San_Marino_svg__path126"
        d="M770.94 438.67a2.74 2.74 0 0 1-.18 2.72 11 11 0 0 1-1.26 2.2c-1.92 2.54-6.17 4.81-8.1 3.49-1.75-1.2-5.33-11.71-2.53-13.52s9.58 1.58 12.07 5.11"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path128"
        d="M760.83 443.36a13.5 13.5 0 0 1 3.23-3.12c1.68-1.29 6-3.57 7.87-1.74 2.48 2.4 3.68 9.66.79 12.17-3.8 3.33-10-.5-12.35-3.79-.83-1.13-.23-2.49.46-3.52"
      />
      <path
        id="San_Marino_svg__path130"
        d="M760.83 443.36a13.5 13.5 0 0 1 3.23-3.12c1.68-1.29 6-3.57 7.87-1.74 2.48 2.4 3.68 9.66.79 12.17-3.8 3.33-10-.5-12.35-3.79-.83-1.13-.23-2.49.46-3.52"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path132"
        d="M764.46 440.9c2.6-1.93 5.55-3 6.66-1.83 3 3.16 3.15 9.21 1.07 11s-7 1.63-11.17-3.68c-.89-1.14.81-3.54 3.44-5.49"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path134"
        d="M764.46 440.9c2.6-1.93 5.55-3 6.66-1.83 3 3.16 3.15 9.21 1.07 11s-7 1.63-11.17-3.68c-.89-1.14.81-3.54 3.44-5.49"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path136"
        d="M770.27 438.32c1.4 2.59-6.26 9.79-8.81 8.08-1.77-1.18-4.19-10.24-2.45-11.81 2.45-2.22 10 1.49 11.26 3.73"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path138"
        d="M764.17 437.27c-2.41-1.08-4.77-1.53-5.46-2.25a1.3 1.3 0 0 1 .3-.43 3.2 3.2 0 0 1 2.2-.68 14.7 14.7 0 0 1 7.48 2.82c1 .95 1.48 1.89 1.18 2.58-.56 1.26-2.58-.66-5.7-2.04"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path140"
        d="M770.27 438.32c1.4 2.59-6.26 9.79-8.81 8.08-1.77-1.18-4.19-10.24-2.45-11.81 2.45-2.22 10 1.49 11.26 3.73"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path142"
        d="M789.47 471.25c3.83-.18 7.49 1.52 9.81.68 3.44-1.24 1.34-3.92 3-4.07s10.05.46 10-3.71c0-.81-.68-1.12-.37-2s6.61-.61 6.84-4c.14-2.15-1.82-2.17-1.52-3.47s7.06-7.7 3.7-10.35c-2.32-1.82-6.12 1.36-6.48.43-.47-1.21-.57-2.22-2.11-2.37-2.23-.2-3.57 3.34-5 3.34s-2.12-1.46-3.61-1.32c-2 .17-2.24 3.15-3.9 3.15a16.6 16.6 0 0 1-4.26-.93l-8.4 24.8s1.41-.13 2.3-.18"
        className="San_Marino_svg__cls-10"
      />
      <path
        id="San_Marino_svg__path144"
        d="M789.47 471.25c3.83-.18 7.49 1.52 9.81.68 3.44-1.24 1.34-3.92 3-4.07s10.05.46 10-3.71c0-.81-.68-1.12-.37-2s6.61-.61 6.84-4c.14-2.15-1.82-2.17-1.52-3.47s7.06-7.7 3.7-10.35c-2.32-1.82-6.12 1.36-6.48.43-.47-1.21-.57-2.22-2.11-2.37-2.23-.2-3.57 3.34-5 3.34s-2.12-1.46-3.61-1.32c-2 .17-2.24 3.15-3.9 3.15a16.6 16.6 0 0 1-4.26-.93l-8.4 24.8s1.41-.13 2.3-.18"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path146"
        d="M793.58 461.48a107 107 0 0 0 12.53-5.69 110 110 0 0 0 10.67-7.63m-23.2 13.32a82 82 0 0 0 12.53-5.27 91 91 0 0 0 10.67-8"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path148"
        d="M743.12 500.72a29.6 29.6 0 0 1 4.38-.75 3.34 3.34 0 0 1 2 .6l1.42-2.61a50 50 0 0 1-5.51.39Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path150"
        d="M724.27 528.76c-2.48-3 5.75-10.88 8.82-8.65 2.19 1.59 4.95 8.42 2.76 10.46-2.44 2.27-9.61.6-11.58-1.81"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path152"
        d="m720.47 518.78-.91-.06c-1.61-2-2.19-2.08-4.54-2.72-.75-.21-.86-1 0-1.21l2.85-.75c.45-.12 1.66 1 2 1.21.54.41 3.31 1 2.3 2l-1.65 1.55Z"
      />
      <path
        id="San_Marino_svg__path154"
        d="m720.47 518.78-.91-.06c-1.61-2-2.19-2.08-4.54-2.72-.75-.21-.86-1 0-1.21l2.85-.75c.45-.12 1.66 1 2 1.21.54.41 3.31 1 2.3 2l-1.65 1.55Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path156"
        d="M719.85 517c1.16-1.75 8.39-2.17 12.6 1.54 2.59 2.29.5 5.51-2 7.59s-6.12 3.76-7.63 2.44c-4.24-3.75-4.37-9.47-2.97-11.57"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path158"
        d="m462.87 487.4.11-.35a183 183 0 0 0 20.72-4.34c15.35-3.89 22.54-.73 35 7.78a13.6 13.6 0 0 0 2.59 1.61c2 .76 3.31.23 5.26.23h.18l2.91 2.28c.23.17.09.32-.12.37a33 33 0 0 1-8.66.27c-4-.36-12.27 9.14-24 9.14-14.89 0-24.67-6.59-33.95-17Z"
      />
      <path
        id="San_Marino_svg__path160"
        d="m462.87 487.4.11-.35a183 183 0 0 0 20.72-4.34c15.35-3.89 22.54-.73 35 7.78a13.6 13.6 0 0 0 2.59 1.61c2 .76 3.31.23 5.26.23h.18l2.91 2.28c.23.17.09.32-.12.37a33 33 0 0 1-8.66.27c-4-.36-12.27 9.14-24 9.14-14.89 0-24.67-6.59-33.95-17Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path162"
        d="M528.34 494.43a58 58 0 0 0-7.09.47c-6.85 1.16-13.63 8.61-24 8.91-13.85.4-22.6-6.12-32.07-15.43 13.78-2.08 24.43-10 38.64-5.56 7.29 2.29 15.86 11.47 22.7 10.16l1.86 1.45Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path164"
        d="M528.34 494.43a58 58 0 0 0-7.09.47c-6.85 1.16-13.63 8.61-24 8.91-13.85.4-22.6-6.12-32.07-15.43 13.78-2.08 24.43-10 38.64-5.56 7.29 2.29 15.86 11.47 22.7 10.16l1.86 1.45Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path166"
        d="M519.77 492.61s-12.15 2-19.72 2c-12.23 0-30.94-5.07-30.94-5.07s18.66 5.64 30.94 5.89c7.55.15 19.72-1.6 19.72-1.6v-1.24Z"
      />
      <path
        id="San_Marino_svg__path168"
        d="M519.77 492.61s-12.15 2-19.72 2c-12.23 0-30.94-5.07-30.94-5.07s18.66 5.64 30.94 5.89c7.55.15 19.72-1.6 19.72-1.6v-1.24Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path170"
        d="M486.75 345.77a.41.41 0 1 1-.78-.27 2.27 2.27 0 0 0-.22-1.42 15 15 0 0 0-1-1.89c-.41-.71-.85-1.44-1.2-2.21a7.4 7.4 0 0 1-.68-2.49 2.53 2.53 0 0 1 .56-2.06.66.66 0 0 1 1 .26 3.2 3.2 0 0 1 .36 1.26 9.15 9.15 0 0 0 1.49 3.49 6.7 6.7 0 0 0 1 1.24 1.3 1.3 0 0 0 .37.27.1.1 0 0 0 .07 0l.49.56Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path172"
        d="M557.38 514c-.07-2.53.44-1.59 3.17-.47.58.23.15.8-.35 1.11-1.63 1-3.07 3.18-3.76 2.7-1.88-1.32-.7-1.36.94-3.34"
      />
      <path
        id="San_Marino_svg__path174"
        d="M557.38 514c-.07-2.53.44-1.59 3.17-.47.58.23.15.8-.35 1.11-1.63 1-3.07 3.18-3.76 2.7-1.88-1.32-.7-1.36.94-3.34"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path176"
        d="M492.13 335.18c-8 20.43-10.75 56.62-8 73.05 8.55 50.52 50.15 97.88 88.24 105.53 33.13 6.66 53.32 21.5 66.51 37.33 8.62 10.35 13.22 15 25.59 35.65 4.53 7.53-3.21 9-6.4 2.81-8.71-17-13.4-24.6-25.4-38-12.89-14.37-31.84-27.28-62.78-33.45-36.89-7.37-80.11-54.81-88.66-105.33-2.78-16.43-.34-55.67 8.09-76.41l2.78-1.19Z"
      />
      <path
        id="San_Marino_svg__path178"
        d="M492.13 335.18c-8 20.43-10.75 56.62-8 73.05 8.55 50.52 50.15 97.88 88.24 105.53 33.13 6.66 53.32 21.5 66.51 37.33 8.62 10.35 13.22 15 25.59 35.65 4.53 7.53-3.21 9-6.4 2.81-8.71-17-13.4-24.6-25.4-38-12.89-14.37-31.84-27.28-62.78-33.45-36.89-7.37-80.11-54.81-88.66-105.33-2.78-16.43-.34-55.67 8.09-76.41l2.78-1.19"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path180"
        d="M547 511.8c-5.74.63-9.62 9-15.38 14.21-10.6 9.65-27.59 10.61-38.42 4.17-.46-.28-.69-.88-.17-1 13.47-3.06 15.22-21.43 43.3-19.63 3.29.22 4.68.89 8 .89Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path182"
        d="m525.68 426.33.19.1c.14 8.21 6.36 19.4 7.89 28.44 1.32 7.77-.58 14.27-3.56 21.52-.75 1.81-2.49 5.44-2.56 7.21s1 3.19 1.85 4.56c.31.48 2.17 2.92 2 3.4-7.44-6.44-3.06-2.24-6.15-8.18-1.6-3.07-3.5-5.85-5.09-8.93-8.38-16.29-8.53-34.77 5.43-48.12"
      />
      <path
        id="San_Marino_svg__path184"
        d="m525.68 426.33.19.1c.14 8.21 6.36 19.4 7.89 28.44 1.32 7.77-.58 14.27-3.56 21.52-.75 1.81-2.49 5.44-2.56 7.21s1 3.19 1.85 4.56c.31.48 2.17 2.92 2 3.4-7.44-6.44-3.06-2.24-6.15-8.18-1.6-3.07-3.5-5.85-5.09-8.93-8.38-16.29-8.53-34.77 5.43-48.12"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path186"
        d="M579.38 515.32c-3.66-1.18-7.38-2.64-9.38-6.38-3.37-6.27-2.65-11.35-6.11-17.84-6.55-12.33-19.17-13.65-25.53-25.08-1.3 10.52-2.71 26.22 13.66 37.45 5.76 3.95 14.55 4.86 16.66 6.45a14.1 14.1 0 0 1 3.4 3.86z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path188"
        d="M572.29 513.4a28.3 28.3 0 0 0-4-3.6c-3.34-2.42-10.57-2.64-16-6.65-7.63-5.59-11.58-10.79-13.7-20-1.28-5.58-.29-10.05 0-14.7 6.87 10 18.8 10.92 25.19 22.85 3.88 7.25 3.36 18.28 11.31 22.69l-2.76-.58Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path190"
        d="M572.29 513.4a28.3 28.3 0 0 0-4-3.6c-3.34-2.42-10.57-2.64-16-6.65-7.63-5.59-11.58-10.79-13.7-20-1.28-5.58-.29-10.05 0-14.7 6.87 10 18.8 10.92 25.19 22.85 3.88 7.25 3.36 18.28 11.31 22.69l-2.76-.58Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path192"
        d="M507.07 458.52a8.6 8.6 0 0 0-1.1 2.38c-.28.81 1.52 3.28 1.37 2.43a5.08 5.08 0 0 1 .66-3.57Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path194"
        d="M509.85 472.36a37.3 37.3 0 0 1-6.32-1.91c-3.37-1.69-10.82-11.47-19.44-16.36-12.36-7-23.12-5.55-35.27-9.11 3.45 13 10 20.73 22.29 26.23 11 4.92 28.87.67 30.81.83s8.09 2.74 8.09 2.74z"
        className="San_Marino_svg__cls-11"
      />
      <path
        id="San_Marino_svg__path196"
        d="M527.24 487.22c-.54-3.86-4.93-9.41-6.76-13a48.4 48.4 0 0 1-5.31-16.92c-1.3-12.73 1.62-19.59 10-29a17.7 17.7 0 0 0 1.27 6.3c3.51 10.8 8.41 19.72 6.82 31.46-.78 5.78-5.5 14-5.72 17.53-.11 1.83.93 4 1.84 5.52l-2.13-1.87Z"
        className="San_Marino_svg__cls-10"
      />
      <path
        id="San_Marino_svg__path198"
        d="M527.24 487.22c-.54-3.86-4.93-9.41-6.76-13a48.4 48.4 0 0 1-5.31-16.92c-1.3-12.73 1.62-19.59 10-29a17.7 17.7 0 0 0 1.27 6.3c3.51 10.8 8.41 19.72 6.82 31.46-.78 5.78-5.5 14-5.72 17.53-.11 1.83.93 4 1.84 5.52l-2.13-1.87Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path200"
        d="M495.82 452.81c-9-14.94-30.07-8.24-43.88-20.78-6.7-6.09-9.69-15.25-11-24-.4-2.59-1.51-12.88-.91-14.88a.44.44 0 0 1 .78-.18c4.58 4.48 9.17 7.37 14.47 11 12.59 8.52 17.76 16.52 24.25 29.81 8.5 17.41 16.2 7.49 16.32 19Z"
      />
      <path
        id="San_Marino_svg__path202"
        d="M495.82 452.81c-9-14.94-30.07-8.24-43.88-20.78-6.7-6.09-9.69-15.25-11-24-.4-2.59-1.51-12.88-.91-14.88a.44.44 0 0 1 .78-.18c4.58 4.48 9.17 7.37 14.47 11 12.59 8.52 17.76 16.52 24.25 29.81 8.5 17.41 16.2 7.49 16.32 19Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path204"
        d="M523.84 432.78s-2.85 15-2.42 24.56c.45 9.82 4.8 24.74 4.8 24.74h-.83s-4.51-14.91-4.79-24.74c-.28-9.66 3.24-24.56 3.24-24.56"
      />
      <path
        id="San_Marino_svg__path206"
        d="M523.84 432.78s-2.85 15-2.42 24.56c.45 9.82 4.8 24.74 4.8 24.74h-.83s-4.51-14.91-4.79-24.74c-.28-9.66 3.24-24.56 3.24-24.56"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path208"
        d="M494.2 450.38c-6.19-7.24-16.4-8.15-27.95-10.93-5.52-1.33-10-4.35-14.24-8.14-6.54-5.9-8.7-13.8-10-22.28a64.6 64.6 0 0 1-.59-14.17 7.6 7.6 0 0 0 2.07 2.47c4.28 3.07 8.75 5.22 13.05 8.32 3.75 2.71 6.42 4.5 9.49 8a71.9 71.9 0 0 1 9.88 14.32c2.16 4.09 4 8.88 6.8 12.59 1.44 1.93 7.28 4.44 9.4 4.71l2.06 5.14Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path210"
        d="m483.4 441.22-.54 1.44.08.8c4.21 1.38 7.88 3.25 10.76 6.35l.38.25-1.94-4.82a23.4 23.4 0 0 1-8.74-4.02"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path212"
        d="M494.2 450.38c-6.19-7.24-16.4-8.15-27.95-10.93-5.52-1.33-10-4.35-14.24-8.14-6.54-5.9-8.7-13.8-10-22.28a64.6 64.6 0 0 1-.59-14.17 7.6 7.6 0 0 0 2.07 2.47c4.28 3.07 8.75 5.22 13.05 8.32 3.75 2.71 6.42 4.5 9.49 8a71.9 71.9 0 0 1 9.88 14.32c2.16 4.09 4 8.88 6.8 12.59 1.44 1.93 7.28 4.44 9.4 4.71l2.06 5.14Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path214"
        d="M469.19 395.79a5.9 5.9 0 1 1-5.89 5.89 5.89 5.89 0 0 1 5.89-5.89"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path216"
        d="M469.39 398.84a5.85 5.85 0 0 1 .77-3 5.89 5.89 0 0 1 4.92 5.81 6 6 0 0 1 0 .72 2.94 2.94 0 0 1-2.23 1.14c-1.93.03-3.46-2.08-3.46-4.67"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path218"
        d="M469.19 395.79a5.9 5.9 0 1 1-5.89 5.89 5.89 5.89 0 0 1 5.89-5.89"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path220"
        d="M486.6 399.07s2.75-10.24 5.34-16.58c6.12-15 16.75-15.57 22.16-27.45 3.1 8 5.57 18.34.16 29.9C508 398.31 492 406.15 492 406.15l-5.42-7.08Z"
      />
      <path
        id="San_Marino_svg__path222"
        d="M486.6 399.07s2.75-10.24 5.34-16.58c6.12-15 16.75-15.57 22.16-27.45 3.1 8 5.57 18.34.16 29.9C508 398.31 492 406.15 492 406.15l-5.42-7.08Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path224"
        d="M514.05 357.74c8 21.78-2.56 37.47-21.91 48.29l-5.09-7c3.32-14 5.71-20.88 16.4-30.82 4.23-3.93 7.93-5.21 10.6-10.42Z"
        className="San_Marino_svg__cls-10"
      />
      <path
        id="San_Marino_svg__path226"
        d="M514.05 357.74c8 21.78-2.56 37.47-21.91 48.29l-5.09-7c3.32-14 5.71-20.88 16.4-30.82 4.23-3.93 7.93-5.21 10.6-10.42Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path228"
        d="M491.54 336.15c-8 20.94-10.33 56-7.58 72.15 8.57 50.64 50.06 98.17 88.36 105.87 33 6.63 52.77 21.51 66.37 36.88a166.6 166.6 0 0 1 15.69 20.8c3.63 5.68 6.74 11.88 9.79 16.78.49.79-3.63 2.5-4.06 1.8-3.23-5.22-6.2-11.8-9.91-17.82-4.23-6.86-11.5-13.87-17.82-21.33-13.44-15.87-31.35-27.8-62.38-34-36.69-7.33-79.39-54.19-87.91-104.58-2.77-16.37-.73-54.36 6.56-74.42l2.89-2.14Z"
        className="San_Marino_svg__cls-6"
      />
      <path
        id="San_Marino_svg__path230"
        d="M487.54 435.22c-1.64-1.57-4-3.08-5.59-4.72-14.71-15.27-10.85-41.94 5.28-55 .55-.45 1-.24 1 .41a68.7 68.7 0 0 0 3.64 16.35c4.92 13.52 5.72 21.28 1.25 32.79a18.57 18.57 0 0 0 0 13.2l-5.64-3.07Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path232"
        d="M539.42 501c-9.41-3.22-19.14-2.36-27-10.48-9-9.37-11-23.87-8.63-32.24.11-.41.43-.74.68-.42 2 2.45 3.07 4.22 5.71 6.16 9.43 7 21 10.44 25 21.07.8 2.11 1.06 4.33 1.81 6.46 2.54 7.3 6.72 9.5 12.77 13.49l-10.38-4Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path234"
        d="M546.77 504.84c-8.8-7.47-24.67-4.79-34.12-14.92-6.94-7.43-9.87-19.16-8.15-29.33 8.39 7.47 18.14 9.52 25.77 17.91 9 9.88 1.33 16.51 18.23 26.12z"
        className="San_Marino_svg__cls-11"
      />
      <path
        id="San_Marino_svg__path236"
        d="M499.74 451.25v-.23c2.19-2.61.67-10.44 0-13.57a38.2 38.2 0 0 1-.49-15.57c1-6.37 4.52-12.11 8.1-17.38 1.59-2.34 6.76-9.68 7.3-12.34 0-.22.28-.21.38 0 2 4.3 3 9.54 3.8 14.18 1.11 6.51 1.46 12.43-.8 19.83a36.3 36.3 0 0 1-8.9 15.37c-1.77 1.88-5.91 6-6.52 8.28a21.2 21.2 0 0 0-.65 5.58l-2.2-4.16Z"
      />
      <path
        id="San_Marino_svg__path238"
        d="M499.74 451.25v-.23c2.19-2.61.67-10.44 0-13.57a38.2 38.2 0 0 1-.49-15.57c1-6.37 4.52-12.11 8.1-17.38 1.59-2.34 6.76-9.68 7.3-12.34 0-.22.28-.21.38 0 2 4.3 3 9.54 3.8 14.18 1.11 6.51 1.46 12.43-.8 19.83a36.3 36.3 0 0 1-8.9 15.37c-1.77 1.88-5.91 6-6.52 8.28a21.2 21.2 0 0 0-.65 5.58l-2.2-4.16Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path240"
        d="M485.17 365.61s.28 0 1.46-.75a8.3 8.3 0 0 0 3.21-3.85c.61-1.69 4.86-15.82 10.54-24.57 6.63-10.21 13.52-14.8 21.88-22.3 1.31 8.1 1.5 21.3-5.34 31.89-6.27 9.69-22.17 16.6-24 17.32s-5 1.25-6.81 3.66a14.6 14.6 0 0 0-1.74 4l.81-5.41Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path242"
        d="M483.17 367s-.69 0-1.58-1.29a9.5 9.5 0 0 1-1.78-5.2c0-4.23 4-16.87 2-26.44-3.79-18.26-9.53-25.59-10.41-32.36-.35-2.71-15.27 18.44-10.73 38.08 2.24 9.73 13.55 20.6 15.14 22s3.75 3.28 4.79 6.14a17.6 17.6 0 0 1 .84 6.29l1.72-7.25Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path244"
        d="M491.92 335.54c1.08-2.61 2.85-5.71 4.49-7.08 4-3.37 15.33-11.76 19.19-17.88 8.59-13.61 6.85-30.39 5.95-33.31-7.44 6.48-14.24 10.75-21.83 21.47-6.63 9.36-8.08 27.66-8.59 31.13a39.7 39.7 0 0 1-2.24 7.87l3-2.2Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path246"
        d="M462.89 401.68a6.3 6.3 0 1 1 6.3 6.3 6.3 6.3 0 0 1-6.3-6.3"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path248"
        d="M790.89 439.49s3.49-3.63 6.31-5.05c5.46-2.75 14.33 1.68 15.65-.81.67-1.27-.35-2.2.5-2.53s10.53 1.58 10.91-2.8c.08-.79-1-1.19-.17-2s7-1.25 6.35-4.14c-.2-.93-1.53-1.19-1.19-2.11s4.92-5.28 3-7.95c-.57-.78-2-.63-1.9-1.58.34-3 1.33-7.54-1.11-7.77-2.63-.26-5.7 5.08-6.72 5.29-1.28.25-2-1-3.3-.59-2.11.67-2.45 3.8-3.3 3.8s-.78-.88-2.14-.85c-4.14.09-4.49 6.74-6.57 8.38-1.18.93-1.88-.33-3-.08-2.87.58-2 7.77-3.54 10.05a23.4 23.4 0 0 1-5.5 5.33 5.9 5.9 0 0 1-2 .34l-2.19 5.1Z"
        className="San_Marino_svg__cls-11"
      />
      <path
        id="San_Marino_svg__path250"
        d="m485.25 368.57.29-2.63a9.07 9.07 0 0 0 4.69-4.79c3.56-8.52 5.73-17.17 10.73-25 6.49-10.21 13.44-14.18 20.46-19.79.33 9 1.92 18.53-5.27 30.35-4.08 6.72-16 13.37-23.39 16.29-3.31 1.31-5.68 2.37-7.51 5.61Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path252"
        d="m485.25 368.57.29-2.63a9.07 9.07 0 0 0 4.69-4.79c3.56-8.52 5.73-17.17 10.73-25 6.49-10.21 13.44-14.18 20.46-19.79.33 9 1.92 18.53-5.27 30.35-4.08 6.72-16 13.37-23.39 16.29-3.31 1.31-5.68 2.37-7.51 5.61Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path254"
        d="M497.74 530.14a124 124 0 0 0 15.07-4.73c7.21-3.09 10.12-7.09 17.33-10.18a125 125 0 0 1 15.49-4.83m-47.89 19.74a148 148 0 0 0 15.07-5.36c7.14-3.23 10.06-7.24 17.33-10.17 5.8-2.34 15.49-4.21 15.49-4.21"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path256"
        d="M454.72 350.58c11.35 9.45 14.59 13.88 17.93 28.5.39 1.72 2.57 9.12 3 10 1.09 2.18 3.35 3.21 4.75 5 .15.19.53 4.05.58 4.55 0 .31-.2.3-.37.14-1.77-1.61-2.7-4.14-4.76-5.65-1.77-1.3-7.76-2.58-10.34-3.65a35.06 35.06 0 0 1-15.8-13.78c-5.05-7.87-5.62-18.6-4.41-27.62a31.4 31.4 0 0 1 1.3-6.53c.1-.27.26-.21.4 0a33.8 33.8 0 0 0 7.69 9Z"
      />
      <path
        id="San_Marino_svg__path258"
        d="M454.72 350.58c11.35 9.45 14.59 13.88 17.93 28.5.39 1.72 2.57 9.12 3 10 1.09 2.18 3.35 3.21 4.75 5 .15.19.53 4.05.58 4.55 0 .31-.2.3-.37.14-1.77-1.61-2.7-4.14-4.76-5.65-1.77-1.3-7.76-2.58-10.34-3.65a35.06 35.06 0 0 1-15.8-13.78c-5.05-7.87-5.62-18.6-4.41-27.62a31.4 31.4 0 0 1 1.3-6.53c.1-.27.26-.21.4 0a33.8 33.8 0 0 0 7.69 9Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path260"
        d="m479.9 394.48.32 2.67c-5.39-7.29-7.2-5.13-14.65-8.22a34.6 34.6 0 0 1-15.52-13.55c-5.63-8.75-5.53-21.71-3.15-31.57 3 5.95 14.85 11.93 19.39 19.37 2.92 4.78 4.73 10.46 6.17 15.85.73 2.7 1.54 8.13 2.66 10.35.83 1.67 3.34 3.9 4.78 5.1"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path262"
        d="m479.9 394.48.32 2.67c-5.39-7.29-7.2-5.13-14.65-8.22a34.6 34.6 0 0 1-15.52-13.55c-5.63-8.75-5.53-21.71-3.15-31.57 3 5.95 14.85 11.93 19.39 19.37 2.92 4.78 4.73 10.46 6.17 15.85.73 2.7 1.54 8.13 2.66 10.35.83 1.67 3.34 3.9 4.78 5.1"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path264"
        d="M500.41 451.39c2-3.07.25-10.85-.39-14.37a43.9 43.9 0 0 1-.18-15.67c1.46-9 7.15-15 12.18-22.3a36 36 0 0 0 2.75-4.46c5.78 16.26 7.4 32.88-5.19 46.54-1.9 2.06-6.47 6-7.17 8.54a20.7 20.7 0 0 0-.61 4.15z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path266"
        d="M500.41 451.39c2-3.07.25-10.85-.39-14.37a43.9 43.9 0 0 1-.18-15.67c1.46-9 7.15-15 12.18-22.3a36 36 0 0 0 2.75-4.46c5.78 16.26 7.4 32.88-5.19 46.54-1.9 2.06-6.47 6-7.17 8.54a20.7 20.7 0 0 0-.61 4.15z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path268"
        d="M548.37 509.31s-.71 1.13-4.06 1.13-13.8-1.73-22.16.45c-12.61 3.3-17.82 15.1-27.3 19.29 14.4 6.2 24.94 4.68 36.93-4.91 5.08-4.07 8.22-12 15.22-13.47 3.2-.66 4.18-.56 6.26.25z"
        className="San_Marino_svg__cls-10"
      />
      <path
        id="San_Marino_svg__path270"
        d="m544.54 510.61.91 1.46 2.28-.46h.39a9.7 9.7 0 0 1 2.88-.18l1-.06-3.65-2a2.5 2.5 0 0 1-1.43.81l-.12.12Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path272"
        d="M548.37 509.31s-.71 1.13-4.06 1.13-13.8-1.73-22.16.45c-12.61 3.3-17.82 15.1-27.3 19.29 14.4 6.2 24.94 4.68 36.93-4.91 5.08-4.07 8.22-12 15.22-13.47 3.2-.66 4.18-.56 6.26.25m94 58a3.17 3.17 0 0 1 2.25-2.58 2.35 2.35 0 0 1 2.78.82"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path274"
        d="M713.58 515.35a13.6 13.6 0 0 0 7.38.81 2.07 2.07 0 0 1-1.5-.4c-.25-.18-2.05-1.78-2.05-1.78z"
        className="San_Marino_svg__cls-6"
      />
      <path
        id="San_Marino_svg__path276"
        d="M720.58 517.55c1.93-2.2 7.55-2 11.66 1.66 2 1.81.69 4.52-1.73 6.66s-5.56 3.36-6.61 2.44c-4.11-3.59-4.75-9.15-3.32-10.76"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path278"
        d="M720.58 517.55c1.93-2.2 7.55-2 11.66 1.66 2 1.81.69 4.52-1.73 6.66s-5.56 3.36-6.61 2.44c-4.11-3.59-4.75-9.15-3.32-10.76"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path280"
        d="M724.74 528.56c-.93-1 .55-4.28 2.51-6 1.74-1.56 4.56-2.63 5.18-2 2.39 2.58 4.85 7.16 3 9.43s-8.62.94-10.69-1.43"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path282"
        d="M732 521.37a2.8 2.8 0 0 1 1.23 0c2.11 2.64 3.9 6.53 2.19 8.56a4.48 4.48 0 0 1-3.43 1.19 6 6 0 0 1-2.51-3.91c-.6-2.82.53-5.44 2.52-5.86Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path284"
        d="M724.74 528.56c-.93-1 .55-4.28 2.51-6 1.74-1.56 4.56-2.63 5.18-2 2.39 2.58 4.85 7.16 3 9.43s-8.62.94-10.69-1.43"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path286"
        d="M560.59 513.86a15 15 0 0 0-1.47 1c-.77.69-1.79 1.2-2.1 1.77l-1.23-.12a17.6 17.6 0 0 0 2-2.25c.25-.31 0-1.48 0-1.48l2.79 1.12Z"
        className="San_Marino_svg__cls-6"
      />
      <path
        id="San_Marino_svg__path288"
        d="M490 336c2.26-6.41 2.21-13.54 3.48-20.2 2.67-14 6.65-18.59 16.79-28a121 121 0 0 1 10.05-7.8 45.5 45.5 0 0 1 .42 11.47c-2 19.83-10.44 24.51-24.59 36.63-2.75 2.35-3.46 5.64-6.15 7.89Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path290"
        d="M490.53 334.35c.37-.54.73-.85.92-.76s.17.38.08.82A10 10 0 0 1 490 336c.19-.53.37-1.09.53-1.65"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path292"
        d="M490 336c2.26-6.41 2.21-13.54 3.48-20.2 2.67-14 6.65-18.59 16.79-28a121 121 0 0 1 10.05-7.8 45.5 45.5 0 0 1 .42 11.47c-2 19.83-10.44 24.51-24.59 36.63-2.75 2.35-3.46 5.64-6.15 7.89Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path294"
        d="M490.88 336.75s.51-1.55 1.28-3.54.57.53.57.53l-.45 2.17Z"
      />
      <path
        id="San_Marino_svg__path296"
        d="m482.66 367.23-1 3.32c-.58-4.33-2.41-6.26-5.52-9.08-13.58-12.29-19.39-26.75-13.69-43.66a33.74 33.74 0 0 1 8.08-13.81 68 68 0 0 1 5.77 12.2c4.66 12.52 6.52 19.6 4.67 33.94-.65 5.07-3.08 11.24.28 15.74a4 4 0 0 0 1.41 1.32Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path298"
        d="m482.66 367.23-1 3.32c-.58-4.33-2.41-6.26-5.52-9.08-13.58-12.29-19.39-26.75-13.69-43.66a33.74 33.74 0 0 1 8.08-13.81 68 68 0 0 1 5.77 12.2c4.66 12.52 6.52 19.6 4.67 33.94-.65 5.07-3.08 11.24.28 15.74a4 4 0 0 0 1.41 1.32Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path300"
        d="M482.27 374.58a12.3 12.3 0 0 0-1.1-7.75 7.5 7.5 0 0 0 2 .75c.38-.06-.91 7-.91 7Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path302"
        d="M487.81 342.37c-.78.32-3.19-3.07-3.48-5.37s-1.17-1.27-1.07.46c.2 3.23 4.06 6.68 3.52 8.73a10.2 10.2 0 0 0 1-3.82Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path304"
        d="M487.81 342.37c-.78.32-3.19-3.07-3.48-5.37s-1.17-1.27-1.07.46c.2 3.23 3.64 6.1 3.11 8.14"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path306"
        d="M476 333.28a5.89 5.89 0 1 1 5.79 6 5.88 5.88 0 0 1-5.79-6"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path308"
        d="M482.19 332.71c-1.6-1.12-2.3-2.88-1.56-3.93s2.62-1 4.22.13 2.29 2.88 1.56 3.92-2.62 1-4.22-.12"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path310"
        d="M476 333.28a5.89 5.89 0 1 1 5.79 6 5.88 5.88 0 0 1-5.79-6"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path312"
        d="M794.55 342.54s.07-2.37 1.93-9a3.64 3.64 0 0 1 1.21-1.8l-3.48-.48a3 3 0 0 1 .87 1.95 11 11 0 0 1-1.71 5.53l1.18 3.83Z"
        className="San_Marino_svg__cls-6"
      />
      <path
        id="San_Marino_svg__path314"
        d="M790.69 335.41s-2.26-6.6-4.19-9-3.51-3.1-7.22-4.28c-3.28-1.05-8.41-1.9-8.63-4.47s.09-2.09-.85-2.33c-3-.8-6.78-1.79-6.06-4.78s1.83-3.45.54-4.07c-1.91-.92-6.92-3.84-6.32-6.39s2.83-2.59 1.89-4.16c-.68-1.12-3.09-2.35-2.9-4.4.13-1.39 1.9-1.84 1.84-3.08s-4.79-6.76-2-9.06c2.54-2.1 7 1.65 8.17 2.12s2.47-1.95 4.16-1.55c2.16.51 2.27 3.75 2.91 4.89 1.16 2.09 3.55-.63 5.41.38 3.11 1.67 2 7.42 2.87 8.59s3.14-.7 4.77.2c2.54 1.4.36 9.8.53 11.18s2 .19 3.06 1c2.81 2.18-.61 8.81-.07 14.39.19 1.93.65 4.93.65 4.93z"
        className="San_Marino_svg__cls-11"
      />
      <path
        id="San_Marino_svg__path316"
        d="M511.88 448.45a6.1 6.1 0 1 1-6.1 6.1 6.1 6.1 0 0 1 6.1-6.1"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path318"
        d="M511.17 454c-1.3-1.79-1.35-4-.1-4.88s3.31-.19 4.61 1.6 1.35 4 .1 4.89-3.31.13-4.61-1.61"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path320"
        d="M511.88 448.45a6.1 6.1 0 1 1-6.1 6.1 6.1 6.1 0 0 1 6.1-6.1"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path322"
        d="M505.37 454.55a6.52 6.52 0 1 1 6.51 6.51 6.51 6.51 0 0 1-6.51-6.51"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path324"
        d="M481.67 339.74a6.3 6.3 0 1 1 6.41-6.19 6.3 6.3 0 0 1-6.41 6.19"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path326"
        d="M649.07 572.12a2.7 2.7 0 0 1 2.26-2.37 2.4 2.4 0 0 1 2.77 1.25m9.65 20.83c-4 .82-6.43-4.18-5.06-5.41.9-.8 3.1-.63 4.72.16 2.89 1.42 2.11 4.87.34 5.24Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path328"
        d="M663.75 591.82c-3.32.84-5.92-3.61-5.06-4.59s2.47-1 4.09-.16c2.89 1.41 2.72 4.3 1 4.75Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path330"
        d="M663.75 591.82c-3.32.84-5.92-3.61-5.06-4.59s2.47-1 4.09-.16c2.89 1.41 2.72 4.3 1 4.75Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path332"
        d="M489.84 336.83c4.19-12.22 6.53-20.81 13.47-32.74 4.72-8.12 14-19.61 14-19.61s-8.73 11.79-13.25 20c-6.4 11.55-7.83 16.53-12.94 31.3l-1.27 1.09Z"
      />
      <path
        id="San_Marino_svg__path334"
        d="M489.84 336.83c4.19-12.22 6.53-20.81 13.47-32.74 4.72-8.12 14-19.61 14-19.61s-8.73 11.79-13.25 20c-6.4 11.55-7.83 16.53-12.94 31.3l-1.27 1.09Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path336"
        d="M470 309.67s-1.53 19.2.88 31.08c2.17 10.68 9.71 26.19 9.71 26.19s.42.31-1.76-5.44-5.1-12.43-6.91-20.78c-2.58-11.86-1.92-31.05-1.92-31.05"
      />
      <path
        id="San_Marino_svg__path338"
        d="M470 309.67s-1.53 19.2.88 31.08c2.17 10.68 9.71 26.19 9.71 26.19s.42.31-1.76-5.44-5.1-12.43-6.91-20.78c-2.58-11.86-1.92-31.05-1.92-31.05"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path340"
        d="M452 359.54a109 109 0 0 0 4.72 10.61c6 10.91 11.1 16.61 21.31 23.71l.29-.91c-9.83-7-14.46-12.56-20.78-22.8-2.42-3.97-5.54-10.61-5.54-10.61"
      />
      <path
        id="San_Marino_svg__path342"
        d="M452 359.54a109 109 0 0 0 4.72 10.61c6 10.91 11.1 16.61 21.31 23.71l.29-.91c-9.83-7-14.46-12.56-20.78-22.8-2.42-3.97-5.54-10.61-5.54-10.61"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path344"
        d="M488.56 364s12.22-11.28 18.46-20.1c5.52-7.8 12.14-21.62 12.14-21.62s-6 14-11.4 21.84c-6 8.81-17.55 19.88-17.55 19.88Z"
      />
      <path
        id="San_Marino_svg__path346"
        d="M488.56 364s12.22-11.28 18.46-20.1c5.52-7.8 12.14-21.62 12.14-21.62s-6 14-11.4 21.84c-6 8.81-17.55 19.88-17.55 19.88Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path348"
        d="M500.53 452.38c2.32-5.6 5.82-13.3 8.43-22.19 3.27-11.14 5.22-16.57 5.59-29.25-.19 12.66-1.54 17-4.22 27.59A162 162 0 0 1 502.6 451l-2.07 1.4Z"
      />
      <path
        id="San_Marino_svg__path350"
        d="M500.53 452.38c2.32-5.6 5.82-13.3 8.43-22.19 3.27-11.14 5.22-16.57 5.59-29.25-.19 12.66-1.54 17-4.22 27.59A162 162 0 0 1 502.6 451l-2.07 1.4Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path352"
        d="M493.57 396.19s9.21-8.05 13.32-15.25c5.41-9.49 6.32-17.11 6.32-17.11s-.08 7.66-5.5 17.15c-4.11 7.2-13.77 16.39-13.77 16.39z"
      />
      <path
        id="San_Marino_svg__path354"
        d="M493.57 396.19s9.21-8.05 13.32-15.25c5.41-9.49 6.32-17.11 6.32-17.11s-.08 7.66-5.5 17.15c-4.11 7.2-13.77 16.39-13.77 16.39z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path356"
        d="M483.09 441.83a144 144 0 0 1-12.29-8.7c-16.89-14.22-27.47-33.39-27.47-33.39S453 420 470.18 434c4.56 3.72 12.91 8.91 12.91 8.91v-1Z"
      />
      <path
        id="San_Marino_svg__path358"
        d="M483.09 441.83a144 144 0 0 1-12.29-8.7c-16.89-14.22-27.47-33.39-27.47-33.39S453 420 470.18 434c4.56 3.72 12.91 8.91 12.91 8.91v-1Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path360"
        d="M484.18 443.87a1.45 1.45 0 0 1-.73-2.1"
        className="San_Marino_svg__cls-12"
      />
      <path
        id="San_Marino_svg__path362"
        d="M544.8 502c-7.45-4.68-17.93-11.66-27.38-21.37-3.24-3.32-7.89-8.89-7.89-8.89a75 75 0 0 0 6.85 9.1c8.43 8.77 20 17 27.45 21.68l1-.52Z"
      />
      <path
        id="San_Marino_svg__path364"
        d="M544.8 502c-7.45-4.68-17.93-11.66-27.38-21.37-3.24-3.32-7.89-8.89-7.89-8.89a75 75 0 0 0 6.85 9.1c8.43 8.77 20 17 27.45 21.68l1-.52Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path366"
        d="M570.59 511s-14-10-20.32-18.83a59.6 59.6 0 0 1-7.42-13.17 69.6 69.6 0 0 0 8.45 13.12c6.32 8 19.29 17.59 19.29 17.59z"
      />
      <path
        id="San_Marino_svg__path368"
        d="M570.59 511s-14-10-20.32-18.83a59.6 59.6 0 0 1-7.42-13.17 69.6 69.6 0 0 0 8.45 13.12c6.32 8 19.29 17.59 19.29 17.59z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path370"
        d="M501.19 529c20.61-2.87 28.63-14.91 46.18-17.64-1.85.1-1.51-.63-3.2-.27-15.47 3.24-24.94 14.91-42.98 17.91"
      />
      <path
        id="San_Marino_svg__path372"
        d="M501.19 529c20.61-2.87 28.63-14.91 46.18-17.64-1.85.1-1.51-.63-3.2-.27-15.47 3.24-24.94 14.91-42.98 17.91"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path374"
        d="M526.34 498.87a6.1 6.1 0 1 1-6.1 6.1 6.11 6.11 0 0 1 6.1-6.1"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path376"
        d="M532.32 503.81a2.5 2.5 0 0 1-.23.57c-.9 1.54-3.35 1.8-5.47.58s-3.13-3.48-2.23-5a2.43 2.43 0 0 1 1.1-1 6 6 0 0 1 .85-.06 6.09 6.09 0 0 1 6 4.94Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path378"
        d="M526.34 498.87a6.1 6.1 0 1 1-6.1 6.1 6.11 6.11 0 0 1 6.1-6.1"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path380"
        d="M519.82 505a6.52 6.52 0 1 1 6.52 6.51 6.52 6.52 0 0 1-6.52-6.51"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path382"
        d="M547.68 507.8a4.3 4.3 0 0 1 .93.72c.35.4.48.87.24 1.18a1.77 1.77 0 0 0 .59.68 5.2 5.2 0 0 0 2.31.55 22 22 0 0 1 2.73.57c.81.24 1.82.66 1.82.66l-4.57-2.28z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path384"
        d="M503.6 472.07s-11.37-3-25.91-8.41a81.1 81.1 0 0 1-24.33-14.5 90.8 90.8 0 0 0 24.33 13.67 223 223 0 0 0 25.91 8Z"
      />
      <path
        id="San_Marino_svg__path386"
        d="M503.6 472.07s-11.37-3-25.91-8.41a81.1 81.1 0 0 1-24.33-14.5 90.8 90.8 0 0 0 24.33 13.67 223 223 0 0 0 25.91 8Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path388"
        d="M769.26 527.53c.88 1.52 2.49 2.56 3.23 4.12 1 2.19.06 4.41-2.58 4.25-1.14-.07-2.2-.95-3.29-1-.89-.07-3.43 3.32-5.89 3.21-3.35-.15-4.94-4.24-7-6.33-1.63-.34-2.83 2.06-4.63 1.73-3.72-.67-3.54-6.57-4.82-9.17-1-.76-2.58.85-4.64-.61-3.18-2.24-1.52-9.31-4.93-11.29-3-1.74-9.37-.59-8.82-.88l3.55-1.84c.22-.12.9.21 1.12.25 5.81 1.16 13.59.21 19.55.21 2.85 0 2.39 2.3 2.85 2.77h.23c3 .21 6.51 0 9 1.86 3.06 2.27.16 4.3.15 4.81l.14.07.65.21 2 .59a8.8 8.8 0 0 1 4.33 2.5c1.54 1.93-.15 2.82-.2 4.54"
      />
      <path
        id="San_Marino_svg__path390"
        d="M769.26 527.53c.88 1.52 2.49 2.56 3.23 4.12 1 2.19.06 4.41-2.58 4.25-1.14-.07-2.2-.95-3.29-1-.89-.07-3.43 3.32-5.89 3.21-3.35-.15-4.94-4.24-7-6.33-1.63-.34-2.83 2.06-4.63 1.73-3.72-.67-3.54-6.57-4.82-9.17-1-.76-2.58.85-4.64-.61-3.18-2.24-1.52-9.31-4.93-11.29-3-1.74-9.37-.59-8.82-.88l3.55-1.84c.22-.12.9.21 1.12.25 5.81 1.16 13.59.21 19.55.21 2.85 0 2.39 2.3 2.85 2.77h.23c3 .21 6.51 0 9 1.86 3.06 2.27.16 4.3.15 4.81l.14.07.65.21 2 .59a8.8 8.8 0 0 1 4.33 2.5c1.54 1.93-.15 2.82-.2 4.54"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path392"
        d="M729.64 510.28c1.28.81 18.39.27 20.69.27 2.48 0 1.67 2 2.52 2.7 1 .47 12.78.08 10.1 4.52-.31.51-.71 1-1 1.51l.06.49c1.2 1 5.37 1.07 7.18 3.41 1.08 1.39-1.78 3.63-.56 4.52 2.36 1.69 7.63 9.22-1.93 7-2.3-.54-5 5.87-10 .13a33 33 0 0 0-2.6-3.13c-1.4-1-3.17 1.27-4.89 1-3.14-.51-3.34-6-4.47-8.35-1.57-1.09-2.87.2-4.74-1.11-4.22-3 1-13.22-12.72-11.69Z"
        className="San_Marino_svg__cls-10"
      />
      <path
        id="San_Marino_svg__path394"
        d="M729.64 510.28c1.28.81 18.39.27 20.69.27 2.48 0 1.67 2 2.52 2.7 1 .47 12.78.08 10.1 4.52-.31.51-.71 1-1 1.51l.06.49c1.2 1 5.37 1.07 7.18 3.41 1.08 1.39-1.78 3.63-.56 4.52 2.36 1.69 7.63 9.22-1.93 7-2.3-.54-5 5.87-10 .13a33 33 0 0 0-2.6-3.13c-1.4-1-3.17 1.27-4.89 1-3.14-.51-3.34-6-4.47-8.35-1.57-1.09-2.87.2-4.74-1.11-4.22-3 1-13.22-12.72-11.69Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path396"
        d="M728.39 510.56s12.88 2.61 20.28 6.34c6.79 3.43 15.9 11.29 15.9 11.29s-8.88-8.36-15.69-11.91c-7.06-3.67-19.46-6.13-19.46-6.13Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path398"
        d="M761.55 497c3.34 3.1-1.71 13.41-5.5 12.76-6-1-9.37-7.86-8.23-10.76 1.18-3.16 10.12-5.38 13.73-2"
      />
      <path
        id="San_Marino_svg__path400"
        d="M761.55 497c3.34 3.1-1.71 13.41-5.5 12.76-6-1-9.37-7.86-8.23-10.76 1.18-3.16 10.12-5.38 13.73-2"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path402"
        d="M755.53 508.67c-1.71-1.22-1-5.56.46-8.18 1.38-2.4 3.35-3.91 4.86-3.44 4.28 1.34 8.45 7 6.84 10.41s-10.46 2.43-12.16 1.21"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path404"
        d="M761.27 497.27c3.07 2.84-1.81 12.2-5.15 11.63-5.76-1-7.84-6.91-7.14-9.36s8.88-5.43 12.29-2.27"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path406"
        d="M761.27 497.27c3.07 2.84-1.81 12.2-5.15 11.63-5.76-1-7.84-6.91-7.14-9.36s8.88-5.43 12.29-2.27"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path408"
        d="M781.31 504.35c-.55.73-1.7 2.08-2.9 2.06-5.13 0-4.77-4.42-7.47-7.33-.9-.22-1.57.85-3.33.44-2.32-.53-2.46-6.42-5.92-7.62-1.75-.61-6.63-.64-9.34 1.91l4.85-3.81c4.68 1.83 8.9-8.14 14.27-6.81 1.52.37 1.57 1.37 3.33 1.21 3.92-.35 7.91-2.91 12.62-1.36 2.82.93-.85 4.71 2.72 4.28 2.29-.28 5.71-.27 6.39 2.58.38 1.56-.43 2.27-.26 3.41.46.36 9.07 3.35 4.52 5.66.72 2 4.18 3.37 2.34 5.85-1.71 2.33-5.37-.25-6.39.71-.41.4-.4 1.52-.76 2-1.52 1.88-5.52-1.95-7.22-2.31-1.7 5.75-4.76 3-7.45-.89Z"
      />
      <path
        id="San_Marino_svg__path410"
        d="M781.31 504.35c-.55.73-1.7 2.08-2.9 2.06-5.13 0-4.77-4.42-7.47-7.33-.9-.22-1.57.85-3.33.44-2.32-.53-2.46-6.42-5.92-7.62-1.75-.61-6.63-.64-9.34 1.91l4.85-3.81c4.68 1.83 8.9-8.14 14.27-6.81 1.52.37 1.57 1.37 3.33 1.21 3.92-.35 7.91-2.91 12.62-1.36 2.82.93-.85 4.71 2.72 4.28 2.29-.28 5.71-.27 6.39 2.58.38 1.56-.43 2.27-.26 3.41.46.36 9.07 3.35 4.52 5.66.72 2 4.18 3.37 2.34 5.85-1.71 2.33-5.37-.25-6.39.71-.41.4-.4 1.52-.76 2-1.52 1.88-5.52-1.95-7.22-2.31-1.7 5.75-4.76 3-7.45-.89Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path412"
        d="M762 491.91c3.55 1 3.65 6.49 5.7 7s2-.57 3.28-.28 2.38 7.19 8.11 6.48a3.25 3.25 0 0 0 2.2-1.74s2.09 3.44 4.3 3.75c3.17.45 2.26-2.41 3.07-2.51 1.29-.14 3.66 2.59 6 2.59 1.34 0 1.15-2.28 2.56-2.28s4.19 1.35 5.34-.31c1.5-2.15-2-4.67-2.25-5.45s1-.79.86-1.53c-.48-2.73-4.93-3.17-5.32-4.14s.63-2 .25-3.46c-.64-2.55-4.26-2.64-5.9-2.28-3.8.85-.35-3.21-3.06-4.35-4.66-2-11.44 1.76-13.17 1a10 10 0 0 0-2.6-.81c-4.2-.73-8.07 5.4-10.72 6.67l1.33 1.61Z"
        className="San_Marino_svg__cls-11"
      />
      <path
        id="San_Marino_svg__path414"
        d="M760.69 490s12.87-.79 20.42 1.84c6.54 2.27 15.16 9.22 15.16 9.22s-9.29-6.84-16.2-8.84c-7.44-2.16-19.84-1-19.84-1l.46-1.24Z"
      />
      <path
        id="San_Marino_svg__path416"
        d="M760.69 490s12.87-.79 20.42 1.84c6.54 2.27 15.16 9.22 15.16 9.22s-9.29-6.84-16.2-8.84c-7.44-2.16-19.84-1-19.84-1l.46-1.24Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path418"
        d="M749.32 490.9s2.46-16.38 2.25-26.91c-.13-6.33-1.34-16.17-1.34-16.17s1.7 10.21 2 16.8c.39 9.78-1.84 25-1.84 25l-1 1.24Z"
      />
      <path
        id="San_Marino_svg__path420"
        d="M749.32 490.9s2.46-16.38 2.25-26.91c-.13-6.33-1.34-16.17-1.34-16.17s1.7 10.21 2 16.8c.39 9.78-1.84 25-1.84 25l-1 1.24Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path422"
        d="M736.88 490.3c.24.71 2.62 1.4 2.4 4.05-.26 3.25-5.16 2.25-7.44 3.78-.86.58 1 3.37 0 4.7-1.78 2.36-7.79.95-8.23 1.54-.8 1.08 2 4.05-.95 5.69-4.05 2.28-12.61-1.32-17.23 2.77-.27.24-2.06 2.26-2.13 2.28-2.64.69-9.64 2.14-8.82 1.79 4.11-1.73 10.71-3.42 12-6.24 1.1-2.41.27-7 .72-9.55.67-3.88 3.52-2.32 4.46-3.55.76-1-.65-6.41 2.42-9 2.15-1.79 4.46-.56 6.43-2s-1-6.42 3-7.83c2.44-.84 5 1.88 5.53 1.76 1.52-.32 3.31-4.9 6.39-4.29s1.7 4.67 1.57 6.54c5.15.64 2.36 4.47-.18 7.5Z"
      />
      <path
        id="San_Marino_svg__path424"
        d="M736.88 490.3c.24.71 2.62 1.4 2.4 4.05-.26 3.25-5.16 2.25-7.44 3.78-.86.58 1 3.37 0 4.7-1.78 2.36-7.79.95-8.23 1.54-.8 1.08 2 4.05-.95 5.69-4.05 2.28-12.61-1.32-17.23 2.77-.27.24-2.06 2.26-2.13 2.28-2.64.69-9.64 2.14-8.82 1.79 4.11-1.73 10.71-3.42 12-6.24 1.1-2.41.27-7 .72-9.55.67-3.88 3.52-2.32 4.46-3.55.76-1-.65-6.41 2.42-9 2.15-1.79 4.46-.56 6.43-2s-1-6.42 3-7.83c2.44-.84 5 1.88 5.53 1.76 1.52-.32 3.31-4.9 6.39-4.29s1.7 4.67 1.57 6.54c5.15.64 2.36 4.47-.18 7.5Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path426"
        d="M695.25 516.51s11-4.57 11.85-6.87c1.37-3.52-.13-8.85 1.79-10.13 1.25-.83 2.5-.41 3.32-1.6s-.24-6.93 2.71-9.25c1.86-1.45 3.53-.15 5.79-1.74 2.43-1.71-.65-5.95 3.07-7.34 2.19-.82 4.39 1.86 5.48 1.57 2.1-.54 3.21-4.71 6.28-4.27 2.47.36 1.26 2.88 1.11 5.26-.09 1.37 2.05.73 2.69 2.65.47 1.4-1.44 4.4-2.72 5.51-.73.64 2.22 1.76 2 3.74-.25 2.85-5.75 3-7 3.51-1.65.58-.16 3.05-1.28 4.48-1.79 2.3-6.38.87-7.19 2s.91 3.57-1.19 5.15-10.7.6-12.08 1.11c-4.1 1.51-7.43 3.08-7.43 3.08l-7.21 3.17Z"
        className="San_Marino_svg__cls-11"
      />
      <path
        id="San_Marino_svg__path428"
        d="M707 510.08s12-8.61 18.09-16.31c3.38-4.25 7.84-10.7 7.84-10.7s-4.32 6.69-7.63 11.12c-6 8.06-18.1 17.27-18.1 17.27Z"
      />
      <path
        id="San_Marino_svg__path430"
        d="M707 510.08s12-8.61 18.09-16.31c3.38-4.25 7.84-10.7 7.84-10.7s-4.32 6.69-7.63 11.12c-6 8.06-18.1 17.27-18.1 17.27Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path432"
        d="M796.44 433.49c4.6-2.49 12.95-6.79 19.77-13a119 119 0 0 0 10.58-11.92s-5.94 8.13-10.58 12.54c-7 6.63-15.79 11.36-20.39 13.84Z"
      />
      <path
        id="San_Marino_svg__path434"
        d="M796.44 433.49c4.6-2.49 12.95-6.79 19.77-13a119 119 0 0 0 10.58-11.92s-5.94 8.13-10.58 12.54c-7 6.63-15.79 11.36-20.39 13.84Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path436"
        d="m786.66 439.67-1 3.51c0-4.85-.19-7.16-5.94-6.85a13.4 13.4 0 0 1-2.69 0c-2.92-.46-.67-2.21-1.59-3.55-1.14-1.62-8.82-.16-9.45-4-.24-1.49 1.42-3.27.2-4.43-1.85-1.77-6.44-3.3-5.95-6.54.21-1.33 2-2.3 1.73-3.54-.34-1.65-3.64-4.53-2.84-6.35.65-1.45 1.82-1 1.94-2.34.12-1.53-2.55-5.34-.17-6.5 3.14-1.53 5.27 1.45 8 1.67 1.57.13 2.63-1.73 4.26-1.37 2.11.47 2.12 3.87 3.48 4.56.5.26 2-1 2.7-1.09 3.78-.43 2.92 6.9 4.21 8.62.47.62 1.46 0 2.14.21 2.37.74-.17 8.75.81 9.83.33.36 1.53.16 2.06.3 2 .56.59 5.66.27 6.91-.74 2.81-3.28 8.33-2.08 11Z"
        className="San_Marino_svg__cls-10"
      />
      <path
        id="San_Marino_svg__path438"
        d="m786.66 439.67-1 3.51c0-4.85-.19-7.16-5.94-6.85a13.4 13.4 0 0 1-2.69 0c-2.92-.46-.67-2.21-1.59-3.55-1.14-1.62-8.82-.16-9.45-4-.24-1.49 1.42-3.27.2-4.43-1.85-1.77-6.44-3.3-5.95-6.54.21-1.33 2-2.3 1.73-3.54-.34-1.65-3.64-4.53-2.84-6.35.65-1.45 1.82-1 1.94-2.34.12-1.53-2.55-5.34-.17-6.5 3.14-1.53 5.27 1.45 8 1.67 1.57.13 2.63-1.73 4.26-1.37 2.11.47 2.12 3.87 3.48 4.56.5.26 2-1 2.7-1.09 3.78-.43 2.92 6.9 4.21 8.62.47.62 1.46 0 2.14.21 2.37.74-.17 8.75.81 9.83.33.36 1.53.16 2.06.3 2 .56.59 5.66.27 6.91-.74 2.81-3.28 8.33-2.08 11Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path440"
        d="M786.52 439.1s-3.67-14.59-8.87-22.42c-4.31-6.5-13.74-14.5-13.74-14.5s9 8.06 13.12 14.5c5 7.88 8.45 22.42 8.45 22.42Z"
      />
      <path
        id="San_Marino_svg__path442"
        d="M786.52 439.1s-3.67-14.59-8.87-22.42c-4.31-6.5-13.74-14.5-13.74-14.5s9 8.06 13.12 14.5c5 7.88 8.45 22.42 8.45 22.42Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path444"
        d="M794.48 362.87s-8.67-14.07-16.11-21.39c-6.08-6-17.32-13.33-17.32-13.33s10.71 7.56 16.49 13.56c7.06 7.33 15.28 21.16 15.28 21.16Z"
      />
      <path
        id="San_Marino_svg__path446"
        d="M794.48 362.87s-8.67-14.07-16.11-21.39c-6.08-6-17.32-13.33-17.32-13.33s10.71 7.56 16.49 13.56c7.06 7.33 15.28 21.16 15.28 21.16Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path448"
        d="M790.7 329.2a134 134 0 0 1 4.89 14.42c6.46 24.46 7 52.72 4.29 69.05-8.52 50.33-54.25 97.11-90.88 104.41-31.08 6.21-49.45 19.67-62.49 34.07a123 123 0 0 0-14.95 20.11c-3.79 6.43-6.28 11.94-9.64 17.48l-.19.08a7 7 0 0 1-.88.22 19 19 0 0 1-2.56.28 8.7 8.7 0 0 1-2.2-.12h-.11c.47-.73.94-1.45 1.4-2.21 3.21-5.29 6-10.44 9.67-16.57A126 126 0 0 1 641 551.19c13.57-15.35 32.86-30.19 65.84-36.82 38.38-7.71 82.21-55.31 90.8-106 2.79-16.52 2.73-45-7.76-75.95l.87-3.19Z"
        className="San_Marino_svg__cls-6"
      />
      <path
        id="San_Marino_svg__path450"
        d="M789.21 326.25a105.2 105.2 0 0 0-10-20c-5.95-9.55-18-22.52-18-22.52s11.44 13 17.07 22.48a107.9 107.9 0 0 1 12.1 27.31Z"
      />
      <path
        id="San_Marino_svg__path452"
        d="M789.21 326.25a105.2 105.2 0 0 0-10-20c-5.95-9.55-18-22.52-18-22.52s11.44 13 17.07 22.48a107.9 107.9 0 0 1 12.1 27.31Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path454"
        d="M791.06 334s-.49-1.22-.74-2a37 37 0 0 1-1-4.35l1.31 3.13c.46 1.1 1.19 3.27 1.19 3.27Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path456"
        d="M546.36 522a6.51 6.51 0 1 1 6.51 6.51 6.51 6.51 0 0 1-6.51-6.51"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path458"
        d="M552.86 515.89a6.1 6.1 0 1 1-6.09 6.11 6.1 6.1 0 0 1 6.09-6.11"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path460"
        d="M557.49 526c-2 .74-4.52-.53-6-3-1.56-2.7-1.22-5.82.76-7l.09-.05h.5A6.1 6.1 0 0 1 559 522a6.07 6.07 0 0 1-1.47 4Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path462"
        d="M552.86 515.89a6.1 6.1 0 1 1-6.09 6.11 6.1 6.1 0 0 1 6.09-6.11"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path464"
        d="M792.59 418c-2.37-2-8.88-8-8.88-11 0-3.65 3.41-3 4.23-3.56-.14-1.48-5.14-5.13-3.14-8.42 1.32-2.17 4.33-1.56 5.44-2.45.85-2.32-2.45-8.36.2-11.64 1.57-1.94 2.78-.49 3.52-.66.14-1 .11-2.06.23-3.08.2-1.81.85-3.6 2.95-3.71 2.94-.15 4.94 3.62 6.34 5.69.31-.18 1.84-.4 2.17-.56 3.61-1.76 2.3 9.45 2.4 11.18.84 0 2.55-.5 3.3-.06 3.87 2.28-3.82 14.3-4.64 17.12-.34 1.18 4.06.24.68 4.5-2 2.49-4.49 4.7-6.66 7l-8.14-.34Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path466"
        d="M793.82 427.28c1.47-3.88.94-7.66-2-9.77-3.13-2.27-7.3-7.65-7.3-10.77 0-3.68 3.67-1.44 3.84-3.18.13-1.3-4.81-5.2-3-8.06 1.15-1.86 4.2-1.65 5-2.58 1.29-1.55-1.9-8.45.63-11.66 1.38-1.76 2.46.12 3.38-.54s-.54-5.9 2.86-6.05 5.68 5.34 6.2 5.17c1.06-.34 2.32-1.44 3.51-.31s.8 10.46.8 10.46 2.22-.22 2.93.22c3 1.82-2.35 12.45-3.85 15.37-1.28 2.48 2.46 2.8.55 5.35-3.16 4.21-9.46 9.26-10.46 15.45l-3 .9Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path468"
        d="M794.44 425.07c.38-.76.78-1.32 1.1-1.26.77.15.43 2.1.26 2.88l-2 .58a13.5 13.5 0 0 0 .64-2.2"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path470"
        d="M793.82 427.28c1.47-3.88.94-7.66-2-9.77-3.13-2.27-7.3-7.65-7.3-10.77 0-3.68 3.67-1.44 3.84-3.18.13-1.3-4.81-5.2-3-8.06 1.15-1.86 4.2-1.65 5-2.58 1.29-1.55-1.9-8.45.63-11.66 1.38-1.76 2.46.12 3.38-.54s-.54-5.9 2.86-6.05 5.68 5.34 6.2 5.17c1.06-.34 2.32-1.44 3.51-.31s.8 10.46.8 10.46 2.22-.22 2.93.22c3 1.82-2.35 12.45-3.85 15.37-1.28 2.48 2.46 2.8.55 5.35-3.16 4.21-9.46 9.26-10.46 15.45"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path472"
        d="M797.46 424.54s2.37-15.23 3-23.27c.54-6.59-.93-17.44-.93-17.44a134 134 0 0 1 .31 17c-.66 8-4.18 27.16-4.18 27.16l1.78-3.47Z"
      />
      <path
        id="San_Marino_svg__path474"
        d="M797.46 424.54s2.37-15.23 3-23.27c.54-6.59-.93-17.44-.93-17.44a134 134 0 0 1 .31 17c-.66 8-4.18 27.16-4.18 27.16l1.78-3.47Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path476"
        d="M762.81 481.16c1.33-3.41-2.58-13.4.37-15.15 1.69-1 2.75.88 4.39-.73 2.1-2.07-1.18-9.88 2.65-12.34 2.23-1.44 4 .63 6.14-1.32 1.42-1.29 1.48-6.52 5.1-7.42 2.41-.6 3.51 1 5.64 1.33 1.81.24 7.94-8.3 11.75-6.26 4 2.14.45 6.68-.35 9.71-.42 1.59 3 1.37 2.66 4-.29 2.43-3.07 4.87-3.07 5.89s2.81 1.82 2.92 3.86c.22 3.95-6.15 4.51-8.29 6.19-1.12.88 1.45 3.72-.14 6.33-1.67 2.78-8.82.83-10 1.43-1 .49 0 5.19-1.23 6.86-2 2.72-11.29.17-14.75.74-4.63.75-6.65 1.7-9.56 5.16l5.78-8.3Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path478"
        d="M756.94 486.62s3.65-1.89 5-4 1.46-2.83 1.41-6.12c0-2-1.77-8.87.19-10 1.61-.9 2.5.86 4.51-1 2.44-2.31-1.14-10.31 2.34-12.47 2.1-1.3 4 1 6.42-1.17 1.66-1.48 1.37-6.46 4.63-7.28 2.05-.51 3.68 1.08 5.61 1.34 2.36.32 7.75-7.54 11.12-5.7a3 3 0 0 1 1.65 3.56c-.29 1.75-1.29 3.3-1.66 5-.49 2.2 2.49 2 2.22 4.33s-2.87 4.33-2.87 5.76 2.36 2.58 2.51 4.51c.29 3.66-7.36 3.73-8 5.74s.87 3.47-.58 5.82c-1.56 2.52-6.94.29-9 1.14-1.75.72-.69 4.68-1.76 6.27-2.93 4.38-17.14-1.77-23 6.25l-.72-2Z"
        className="San_Marino_svg__cls-11"
      />
      <path
        id="San_Marino_svg__path480"
        d="M757.37 487.13s15.1-12.86 23.39-22.38c6.38-7.33 15-19.9 15-19.9s-8 12.72-14.17 20.11c-7.49 9-21.34 21.16-21.34 21.16l-2.88 1Z"
      />
      <path
        id="San_Marino_svg__path482"
        d="M757.37 487.13s15.1-12.86 23.39-22.38c6.38-7.33 15-19.9 15-19.9s-8 12.72-14.17 20.11c-7.49 9-21.34 21.16-21.34 21.16l-2.88 1Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path484"
        d="m756 487.46 2.48-.71s-.91 1.06-1.27 1.39l-1.13 1-.08-1.72Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path486"
        d="M755.89 508.37c-1.23-.87-.91-4.89.64-7.57 1.4-2.43 3.57-3.61 4.47-3.18 3.31 1.55 7.45 6.75 6.13 9.58s-9.62 2.33-11.24 1.17"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path488"
        d="M760.9 499.64a2.9 2.9 0 0 1 1.86-.92c2.82 2.18 5.47 6.14 4.37 8.48a2 2 0 0 1-.18.31 5.8 5.8 0 0 1-4.64-1.64c-2.15-1.93-2.78-4.72-1.41-6.23"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path490"
        d="M755.89 508.37c-1.23-.87-.91-4.89.64-7.57 1.4-2.43 3.57-3.61 4.47-3.18 3.31 1.55 7.45 6.75 6.13 9.58s-9.62 2.33-11.24 1.17"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path492"
        d="M795.61 334.71c-3.14-1.09-5.29-6.89-4-12s14.31-3 12.91 3.06c-1.11 4.79-6.27 9.91-8.93 9Z"
      />
      <path
        id="San_Marino_svg__path494"
        d="M795.61 334.71c-3.14-1.09-5.29-6.89-4-12s14.31-3 12.91 3.06c-1.11 4.79-6.27 9.91-8.93 9Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path496"
        d="M804.19 323.87c-.47 3.06-4.5 3.4-6.36 3s-5.73-2.5-5.29-5c.93-5.37 5.27-9.51 7.83-9.11 2.79.44 4.56 6.21 3.82 11.13Z"
      />
      <path
        id="San_Marino_svg__path498"
        d="M804.19 323.87c-.47 3.06-4.5 3.4-6.36 3s-5.73-2.5-5.29-5c.93-5.37 5.27-9.51 7.83-9.11 2.79.44 4.56 6.21 3.82 11.13Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path500"
        d="M795.88 333.72c-2.64-.41-4.71-5.87-3.45-10.85 1.19-4.67 12.32-1.72 11.31 2.66-1.1 4.79-5.27 8.59-7.86 8.19"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path502"
        d="M795.88 333.72c-2.64-.41-4.71-5.87-3.45-10.85 1.19-4.67 12.32-1.72 11.31 2.66-1.1 4.79-5.27 8.59-7.86 8.19"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path504"
        d="M800.26 313.56c2.18.34 4.48 5.24 3.73 10.22-.37 2.41-4.12 2.27-6 1.89s-5.54-1.81-5.21-3.71c.92-5.31 5.52-8.72 7.52-8.4Z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path506"
        d="M800.5 318c-.34-2-1.21-3.67-.89-4.4h.66a3.67 3.67 0 0 1 2.22 1.88 16 16 0 0 1 .53 2.24c.59 3.36.49 4.95-.86 5.19s-1.33-2.95-1.66-4.9Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path508"
        d="M800.26 313.56c2.18.34 4.48 5.24 3.73 10.22-.37 2.41-4.12 2.27-6 1.89s-5.54-1.81-5.21-3.71c.92-5.31 5.52-8.72 7.52-8.4Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path510"
        d="M616.34 591c-1-1.52 1.33-6.16 6.25-5.6 2.16.24 1.11 3.37-1.56 5.24-1.88 1.31-3.66 1.87-4.69.36"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path512"
        d="M616.34 591c-1-1.52.47-4.77 5.43-5 1.77-.08 1.93 2.75-.74 4.62-1.88 1.31-3.66 1.87-4.69.36Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path514"
        d="M616.34 591c-1-1.52.47-4.77 5.43-5 1.77-.08 1.93 2.75-.74 4.62-1.88 1.31-3.66 1.87-4.69.36Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path516"
        d="M633.22 570.06a3.17 3.17 0 0 0-2.26-2.58 2.73 2.73 0 0 0-3 .82m3.17 4.24a2.68 2.68 0 0 0-2.25-2.37 2.39 2.39 0 0 0-2.78 1.23"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path518"
        d="M492.71 438.72s.7 2.12 1.24 3.43c.4 1 1.11 2.47 1.11 2.47s-1.49.32-1.49.16-1.16-6-1.16-6Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path520"
        d="M491.93 440c-2.2-3.37-6.89-7.13-9.54-9.88a30.14 30.14 0 0 1-8.39-16.71c-2.46-15.41 2-25.76 13.26-36.18.71 10.81 6.89 19.77 8.2 30.56 1.87 15.48-8 18.39-1.13 33.54Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path522"
        d="M490.44 436.88s.13.66.31 1.49a18 18 0 0 1 1.18 1.58l1.95 1.13-1-3.55Z"
        className="San_Marino_svg__cls-7"
      />
      <path
        id="San_Marino_svg__path524"
        d="M491.93 440c-2.2-3.37-6.89-7.13-9.54-9.88a30.14 30.14 0 0 1-8.39-16.71c-2.46-15.41 2-25.76 13.26-36.18.71 10.81 6.89 19.77 8.2 30.56 1.87 15.48-8 18.39-1.13 33.54"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path526"
        d="M491.91 436.75c-4.47-6.73-5.35-10-7.24-17-3.56-13-3.58-28.86-.23-34.64-3.35 5.78-4 21.52-.8 34.65a53.9 53.9 0 0 0 7.42 18.06l.85-1.11Z"
      />
      <path
        id="San_Marino_svg__path528"
        d="M491.91 436.75c-4.47-6.73-5.35-10-7.24-17-3.56-13-3.58-28.86-.23-34.64-3.35 5.78-4 21.52-.8 34.65a53.9 53.9 0 0 0 7.42 18.06l.85-1.11Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path530"
        d="M491.37 439.17c-1.09-1.28.3-3.38 1.56-1.53"
        className="San_Marino_svg__cls-12"
      />
      <path
        id="San_Marino_svg__path532"
        d="M713.9 223.51a5.4 5.4 0 1 1 5.4 5.39 5.4 5.4 0 0 1-5.4-5.39"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path534"
        d="M713.9 223.51a5.4 5.4 0 1 1 5.4 5.39 5.4 5.4 0 0 1-5.4-5.39"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path536"
        d="M715.52 204.56a6.78 6.78 0 1 1 6.78 6.77 6.77 6.77 0 0 1-6.78-6.77"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path538"
        d="M715.52 204.56a6.78 6.78 0 1 1 6.78 6.77 6.77 6.77 0 0 1-6.78-6.77"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path540"
        d="M603.29 184.14a5.21 5.21 0 1 1 5.21 5.21 5.22 5.22 0 0 1-5.21-5.21"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path542"
        d="M603.29 184.14a5.21 5.21 0 1 1 5.21 5.21 5.22 5.22 0 0 1-5.21-5.21"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path544"
        d="M551.14 204.56a6.78 6.78 0 1 1 6.77 6.77 6.77 6.77 0 0 1-6.77-6.77"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path546"
        d="M551.14 204.56a6.78 6.78 0 1 1 6.77 6.77 6.77 6.77 0 0 1-6.77-6.77"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path548"
        d="M583.23 186.33a5.63 5.63 0 1 1 5.63 5.63 5.63 5.63 0 0 1-5.63-5.63"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path550"
        d="M583.23 186.33a5.63 5.63 0 1 1 5.63 5.63 5.63 5.63 0 0 1-5.63-5.63"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path552"
        d="M555.52 223.51a5.4 5.4 0 1 1 5.4 5.39 5.4 5.4 0 0 1-5.4-5.39"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path554"
        d="M555.52 223.51a5.4 5.4 0 1 1 5.4 5.39 5.4 5.4 0 0 1-5.4-5.39"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path556"
        d="M562.6 191.34a6.52 6.52 0 1 1 6.52 6.52 6.52 6.52 0 0 1-6.52-6.52"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path558"
        d="M562.6 191.34a6.52 6.52 0 1 1 6.52 6.52 6.52 6.52 0 0 1-6.52-6.52"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path560"
        d="M666.5 184.14a5.21 5.21 0 1 1 5.21 5.21 5.22 5.22 0 0 1-5.21-5.21"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path562"
        d="M666.5 184.14a5.21 5.21 0 1 1 5.21 5.21 5.22 5.22 0 0 1-5.21-5.21"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path564"
        d="M685.72 186.33a5.63 5.63 0 1 1 5.63 5.63 5.63 5.63 0 0 1-5.63-5.63"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path566"
        d="M685.72 186.33a5.63 5.63 0 1 1 5.63 5.63 5.63 5.63 0 0 1-5.63-5.63"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path568"
        d="M704.57 191.34a6.52 6.52 0 1 1 6.52 6.52 6.52 6.52 0 0 1-6.52-6.52"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path570"
        d="M704.57 191.34a6.52 6.52 0 1 1 6.52 6.52 6.52 6.52 0 0 1-6.52-6.52"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path572"
        d="M650 171.19c18 20.73 49.56 10.61 64 18.68 25.06 14-2.2 47.34-7.33 53.71l-27.31-7.13c10-8 30.13-21.65 24.08-32.72-6.21-11.35-39.19.16-53.61-24.07-3-5.09-.7-9.51.2-8.47Z"
      />
      <path
        id="San_Marino_svg__path574"
        d="M650 171.19c18 20.73 49.56 10.61 64 18.68 25.06 14-2.2 47.34-7.33 53.71l-27.31-7.13c10-8 30.13-21.65 24.08-32.72-6.21-11.35-39.19.16-53.61-24.07-3-5.09-.7-9.51.2-8.47Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path576"
        d="M630 171.19c-18 20.73-49.57 10.61-64 18.68-25.06 14 2.2 47.34 7.33 53.71l27.31-7.13c-10-8-30.14-21.65-24.08-32.72 6.21-11.35 39.18.16 53.6-24.07 3-5.09.71-9.51-.19-8.47Z"
      />
      <path
        id="San_Marino_svg__path578"
        d="M630 171.19c-18 20.73-49.57 10.61-64 18.68-25.06 14 2.2 47.34 7.33 53.71l27.31-7.13c-10-8-30.14-21.65-24.08-32.72 6.21-11.35 39.18.16 53.6-24.07 3-5.09.71-9.51-.19-8.47Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path580"
        d="M587.19 267.6a6.08 6.08 0 0 1-2.21-5.06l-5.05-8.09 11.35-10.8 21.58-6.19 27.2-1.94h.05l27.21 1.94 21.58 6.19 11.34 10.8-5 8.09a6.08 6.08 0 0 1-2.24 5.06l-25.33-8.6-27.56-1.23L612.5 259l-25.31 8.56Z"
        className="San_Marino_svg__cls-13"
      />
      <path
        id="San_Marino_svg__path582"
        d="M587.8 266.69a7.47 7.47 0 0 1-1.88-6l-6-6.28 11.35-10.79 21.57-6.19 27.26-1.95 27.25 1.95 21.58 6.19 11.34 10.79-6 6.28a11.9 11.9 0 0 1-.48 3.75 12 12 0 0 1-1.4 2.21l-24.7-7.64-27.6-1.24-27.61 1.24-24.7 7.64Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path584"
        d="M587.8 266.69a7.47 7.47 0 0 1-1.88-6l-6-6.28 11.35-10.79 21.57-6.19 27.26-1.95 27.25 1.95 21.58 6.19 11.34 10.79-6 6.28a11.9 11.9 0 0 1-.48 3.75 12 12 0 0 1-1.4 2.21l-24.7-7.64-27.6-1.24-27.61 1.24-24.7 7.64Z"
        className="San_Marino_svg__cls-13"
      />
      <path
        id="San_Marino_svg__path586"
        d="M713.35 223.51a5.95 5.95 0 1 1 5.94 5.94 5.94 5.94 0 0 1-5.94-5.94m1.47-18.95a7.48 7.48 0 1 1 7.48 7.44 7.48 7.48 0 0 1-7.48-7.44m-112.07-20.42a5.75 5.75 0 1 1 5.75 5.75 5.75 5.75 0 0 1-5.75-5.75m-52.31 20.42a7.48 7.48 0 1 1 7.48 7.47 7.48 7.48 0 0 1-7.48-7.47m32.22-18.22a6.2 6.2 0 1 1 6.2 6.2 6.2 6.2 0 0 1-6.2-6.2M555 223.51a5.95 5.95 0 1 1 5.94 5.94 5.94 5.94 0 0 1-5.94-5.94m7-32.17a7.19 7.19 0 1 1 7.18 7.19 7.17 7.17 0 0 1-7.24-7.19Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path588"
        d="M630 171.81c-18 20.74-48.55 10.8-63 18.87-25.06 14 3.24 46.53 8.38 52.9l23.62-7.13c-10-8-29.08-22.06-23-33.13 6.2-11.36 39.78 0 54.2-24.28 3.01-5.04.68-8.26-.2-7.23"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path590"
        d="M631.61 173.41c-19.48 26.3-48.72 13-61.29 23.29-14.2 11.59 6.49 34.41 16.47 43.44l1.55-.47v-.11c-8.1-7.67-32.1-30.47-16.85-42.77 11-8.86 41.8 2.69 60.18-22.76a6 6 0 0 0-.07-.62Z"
      />
      <path
        id="San_Marino_svg__path592"
        d="M631.61 173.41c-19.48 26.3-48.72 13-61.29 23.29-14.2 11.59 6.49 34.41 16.47 43.44m1.55-.47v-.11c-8.1-7.67-32.1-30.47-16.85-42.77 11-8.86 41.8 2.69 60.18-22.76h0"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path594"
        d="M630 171.81c-18 20.74-48.55 10.8-63 18.87-25.06 14 3.24 46.53 8.38 52.9l23.62-7.13c-10-8-29.08-22.06-23-33.13 6.2-11.36 39.78 0 54.2-24.28 3.01-5.04.68-8.26-.2-7.23"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__polygon596"
        d="m588.8 240.01-.48-.45 2.83-.82z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__polygon598"
        d="m588.8 240.01-.48-.45 2.83-.82z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path600"
        d="m598.55 236.1.44.35-7.84 2.29 1.78-1a55 55 0 0 0 5.62-1.64"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path602"
        d="m598.55 236.1.44.35-7.84 2.29 1.78-1a55 55 0 0 0 5.62-1.64"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path604"
        d="M583.74 223.61a19.3 19.3 0 0 0-1.67 4.44c-8.33-9.92-14.57-20.19-8-28.68 6-7.74 20.62-4.24 35.86-9.59a39.7 39.7 0 0 0 19.67-12.67c-.56 1.51-1.14 3.35-1.78 5.18-15.47 19.69-46.37 10.26-52.26 21-3.47 6.36 1.46 13.69 8.19 20.3Z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path606"
        d="M628.51 178.34a10.2 10.2 0 0 0 2.27-.58c-.17.32-.36.67-.59 1a8.7 8.7 0 0 1-2.48.4c.27-.28.53-.57.8-.86Z"
      />
      <path
        id="San_Marino_svg__path608"
        d="M623.53 182.94a12.3 12.3 0 0 0 2.91 1c-.31.35-.64.69-1 1a11.8 11.8 0 0 1-3-1.19c.36-.26.71-.52 1.06-.8Z"
      />
      <path
        id="San_Marino_svg__path610"
        d="M617.41 186.82a11.5 11.5 0 0 0 3.86 1.65c-.44.31-.88.6-1.34.89a10.8 10.8 0 0 1-3.73-2l1.21-.59Z"
      />
      <path
        id="San_Marino_svg__path612"
        d="M609.1 190a11.5 11.5 0 0 0 4.32 2.57c-.57.22-1.15.42-1.73.62a12.1 12.1 0 0 1-3.94-2.83Z"
      />
      <path
        id="San_Marino_svg__path614"
        d="M600.84 191.69a10.9 10.9 0 0 0 3.58 3.41l-1.7.32a11.9 11.9 0 0 1-3.2-3.55Z"
      />
      <path
        id="San_Marino_svg__path616"
        d="M591.61 192.61a7.83 7.83 0 0 0 2.79 3.61.62.62 0 0 1 .24.38l-1.48.19a8.7 8.7 0 0 1-2.8-4.09Z"
      />
      <path
        id="San_Marino_svg__path618"
        d="M582.14 193.44A7.2 7.2 0 0 0 585 198c-.51.11-1 .22-1.49.35a8.36 8.36 0 0 1-2.58-4.78Z"
      />
      <path
        id="San_Marino_svg__path620"
        d="M576.82 201.64a12 12 0 0 1-4.61-5 13 13 0 0 1 1.16-.73 10.14 10.14 0 0 0 4.52 4.86 9.4 9.4 0 0 0-1.07.87"
      />
      <path
        id="San_Marino_svg__path622"
        d="M574.41 207.72a11.73 11.73 0 0 1-7.33-3.77 12 12 0 0 1 .53-1.63 10.3 10.3 0 0 0 6.92 4 9.3 9.3 0 0 0-.12 1.4"
      />
      <path
        id="San_Marino_svg__path624"
        d="M572.36 214.14a8 8 0 0 0 3.33-1.07q.31.69.69 1.38a9.6 9.6 0 0 1-3.24 1.22 11.5 11.5 0 0 1-4.17 0c-.27-.59-.53-1.19-.76-1.78a13.2 13.2 0 0 0 4.15.26Z"
      />
      <path
        id="San_Marino_svg__path626"
        d="M576.11 221.84a7 7 0 0 0 3.6-2.59c.39.47.8.95 1.22 1.42a7.8 7.8 0 0 1-2.57 2.35 9.2 9.2 0 0 1-4.31.91c-.47-.64-.93-1.28-1.38-1.93a9.8 9.8 0 0 0 3.44-.16"
      />
      <path
        id="San_Marino_svg__path628"
        d="M631.68 174.45c.05 1.27-.31 2.37-1.51 4.39-14.42 24.23-48.41 13.12-54.62 24.48-6 10.91 12.87 24.7 23 32.78a55 55 0 0 1-5.63 1.68l-1.77.95-2.62.83c-8.1-7.67-32.07-30.26-16.83-42.56 11-8.86 41.6 2.9 60-22.55Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path630"
        d="M666 184.14a5.75 5.75 0 1 1 5.75 5.75 5.75 5.75 0 0 1-5.75-5.75m19.19 2.19a6.21 6.21 0 1 1 6.2 6.21 6.2 6.2 0 0 1-6.24-6.21Zm18.75 5a7.19 7.19 0 1 1 7.19 7.19 7.19 7.19 0 0 1-7.23-7.18Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path632"
        d="M650.23 171.81c18 20.74 48.55 10.8 62.95 18.87 25.06 14-3.24 46.53-8.37 52.9l-23.59-7.13c10-8 29.08-22.06 23-33.13C698 192 664.46 203.27 650 179c-3-5.09-.71-8.26.19-7.23Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path634"
        d="M648.6 173.41c19.48 26.3 48.73 13 61.29 23.29 14.18 11.57-6.6 34.33-16.62 43.39l-1.41-.43v-.1c8.09-7.67 32.09-30.47 16.84-42.77-11-8.86-41.8 2.69-60.17-22.76a6 6 0 0 1 .06-.62Z"
      />
      <path
        id="San_Marino_svg__path636"
        d="M648.6 173.41c19.48 26.3 48.73 13 61.29 23.29 14.18 11.57-6.6 34.33-16.62 43.39m-1.41-.43v-.1c8.09-7.67 32.09-30.47 16.84-42.77-11-8.86-41.8 2.69-60.17-22.76h0"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path638"
        d="M650.23 171.81c18 20.74 48.55 10.8 62.95 18.87 25.06 14-3.24 46.53-8.37 52.9l-23.59-7.13c10-8 29.08-22.06 23-33.13C698 192 664.46 203.27 650 179c-3-5.09-.71-8.26.19-7.23Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path640"
        d="M696.47 223.61a19.3 19.3 0 0 1 1.67 4.44c8.33-9.92 14.57-20.19 8-28.68-6-7.74-20.62-4.24-35.86-9.59a39.7 39.7 0 0 1-19.67-12.67c.56 1.51 1.14 3.34 1.78 5.17 15.47 19.71 46.37 10.26 52.26 21 3.47 6.36-1.46 13.69-8.19 20.3Z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path642"
        d="M651.7 178.34a10.2 10.2 0 0 1-2.26-.58c.16.32.36.67.58 1a8.8 8.8 0 0 0 2.48.4c-.27-.24-.5-.53-.8-.82"
      />
      <path
        id="San_Marino_svg__path644"
        d="M656.68 182.94a12.3 12.3 0 0 1-2.91 1c.32.35.64.69 1 1a11.8 11.8 0 0 0 3-1.19c-.35-.26-.71-.52-1.06-.8Z"
      />
      <path
        id="San_Marino_svg__path646"
        d="M662.81 186.82a11.5 11.5 0 0 1-3.87 1.65c.44.31.89.6 1.34.88a10.6 10.6 0 0 0 3.73-1.94z"
      />
      <path
        id="San_Marino_svg__path648"
        d="M671.12 190a11.6 11.6 0 0 1-4.33 2.57c.57.21 1.15.42 1.73.61a12 12 0 0 0 3.94-2.82c-.45-.11-.9-.23-1.34-.36"
      />
      <path
        id="San_Marino_svg__path650"
        d="M679.37 191.69a10.9 10.9 0 0 1-3.58 3.41l1.7.32a11.8 11.8 0 0 0 3.2-3.55z"
      />
      <path
        id="San_Marino_svg__path652"
        d="M688.61 192.61a7.9 7.9 0 0 1-2.8 3.61.62.62 0 0 0-.24.38l1.48.19a8.8 8.8 0 0 0 2.81-4.09Z"
      />
      <path
        id="San_Marino_svg__path654"
        d="M698.07 193.44a7.15 7.15 0 0 1-2.86 4.6c.51.11 1 .22 1.49.34a8.3 8.3 0 0 0 2.58-4.77Z"
      />
      <path
        id="San_Marino_svg__path656"
        d="M703.39 201.64a11.85 11.85 0 0 0 4.61-5 13 13 0 0 0-1.16-.73 10.14 10.14 0 0 1-4.52 4.86 8.6 8.6 0 0 1 1.07.87"
      />
      <path
        id="San_Marino_svg__path658"
        d="M705.8 207.72a11.75 11.75 0 0 0 7.33-3.77 11 11 0 0 0-.53-1.63 10.28 10.28 0 0 1-6.91 4 9 9 0 0 1 .11 1.4"
      />
      <path
        id="San_Marino_svg__path660"
        d="M707.85 214.14a7.9 7.9 0 0 1-3.32-1.07q-.31.69-.69 1.38a9.5 9.5 0 0 0 3.23 1.22 11.5 11.5 0 0 0 4.17 0c.28-.59.54-1.19.77-1.78a13.3 13.3 0 0 1-4.16.26Z"
      />
      <path
        id="San_Marino_svg__path662"
        d="M704.1 222.67a9 9 0 0 1-4.31-2.57l-1.22 1.36a11.1 11.1 0 0 0 3.28 2.39 10.5 10.5 0 0 0 3.75.81c.46-.6.92-1.21 1.35-1.82a9.8 9.8 0 0 1-2.85-.17"
      />
      <path
        id="San_Marino_svg__path664"
        d="M648.54 174.45c-.06 1.27.3 2.37 1.5 4.39 14.42 24.23 48.41 13.12 54.62 24.48 6 10.91-12.86 24.7-23 32.78a55 55 0 0 0 5.63 1.68l1.77.95 2.62.83c8.1-7.67 32.07-30.26 16.83-42.56-11-8.86-41.6 2.9-60-22.55Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path666"
        d="M640.11 217.46H631s1.08-8.7-.14-14.6c-1-4.76-4.79-10.23-4.79-14.24s4.34-15.28 4.34-15.28h19.43s4.16 11.27 4.16 15.28-3.6 9.48-4.59 14.24c-1.22 5.9-.14 14.6-.14 14.6Z"
      />
      <path
        id="San_Marino_svg__path668"
        d="M640.11 217.46H631s1.08-8.7-.14-14.6c-1-4.76-4.79-10.23-4.79-14.24s4.34-15.28 4.34-15.28h19.43s4.16 11.27 4.16 15.28-3.6 9.48-4.59 14.24c-1.22 5.9-.14 14.6-.14 14.6Z"
        className="San_Marino_svg__cls-13"
      />
      <path
        id="San_Marino_svg__path670"
        d="M640.11 217.46H631s1.4-8.69.27-14.6c-.92-4.8-4.17-8.53-4.6-13.41-.61-6.88 5.4-16.11 5.4-16.11h16.12s5.79 9.23 5.18 16.11c-.42 4.88-3.47 8.61-4.39 13.41-1.13 5.91.27 14.6.27 14.6Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path672"
        d="M626.63 187.72a5.4 5.4 0 0 1 1.76-.34 3.23 3.23 0 0 1 2.79 1.31 33.5 33.5 0 0 1 17.85 0 3.24 3.24 0 0 1 2.8-1.31 5.3 5.3 0 0 1 1.55.27 13.5 13.5 0 0 1 0 1.8c-.43 4.88-3.48 8.61-4.4 13.41a39.2 39.2 0 0 0-.3 9.42l-8.55 4.07-8.56-4.07a39.2 39.2 0 0 0-.3-9.42c-.92-4.8-4.17-8.53-4.6-13.41a12.5 12.5 0 0 1 0-1.73Z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path674"
        d="M631.79 217.46a66.6 66.6 0 0 0 1.65-15.83 28.7 28.7 0 0 0-1.09-5.39c-.55-2-1.19-4.05-1.59-5.3-1.18-3.75-.24-8.19 1-11.68a37.5 37.5 0 0 1 2.69-5.92h1.79c-.55.9-6.19 10.44-3.73 17.49.91 2.59 2.67 8 2.71 10.79.06 4.59-1.62 11.42-3.07 15.84Z"
      />
      <path
        id="San_Marino_svg__path676"
        d="M649.46 190.94c-.4 1.25-1 3.27-1.59 5.3a28.6 28.6 0 0 0-1.09 5.39 66 66 0 0 0 1.66 15.83h-.37c-1.45-4.43-3.13-11.24-3.07-15.84 0-2.79 1.81-8.2 2.71-10.79a11.88 11.88 0 0 0 .12-8.77c-.93-2.52-2.5-5-3.79-8.67h1.73c1.32 3.59 2.81 6.11 3.69 8.66a13.08 13.08 0 0 1 0 8.94Z"
      />
      <path
        id="San_Marino_svg__path678"
        d="M640.11 217.46H631s1.4-8.69.27-14.6c-.92-4.8-4.17-8.53-4.6-13.41-.61-6.88 5.4-16.11 5.4-16.11h16.12s5.79 9.23 5.18 16.11c-.42 4.88-3.47 8.61-4.39 13.41-1.13 5.91.27 14.6.27 14.6Z"
        className="San_Marino_svg__cls-13"
      />
      <path
        id="San_Marino_svg__path680"
        d="M650.84 123a4.3 4.3 0 0 1 4.1 4.48c0 2.38-1.73 4.7-4.1 4.7-3.09 0-7.58-3.66-7.43-.74l.08 1.47 1.64 13.53c4 .91-14.08.91-10 0l1.65-13.59.07-1.41c.15-2.91-4.46.74-7.43.74-2.37 0-4.1-2.32-4.1-4.7a4.3 4.3 0 0 1 4.1-4.48c2.33 0 4.91 2.17 6.56 1.15 2.61-1.61-.53-5.21-.53-7.65s2.33-4.3 4.71-4.3 4.7 1.93 4.7 4.3-3.16 5.94-.53 7.65c1.57 1 4.15-1.15 6.56-1.15Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path682"
        d="M650.13 123.51a4 4 0 1 1 0 8c-2.21 0-7.65-3.87-7.52-.92l.07 1.58.93 13.05c3.77.85-10.78.85-7 0l.94-13.11.07-1.52c.13-2.95-5.48.92-7.52.92a4 4 0 1 1 0-8c2.18 0 5.17 1.86 6.71.91 2.43-1.5-.91-5-.91-7.3a4.23 4.23 0 0 1 8.45 0c0 2.27-3.36 5.7-.91 7.3 1.46 1 4.46-.91 6.71-.91Z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path684"
        d="M641.68 124.18a2.65 2.65 0 0 1 .89-1.88 1.92 1.92 0 0 0 .85 2.12c1.47 1 4.45-.91 6.71-.91a4.36 4.36 0 0 1 3.56 1.91c-.87 1.39-3.14 2.38-5.81 2.38-3.42 0-6.2-1.62-6.2-3.62"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path686"
        d="M637.33 124a1.45 1.45 0 0 1 .29.84c0 1.47-2.54 2.66-5.66 2.66-2.62 0-4.83-.84-5.47-2a4.33 4.33 0 0 1 3.59-2c2.18 0 5.17 1.86 6.71.91a2.1 2.1 0 0 0 .54-.41"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path688"
        d="M636.65 117.15a3.2 3.2 0 0 1-.61-1.08 4.4 4.4 0 0 1 4.07-3.16 4.1 4.1 0 0 1 2.27.72c-.15.48-1.23.58-2.25 1.44-1.46 1.22-2.25 3.55-3.48 2.08"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path690"
        d="M650.13 123.51a4 4 0 1 1 0 8c-2.21 0-7.65-3.87-7.52-.92l.07 1.58.93 13.05c3.77.85-10.78.85-7 0l.94-13.11.07-1.52c.13-2.95-5.48.92-7.52.92a4 4 0 1 1 0-8c2.18 0 5.17 1.86 6.71.91 2.43-1.5-.91-5-.91-7.3a4.23 4.23 0 0 1 8.45 0c0 2.27-3.36 5.7-.91 7.3 1.46 1 4.46-.91 6.71-.91Zm-21.08 26.7a11.06 11.06 0 1 1 11.06 11.06 11 11 0 0 1-11.06-11.06"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path692"
        d="M630.08 150.21a10 10 0 1 1 10 10 10 10 0 0 1-10-10"
        style={{
          fill: "#f1f1f1",
        }}
      />
      <path
        id="San_Marino_svg__path694"
        d="M640.71 158.6a.12.12 0 0 1-.11-.09.2.2 0 0 1 0-.12l.08-.1.32-.29c.24-.27.57-.65.93-1.09a10.4 10.4 0 0 0 1.81-3.05c.24-.76 1-.41.86.25a10.6 10.6 0 0 1-1.67 3.27 3.2 3.2 0 0 1-1.64 1.24h-.6Zm-10.63-8.39v.55a.56.56 0 0 0 .26-.1l.63-.54a6.4 6.4 0 0 1 .88-.6.42.42 0 1 0-.41-.73 11.5 11.5 0 0 0-1.35.78v.64Zm.2 2a11 11 0 0 0 .3 1.13.5.5 0 0 0 .25-.15c.77-.82 2.06-2 2.26-2.19a.44.44 0 0 0-.55-.68 18 18 0 0 0-1.62 1.29c-.27.24-.49.46-.64.6m.8 2.35a10 10 0 0 0 .49.9.6.6 0 0 0 .19-.1 30.5 30.5 0 0 0 3.29-3c.46-.49-.07-1.17-.61-.67-.26.27-2.36 2.14-3.35 2.9Zm14.11 3.44a.5.5 0 0 1-.73-.68l.32-.26a8 8 0 0 0 .68-.67 5.1 5.1 0 0 0 1.25-2.32c.07-.33.3-.49.54-.44a.51.51 0 0 1 .34.61 5.8 5.8 0 0 1-1.33 2.72 7 7 0 0 1-1.07 1.04m-6.94.11H638l-.35-.09a.85.85 0 0 1-.31-.21.31.31 0 0 1 0-.39 32 32 0 0 0 3.53-4.76.48.48 0 0 1 .61-.21.45.45 0 0 1 .16.64 20 20 0 0 1-2.16 3.46c-.73.93-1.27 1.56-1.27 1.56Zm-4.21-.72a.63.63 0 0 1-.8 0 .5.5 0 0 1 0-.75 32 32 0 0 0 3.94-3.87c.37-.45 1.18-.1.72.58a17 17 0 0 1-2.35 2.73Z"
      />
      <path
        id="San_Marino_svg__path696"
        d="M630.08 150.21a10 10 0 1 1 10 10 10 10 0 0 1-10-10"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path698"
        d="M648.18 173.34h-16.13c-1.36 2.31-5.67 3.87-9.2 2a6.46 6.46 0 0 1-3-4.29s6.75.25 6.79-5.72 3.48-10 8.48-9.42a8.72 8.72 0 0 1 5 2.59 8.8 8.8 0 0 1 5-2.59c5-.59 8.47 3.36 8.47 9.37s6.79 5.78 6.79 5.78a6.45 6.45 0 0 1-3 4.28c-3.54 1.85-7.88.26-9.18-2Z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path700"
        d="M648.18 173.34h-16.13c-1.36 2.31-5.67 3.87-9.2 2a6.46 6.46 0 0 1-3-4.29s6.75.25 6.79-5.72 3.48-10 8.48-9.42a8.72 8.72 0 0 1 5 2.59 8.8 8.8 0 0 1 5-2.59c5-.59 8.47 3.36 8.47 9.37s6.79 5.78 6.79 5.78a6.45 6.45 0 0 1-3 4.28c-3.54 1.85-7.88.26-9.18-2Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__line702"
        d="M688.33 280.81h-.01"
        style={{
          fill: "none",
          stroke: "#fff",
        }}
      />
      <path
        id="San_Marino_svg__path704"
        d="M585.15 271.61c0-10 23.83-17.05 54.92-17.05s54.92 7 54.92 17.05c0 8-23.84 14.44-54.92 14.44s-54.92-6.42-54.92-14.44"
      />
      <path
        id="San_Marino_svg__path706"
        d="M585.15 271.61c0-10 23.83-17.05 54.92-17.05s54.92 7 54.92 17.05c0 8-23.84 14.44-54.92 14.44s-54.92-6.42-54.92-14.44Z"
        className="San_Marino_svg__cls-13"
      />
      <path
        id="San_Marino_svg__path708"
        d="M587 271.61c0-10 22-16.43 53.08-16.43s53.09 6.4 53.09 16.43c0 8-22 14-53.09 14s-53.08-5.98-53.08-14"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path710"
        d="M587 271.61c0-10 22-16.43 53.08-16.43s53.09 6.4 53.09 16.43c0 8-22 14-53.09 14s-53.08-5.98-53.08-14Z"
        className="San_Marino_svg__cls-13"
      />
      <path
        id="San_Marino_svg__path712"
        d="M591 273.11c0-6.92 20.83-12.53 49.07-12.53s49.08 5.61 49.08 12.53-20.83 12.54-49.08 12.54S591 280 591 273.11"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path714"
        d="M688.72 274.8c-9.19 3.93-27.26 6-48.65 6s-39.47-2.11-48.66-6a3.84 3.84 0 0 1-.42-1.69c0-6.92 20.83-12.53 49.08-12.53 28.24 0 49.07 5.61 49.07 12.53a3.7 3.7 0 0 1-.42 1.69"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path716"
        d="M688.72 274.8c-9.19 3.93-27.26 6-48.65 6s-39.47-2.11-48.66-6"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path718"
        d="M687.9 270.24c-9.41 3.59-27 5.38-47.83 5.38s-38.43-1.79-47.84-5.38c4.86-5.54 23.63-9.66 47.84-9.66s42.93 4.12 47.83 9.66"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path720"
        d="M687.9 270.24c-9.41 3.59-27 5.38-47.83 5.38s-38.43-1.79-47.84-5.38"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path722"
        d="M683.3 267.07c-10 2.9-25.47 4.54-43.23 4.54s-33.24-1.64-43.24-4.54c8.1-3.87 23.94-6.49 43.24-6.49s35.14 2.62 43.23 6.49"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path724"
        d="M683.3 267.07c-10 2.9-25.47 4.54-43.23 4.54s-33.24-1.64-43.24-4.54"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path726"
        d="M676.66 264.65c-9.65 1.9-22.39 3-36.59 3s-27-1.05-36.59-3c8.8-2.5 21.66-4.07 36.59-4.07s27.78 1.57 36.59 4.07"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path728"
        d="M676.66 264.65c-9.65 1.9-22.39 3-36.59 3s-27-1.05-36.59-3"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path730"
        d="M665.47 262.31a252.8 252.8 0 0 1-50.81 0 173 173 0 0 1 25.41-1.73 173 173 0 0 1 25.4 1.73"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path732"
        d="M665.47 262.31a252.8 252.8 0 0 1-50.81 0"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path734"
        d="M591 273.11c0-6.92 20.83-12.53 49.07-12.53s49.08 5.61 49.08 12.53-20.83 12.54-49.08 12.54S591 280 591 273.11"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path736"
        d="M659.18 247.22A2 2 0 1 0 657 249a2 2 0 0 0 2.18-1.78m4.64 4.43a2 2 0 1 0-2.17 1.82 2 2 0 0 0 2.17-1.82m4.74-3.56a2 2 0 0 0-1.82-2.17 1.83 1.83 0 0 0-2 1.82 1.86 1.86 0 0 0 1.62 2.18 2 2 0 0 0 2.17-1.83Zm-4-4.43a2 2 0 1 0-2.17 1.82 2 2 0 0 0 2.13-1.82Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path738"
        d="M659.06 247.74A2 2 0 1 0 657 249a2 2 0 0 0 2.06-1.26m1.59-3.55a2 2 0 0 0 1.7 1.29 1.39 1.39 0 1 0-1.7-1.29m4.21 4.46a1.72 1.72 0 0 0 1.53 1.27 1.4 1.4 0 1 0 .35-2.6 1.76 1.76 0 0 0-1.88 1.33m-4.92 3.52a2 2 0 0 0 1.71 1.3 1.39 1.39 0 1 0 .35-2.59 2 2 0 0 0-2.06 1.29"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path740"
        d="M659.18 247.22A2 2 0 1 0 657 249a2 2 0 0 0 2.18-1.78m4.64 4.43a2 2 0 1 0-2.17 1.82 2 2 0 0 0 2.17-1.82m4.74-3.56a2 2 0 0 0-1.82-2.17 1.83 1.83 0 0 0-2 1.82 1.86 1.86 0 0 0 1.62 2.18 2 2 0 0 0 2.17-1.83Zm-4-4.43a2 2 0 1 0-2.17 1.82 2 2 0 0 0 2.13-1.82Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path742"
        d="M635.09 192.82a4.92 4.92 0 1 1 4.92 4.92 4.91 4.91 0 0 1-4.92-4.92"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path744"
        d="M635.09 192.82a4.92 4.92 0 1 1 4.92 4.92 4.91 4.91 0 0 1-4.92-4.92"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path746"
        d="M635.46 182.7c0-1.68 2-3.47 4.55-3.47s4.55 1.79 4.55 3.47-2 3.22-4.55 3.22-4.55-1.53-4.55-3.22"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path748"
        d="M635.46 182.7c0-1.68 2-3.47 4.55-3.47s4.55 1.79 4.55 3.47-2 3.22-4.55 3.22-4.55-1.53-4.55-3.22"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path750"
        d="M591.41 273.11c0-6.92 20.41-12.14 48.66-12.14s48.66 5.22 48.66 12.14-20.42 12.12-48.66 12.12-48.66-5.23-48.66-12.12"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path752"
        d="m607.18 252.34-.8-4.78-3.21-1.62s-3.46.94-5.62 1.71-5.62 2.31-5.62 2.31l-.8 1.4 1 5.41 1.8 1.6 12-3.61 1.21-2.42Z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path754"
        d="m607.18 252.34-.8-4.78-3.21-1.62s-3.46.94-5.62 1.71-5.62 2.31-5.62 2.31l-.8 1.4 1 5.41 1.8 1.6 12-3.61 1.21-2.42Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__line756"
        d="m606.94 252.34-2.77-.59"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__polygon758"
        d="m593.93 255.81 9.64-3.06.6-.99-.84-5.01-.34-.34-10.71 3.92.82 4.54z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__polyline760"
        d="m593.93 255.81 9.64-3.06.6-.99-.64-4.01"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path762"
        d="m673 252.34.8-4.78 3.22-1.62s3.46.94 5.61 1.71 5.57 2.35 5.57 2.35l.8 1.4-1 5.41-1.8 1.6-12-3.61z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path764"
        d="m673 252.34.8-4.78 3.22-1.62s3.46.94 5.61 1.71 5.57 2.35 5.57 2.35l.8 1.4-1 5.41-1.8 1.6-12-3.61z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__line766"
        d="m674.09 254.36 2.48-1.6"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__polygon768"
        d="m686.21 255.81-9.64-3.06-.6-.99.83-5.01.34-.34 10.71 3.92-.81 4.54z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__polyline770"
        d="m686.21 255.81-9.64-3.06-.6-.99.63-4.01"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path772"
        d="M621 247.22a2 2 0 1 1 2.17 1.82 2 2 0 0 1-2.17-1.82m-4.65 4.43a2 2 0 1 1 2.18 1.82 2 2 0 0 1-2.18-1.82m-4.74-3.56a2 2 0 0 1 1.82-2.17 1.82 1.82 0 0 1 2 1.82 1.86 1.86 0 0 1-1.62 2.18 2 2 0 0 1-2.17-1.83Zm4-4.43a2 2 0 1 1 2.17 1.82 2 2 0 0 1-2.17-1.82"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path774"
        d="M621.07 247.74a2 2 0 0 1 1.71-1.29 1.39 1.39 0 1 1 .35 2.59 2 2 0 0 1-2.06-1.3m-5.34-3.55a2 2 0 0 0 2 1.29 2 2 0 0 0 1.71-1.3 2 2 0 0 0-3.76 0Zm-4 4.43a2 2 0 0 0 2 1.3 1.73 1.73 0 0 0 1.53-1.26 1.76 1.76 0 0 0-1.88-1.34 2 2 0 0 0-1.69 1.3Zm4.74 3.55a2 2 0 0 0 2.05 1.3 2 2 0 0 0 1.71-1.3 2 2 0 0 0-3.76 0"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path776"
        d="M621 247.22a2 2 0 1 1 2.17 1.82 2 2 0 0 1-2.17-1.82m-4.65 4.43a2 2 0 1 1 2.18 1.82 2 2 0 0 1-2.18-1.82m-4.74-3.56a2 2 0 0 1 1.82-2.17 1.82 1.82 0 0 1 2 1.82 1.86 1.86 0 0 1-1.62 2.18 2 2 0 0 1-2.17-1.83Zm4-4.43a2 2 0 1 1 2.17 1.82 2 2 0 0 1-2.17-1.82"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path778"
        d="M579.64 252.23c-4.81-6.41-9.11-10.77-19.54-14.45a17.8 17.8 0 0 1 6.4-2.8 15.8 15.8 0 0 1 10.63.92c-2.07-7.41 1.91-14.8 1.91-14.8A20.62 20.62 0 0 1 592 226c.21-9 2.84-13.23 2.84-13.23s6.76.32 13.68 7.2c1.32-9.28 6.33-14.32 6.33-14.32A24.82 24.82 0 0 1 627.89 217c3.17-12.71 12.21-17.68 12.21-17.68s9.06 5 12.22 17.68a24.82 24.82 0 0 1 13.06-11.37s5 4.85 6.33 14.32c6.92-6.88 13.68-7.2 13.68-7.2S688 217 688.24 226a16.2 16.2 0 0 1 13.58-3.28 18.5 18.5 0 0 1 1.26 13.22 15.8 15.8 0 0 1 10.63-.92 17.8 17.8 0 0 1 6.4 2.8c-9.34 3.39-14.93 8-19.75 14.45-4.51-9.21-28.62-19.33-60.26-19.33s-56 10.12-60.46 19.33Z"
      />
      <path
        id="San_Marino_svg__path780"
        d="M579.64 252.23c-4.81-6.41-9.11-10.77-19.54-14.45a17.8 17.8 0 0 1 6.4-2.8 15.8 15.8 0 0 1 10.63.92c-2.07-7.41 1.91-14.8 1.91-14.8A20.62 20.62 0 0 1 592 226c.21-9 2.84-13.23 2.84-13.23s6.76.32 13.68 7.2c1.32-9.28 6.33-14.32 6.33-14.32A24.82 24.82 0 0 1 627.89 217c3.17-12.71 12.21-17.68 12.21-17.68s9.06 5 12.22 17.68a24.82 24.82 0 0 1 13.06-11.37s5 4.85 6.33 14.32c6.92-6.88 13.68-7.2 13.68-7.2S688 217 688.24 226a16.2 16.2 0 0 1 13.58-3.28 18.5 18.5 0 0 1 1.26 13.22 15.8 15.8 0 0 1 10.63-.92 17.8 17.8 0 0 1 6.4 2.8c-9.34 3.39-14.93 8-19.75 14.45-4.51-9.21-28.62-19.33-60.26-19.33s-56 10.12-60.46 19.33Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path782"
        d="M579.64 251.2a34.35 34.35 0 0 0-16.23-13.57c1.43-1.16 4-1.6 6.61-1.78a15.6 15.6 0 0 1 7.93 1.27c-2.07-7.41 1.29-15 1.29-15a23.15 23.15 0 0 1 13.14 5.26c.22-9 3.06-13.42 3.06-13.42s6.34.7 13.26 7.58a29.6 29.6 0 0 1 6.34-14.5 24.72 24.72 0 0 1 13.06 11.36c3.16-12.7 12-17.24 12-17.24s8.85 4.54 12 17.24a24.7 24.7 0 0 1 13.06-11.35s5 4.69 6.33 14.5c6.92-6.88 13.26-7.58 13.26-7.58s2.85 4.45 3.06 13.42a18.5 18.5 0 0 1 14-3.81 22.57 22.57 0 0 1 .47 13.54 15.6 15.6 0 0 1 7.93-1.27c2.66.18 5.18.62 6.61 1.78a34.35 34.35 0 0 0-16.23 13.57c-4.51-9.21-28.83-18.49-60.47-18.49s-56 9.28-60.46 18.49Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path784"
        d="M587.56 239.19c-1-2.21-2.81-5.74-2.81-5.74s0-.1.09 0 2.26 3.2 3.54 5.19c.68 1.08 1.62 2.45 2.35 3.5q-.74.35-1.41.72c-.55-1.1-1.25-2.52-1.76-3.63Z"
      />
      <path
        id="San_Marino_svg__path786"
        d="M587.56 239.19c-1-2.21-2.81-5.74-2.81-5.74s0-.1.09 0 2.26 3.2 3.54 5.19c.68 1.08 1.62 2.45 2.35 3.5m-1.41.72c-.55-1.1-1.25-2.52-1.76-3.63"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path788"
        d="M619.18 227.38c-.52-3-.82-4.72-1.39-7.73a.06.06 0 0 1 .11 0c1 2.92 1.52 4.57 2.38 7.53.61 2.11 1.38 5.11 1.76 6.61l-1.79.22c-.22-1.38-.71-4.45-1.07-6.6Z"
      />
      <path
        id="San_Marino_svg__path790"
        d="M619.18 227.38c-.52-3-.82-4.72-1.39-7.73a.06.06 0 0 1 .11 0c1 2.92 1.52 4.57 2.38 7.53.61 2.11 1.38 5.11 1.76 6.61m-1.79.22c-.22-1.38-.71-4.45-1.07-6.6"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path792"
        d="M602.63 230.7c-1-2.38-2.68-6-2.68-6a.05.05 0 1 1 .09-.05s2.38 3.6 3.69 6c1.11 2 2.53 5.21 2.83 5.89l-.83.21H605c-.05 0-1.38-3.73-2.34-6.05Z"
      />
      <path
        id="San_Marino_svg__path794"
        d="M602.63 230.7c-1-2.38-2.68-6-2.68-6a.05.05 0 1 1 .09-.05s2.38 3.6 3.69 6c1.11 2 2.53 5.21 2.83 5.89m-.83.21H605c-.05 0-1.38-3.73-2.34-6.05"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path796"
        d="M658.17 233.76c.38-1.5 1.15-4.5 1.76-6.61.86-3 1.38-4.61 2.39-7.52a.05.05 0 1 1 .1 0c-.57 3-.87 4.71-1.39 7.73-.36 2.15-.85 5.22-1.07 6.6l-1.79-.22Z"
      />
      <path
        id="San_Marino_svg__path798"
        d="M658.17 233.76c.38-1.5 1.15-4.5 1.76-6.61.86-3 1.38-4.61 2.39-7.52a.05.05 0 1 1 .1 0c-.57 3-.87 4.71-1.39 7.73-.36 2.15-.85 5.22-1.07 6.6"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path800"
        d="M673.65 236.54c.3-.68 1.73-3.85 2.83-5.89 1.32-2.42 3.69-6 3.69-6a.05.05 0 1 1 .09.05s-1.7 3.64-2.68 6-2.29 6-2.29 6h-.88l-.76-.19Z"
      />
      <path
        id="San_Marino_svg__path802"
        d="M673.65 236.54c.3-.68 1.73-3.85 2.83-5.89 1.32-2.42 3.69-6 3.69-6a.05.05 0 1 1 .09.05s-1.7 3.64-2.68 6-2.29 6-2.29 6h-.88"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path804"
        d="M692.46 239.19c1-2.21 2.81-5.74 2.81-5.74s-.06-.1-.1 0-2.26 3.2-3.53 5.19c-.68 1.05-1.59 2.39-2.3 3.42l1.4.71c.54-1.08 1.22-2.46 1.72-3.54Z"
      />
      <path
        id="San_Marino_svg__path806"
        d="M692.46 239.19c1-2.21 2.81-5.74 2.81-5.74s-.06-.1-.1 0-2.26 3.2-3.53 5.19c-.68 1.05-1.59 2.39-2.3 3.42m1.4.71c.54-1.08 1.22-2.46 1.72-3.54"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path808"
        d="M579.64 251.2a34.35 34.35 0 0 0-16.23-13.57c1.43-1.16 4-1.6 6.61-1.78a15.6 15.6 0 0 1 7.93 1.27c-2.07-7.41 1.29-15 1.29-15a23.15 23.15 0 0 1 13.14 5.26c.22-9 3.06-13.42 3.06-13.42s6.34.7 13.26 7.58a29.6 29.6 0 0 1 6.34-14.5 24.72 24.72 0 0 1 13.06 11.36c3.16-12.7 12-17.24 12-17.24s8.85 4.54 12 17.24a24.7 24.7 0 0 1 13.06-11.35s5 4.69 6.33 14.5c6.92-6.88 13.26-7.58 13.26-7.58s2.85 4.45 3.06 13.42a18.5 18.5 0 0 1 14-3.81 22.57 22.57 0 0 1 .47 13.54 15.6 15.6 0 0 1 7.93-1.27c2.66.18 5.18.62 6.61 1.78a34.35 34.35 0 0 0-16.23 13.57c-4.51-9.21-28.83-18.49-60.47-18.49s-56 9.28-60.46 18.49Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__polygon810"
        d="M630.47 249.07v-5.19l3.02-2.82h13.24l3.02 2.82v5.19l-3.02 2.62h-13.24z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__polygon812"
        d="m646.99 241.67-1.07 1.09v4.96l-.84.83-10.02-.07-.83-.83v-4.77l-.9-1.21z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__polygon814"
        d="M630.47 249.07v-5.19l3.02-2.82h13.24l3.02 2.82v5.19l-3.02 2.62h-13.24z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path816"
        d="m631.28 248.85 3-1.13m14.66 1.21-3-1.22m-12.07 3.64 1.2-2.8m11.23 2.8-1.2-2.8m.84-5.79v5l-.84.84-10-.07-.83-.83v-5"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path818"
        d="M577.29 254.09c0-11.68 27.88-21.59 62.77-21.59s61.75 10.31 61.75 20.56c0 2.45-2.17 4.57-5 6.36a7.1 7.1 0 0 0 .41-2.35c0-10.25-22.23-18.55-57.13-18.55s-57.12 8.3-57.12 18.55a6.9 6.9 0 0 0 .42 2.35c-2.87-1.79-6.07-2.87-6.07-5.33Z"
      />
      <path
        id="San_Marino_svg__path820"
        d="M577.29 254.09c0-11.68 27.88-21.59 62.77-21.59s61.75 10.31 61.75 20.56c0 2.45-2.17 4.57-5 6.36a7.1 7.1 0 0 0 .41-2.35c0-10.25-22.23-18.55-57.13-18.55s-57.12 8.3-57.12 18.55a6.9 6.9 0 0 0 .42 2.35c-2.87-1.79-6.07-2.87-6.07-5.33Z"
        className="San_Marino_svg__cls-13"
      />
      <path
        id="San_Marino_svg__path822"
        d="M588.78 258.45c-.45-2.55-2.65-4.59-4.34-4.29s-4.1 2.83-3.65 5.37 3.62 4.39 5.32 4.09 3.12-2.63 2.67-5.17"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path824"
        d="M587.84 258.51c-.38-2.2-1.89-3.78-3.35-3.52a4 4 0 0 0-2.77 4.45c.39 2.2 2.74 3.8 4.21 3.54s2.3-2.27 1.91-4.47"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path826"
        d="M586 255.32a3.2 3.2 0 0 1-4 4.83 4 4 0 0 1-.2-.71 4 4 0 0 1 2.76-4.45h.32a2.2 2.2 0 0 1 1.16.36Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path828"
        d="M587.84 258.51c-.38-2.2-1.89-3.78-3.35-3.52a4 4 0 0 0-2.77 4.45c.39 2.2 2.74 3.8 4.21 3.54s2.3-2.27 1.91-4.47"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path830"
        d="M691.23 258.45c.45-2.55 2.65-4.59 4.34-4.29s4.11 2.83 3.66 5.37-3.63 4.39-5.32 4.09-3.12-2.62-2.68-5.17"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path832"
        d="M692.17 258.51c.39-2.2 1.89-3.78 3.36-3.52a4 4 0 0 1 2.76 4.45c-.39 2.2-2.74 3.8-4.2 3.54s-2.31-2.27-1.92-4.47"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path834"
        d="M693.3 257.39a3.2 3.2 0 0 1 .76-2.07 2.15 2.15 0 0 1 1.15-.35 2 2 0 0 1 .32 0 4 4 0 0 1 2.76 4.45 3.2 3.2 0 0 1-.2.71 3.19 3.19 0 0 1-4.79-2.76Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path836"
        d="M692.17 258.51c.39-2.2 1.89-3.78 3.36-3.52a4 4 0 0 1 2.76 4.45c-.39 2.2-2.74 3.8-4.2 3.54s-2.31-2.27-1.92-4.47"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path838"
        d="M588.78 258.45c-.45-2.55-2.65-4.59-4.34-4.29s-4.1 2.83-3.65 5.37 3.62 4.39 5.32 4.09 3.12-2.63 2.67-5.17"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path840"
        d="M587.84 258.51c-.38-2.2-1.89-3.78-3.35-3.52a4 4 0 0 0-2.77 4.45c.39 2.2 2.74 3.8 4.21 3.54s2.3-2.27 1.91-4.47"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path842"
        d="M586 255.32a3.2 3.2 0 0 1-4 4.83 4 4 0 0 1-.2-.71 4 4 0 0 1 2.76-4.45h.32a2.2 2.2 0 0 1 1.16.36Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path844"
        d="M587.84 258.51c-.38-2.2-1.89-3.78-3.35-3.52a4 4 0 0 0-2.77 4.45c.39 2.2 2.74 3.8 4.21 3.54s2.3-2.27 1.91-4.47"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path846"
        d="M588.78 258.45c-.45-2.55-2.65-4.59-4.34-4.29s-4.1 2.83-3.65 5.37 3.62 4.39 5.32 4.09 3.12-2.63 2.67-5.17"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path848"
        d="M587.84 258.51c-.38-2.2-1.89-3.78-3.35-3.52a4 4 0 0 0-2.77 4.45c.39 2.2 2.74 3.8 4.21 3.54s2.3-2.27 1.91-4.47"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path850"
        d="M586 255.32a3.2 3.2 0 0 1-4 4.83 4 4 0 0 1-.2-.71 4 4 0 0 1 2.76-4.45h.32a2.2 2.2 0 0 1 1.16.36Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path852"
        d="M587.84 258.51c-.38-2.2-1.89-3.78-3.35-3.52a4 4 0 0 0-2.77 4.45c.39 2.2 2.74 3.8 4.21 3.54s2.3-2.27 1.91-4.47"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path854"
        d="m672.39 252.39.87-5.2 3.42-1.69s3.7 1 6 1.83 6 2.46 6 2.46l.86 1.5-1.07 5.8-1.93 1.72-12.87-3.81-1.28-2.56Zm-42.57-8.72 3.2-3h14.17l3.2 3v5.62l-3.21 2.78H633l-3.2-2.78v-5.62Zm-22.08 8.72-.86-5.2-3.42-1.69s-3.71 1-6 1.83-6 2.46-6 2.46l-.86 1.5 1.07 5.8 1.94 1.72 12.85-3.81 1.28-2.56Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path856"
        d="M634.48 192.82a5.53 5.53 0 1 1 5.53 5.53 5.53 5.53 0 0 1-5.53-5.53m.41-10.32c0-1.9 2.29-3.67 5.12-3.67s5.12 1.77 5.12 3.67-2.29 3.62-5.12 3.62-5.12-1.72-5.12-3.62"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path858"
        d="M578.93 253.06c0-8.86 26.25-19.94 61.14-19.94s61.14 11.08 61.14 19.94c0 2.45-2.74 2.7-3 1.94-2.94-9-23.27-16.9-58.16-16.9s-55.21 7.9-58.14 16.9c-.25.76-3 .51-3-1.94Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path860"
        d="M578.93 253.06c0-8.86 26.25-19.94 61.14-19.94s61.14 11.08 61.14 19.94c0 2.45-2.74 2.7-3 1.94-2.94-9-23.27-16.9-58.16-16.9s-55.21 7.9-58.14 16.9c-.25.76-3 .51-3-1.94Z"
        className="San_Marino_svg__cls-13"
      />
      <path
        id="San_Marino_svg__path862"
        d="M648.19 173.34h-.56a9.65 9.65 0 0 1-15 0h-.53s-5.65 4-9.62 1a4.87 4.87 0 0 1-1.77-2.64s6.79-.37 6.79-6.39 3.26-8.54 7.64-8.54a7.68 7.68 0 0 1 5 2.17 7.63 7.63 0 0 1 5-2.17c4.39 0 7.65 2.53 7.65 8.54s6.78 6.39 6.78 6.39a4.87 4.87 0 0 1-1.77 2.64c-4 3-9.59-1-9.59-1Z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path864"
        d="M629.66 161.5c0-2 3.37-3.74 7.91-4.21a9.2 9.2 0 0 1 2.54 1.65 9.1 9.1 0 0 1 2.52-1.65c4.54.47 7.9 2.18 7.9 4.21 0 4.81-5.51 7.14-10.44 7.14s-10.43-2.33-10.43-7.14"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path866"
        d="M628.21 161.88c-.35.85.21 3.82.21 3.82a6.54 6.54 0 0 1-1.93 4.74c-1.48 1.44-4.87 2.06-4.87 2.06M652 161.88c.35.85-.21 3.82-.21 3.82a6.54 6.54 0 0 0 1.93 4.74c1.48 1.44 4.87 2.06 4.87 2.06"
        style={{
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none",
          stroke: "#f0be2e",
        }}
      />
      <path
        id="San_Marino_svg__path868"
        d="M640 176.33c-8.4-1.91-9.49-7.11-9.26-7.05.55.13 2.49 3.93 9.39 5.85 6.89-1.92 8.83-5.72 9.38-5.85.23-.06-.86 5.14-9.25 7.05Z"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path870"
        d="M648.19 173.34h-.56a9.65 9.65 0 0 1-15 0h-.53s-5.65 4-9.62 1a4.87 4.87 0 0 1-1.77-2.64s6.79-.37 6.79-6.39 3.26-8.54 7.64-8.54a7.68 7.68 0 0 1 5 2.17 7.63 7.63 0 0 1 5-2.17c4.39 0 7.65 2.53 7.65 8.54s6.78 6.39 6.78 6.39a4.87 4.87 0 0 1-1.77 2.64c-4 3-9.59-1-9.59-1Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path872"
        d="M650.17 169.33s-1 6.74-10.06 8.74c-9.07-2-10.07-8.74-10.07-8.74s1 5.61 10.07 7.62c9.06-2.01 10.06-7.62 10.06-7.62"
      />
      <path
        id="San_Marino_svg__path874"
        d="M650.17 169.33s-1 6.74-10.06 8.74c-9.07-2-10.07-8.74-10.07-8.74s1 5.61 10.07 7.62c9.06-2.01 10.06-7.62 10.06-7.62"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path876"
        d="M639.44 224.66c.2-3.14.61-10.1.61-10.1s.1-1.1.11-1 .39 8 .58 11.12.38 8 .38 8h-2a.06.06 0 0 1-.06-.05s.22-4.9.43-8Z"
      />
      <path
        id="San_Marino_svg__path878"
        d="M639.44 224.66c.2-3.14.61-10.1.61-10.1s.1-1.1.11-1 .39 8 .58 11.12.38 8 .38 8h0-2a.06.06 0 0 1-.06-.05s.22-4.9.43-8Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path880"
        d="M638.39 298.56c18.06-.31 95.81-13.35 95.81 94.62 0 103.13-94.13 144.14-94.13 144.14s-94.14-39.73-94.14-152c0-100.11 92.46-86.76 92.46-86.76"
        style={{
          fill: "#9fcee9",
        }}
      />
      <path
        id="San_Marino_svg__path882"
        d="M668.92 459.84a38.26 38.26 0 0 1 46.49 7.23c-27.47 49.38-75.34 70.25-75.34 70.25s-46.64-19.68-74.26-70.48A38.23 38.23 0 0 1 614 461a38.24 38.24 0 0 1 54.88-1.18Z"
        style={{
          fill: "#94ba79",
        }}
      />
      <path
        id="San_Marino_svg__path884"
        d="M676.13 513.89a712 712 0 0 0-62-52.93 38.17 38.17 0 0 1 24.8-12l.51.07c13.13 1.88 25 16 20.19 18.69-3.54 2-13.68-1.28-14.21 2.64-.17 1.31 13.6 9.64 21.66 16.57A203 203 0 0 1 686 505c-3.32 3.21-6.64 6.16-9.88 8.87Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path886"
        d="M653.06 523.27c-6 3.17-10.67 5.2-13 6.18-2.33-1-7-3-13-6.18-11.61-9.41-35.54-31.36-52.38-63.27a37.47 37.47 0 0 1 18.36-4.78 17.6 17.6 0 0 1 4.46 1.44c10.59 5 23.69 19.26 18.87 22-3.55 2-13.69-1.28-14.22 2.64-.2 1.48 18.81 11.92 29.61 21.12 8.85 7.53 22.68 19.73 21.29 20.86Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path888"
        d="M685.31 455.54c4.75.55 13 5 17.05 11-3.11 5.15-9.1 13.34-12.4 17.84-7.33-10.76-22.52-25.16-21.47-24.12.15.14.79-.37 1-.48 1.46-.82 2.83-1.55 4.17-2.19a38 38 0 0 1 8.48-2.22 22 22 0 0 1 3.2.14Z"
        className="San_Marino_svg__cls-5"
      />
      <path
        id="San_Marino_svg__path890"
        d="M668.92 459.84a38.26 38.26 0 0 1 46.49 7.23m-149.6-.23A38.23 38.23 0 0 1 614 461a38.24 38.24 0 0 1 54.88-1.18"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path892"
        d="M622.92 466.66a.63.63 0 0 1 .18.8.49.49 0 0 1-.74.1c-4.78-3.4-7.12-4.82-9.89-6.56-.22-.14-.37-.37-.2-.61a1 1 0 0 1 .54-.33 2.06 2.06 0 0 1 1.52.11 79 79 0 0 1 8.59 6.49"
      />
      <path
        id="San_Marino_svg__path894"
        d="M669.44 459.25a19.5 19.5 0 0 1 3.62 4.37c.25.4 0 1.32-.75.65 0 0-1-1-3.93-3.82-4-3.86-10.8-8.74-16.47-9.69-.54-.09-.77-.36-.71-.75a.81.81 0 0 1 .95-.69c.1 0 8.47 1.6 17.29 9.93"
      />
      <path
        id="San_Marino_svg__path896"
        d="M668.92 459.84c5.51-3.07 11.86-5.44 18.62-5.44a37.85 37.85 0 0 1 28 12.49m-149.83-.3a37.72 37.72 0 0 1 27.78-12.4c7.58 0 14.64 3 20.58 6.83 7-7.51 17-13 28-13 10.48 0 20 5 26.87 11.85"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path898"
        d="M597.19 302.6h89.34m-101.27 5h112.22m-120.4 4.95h127.79m-134 4.95h139.59m-144.52 5h148.95m-153 4.95H718.5m-159.89 4.95H721.5m-165.65 4.95H724m-170.43 5h172.54m-174.43 4.95h176.21m-177.77 4.95h179.24m-180.5 4.95h181.73m-67 5h68m-183.73 0h68.51m69.36 4.8h46.69m-185.32 0h47.28m100 5h38.71m-186.53 0h39m117.23 4.95h30.79m-187.38 0h30.68m134.21 5h22.81m-187.91 0h22.8M717 386.8h17.1m-188.1 0h17.39m159.15 4.95h11.7m-188.14 0h11.32"
        style={{
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "none",
          stroke: "#4d8099",
        }}
      />
      <path
        id="San_Marino_svg__path900"
        d="M599.2 353.54c-.37-3.43-1.71-9-6.29-8.27.23 6 7.82 28.4-.85 30l-.29-.31c.11-10.19-10.07-21.31-8.09-30.18 1.31-5.84 5.73-9 11.61-9 10.74 0 12.22 13.34 4.38 18l-.47-.2Z"
      />
      <path
        id="San_Marino_svg__path902"
        d="M599.2 353.54c-.37-3.43-1.71-9-6.29-8.27.23 6 7.82 28.4-.85 30l-.29-.31c.11-10.19-10.07-21.31-8.09-30.18 1.31-5.84 5.73-9 11.61-9 10.74 0 12.22 13.34 4.38 18l-.47-.2Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path904"
        d="M646.34 346.31c-.37-3.4-1.7-9.19-6.29-8.48.24 6 7.82 28.61-.85 30.16l-.29-.31c.12-10.19-10.07-21.31-8.08-30.19 1.3-5.84 5.72-9 11.61-9 10.73 0 12.21 13.34 4.37 18l-.47-.2Z"
      />
      <path
        id="San_Marino_svg__path906"
        d="M646.34 346.31c-.37-3.4-1.7-9.19-6.29-8.48.24 6 7.82 28.61-.85 30.16l-.29-.31c.12-10.19-10.07-21.31-8.08-30.19 1.3-5.84 5.72-9 11.61-9 10.73 0 12.21 13.34 4.37 18l-.47-.2Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path908"
        d="M642.42 328.81c5.22 0 9.39 3.13 9.39 8.27 0 3.65-2.1 6.3-5.16 8.12-1.14-5.4-3.31-8.12-6.6-8.12a3.7 3.7 0 0 0-.82.09c.18 5.55 4 13.89 4 22.86 0 4.57-3 6.82-4.2 6.82 0-12.45-8.21-17.09-8.21-24.94a18.8 18.8 0 0 1 .54-4.35c.61-2.51 3.38-6.59 6.67-7.84a11.4 11.4 0 0 1 4.41-.91Z"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path910"
        d="M633.21 341a8.25 8.25 0 0 1 6-4.85c.5-.06.9.39 1.1.95H640a4 4 0 0 0-.82.1c0 .42 0 .85.1 1.29-1.13.07-3.1.53-5.1 3-.93 1.14-1.43.67-1-.47Z"
      />
      <path
        id="San_Marino_svg__path912"
        d="m633.77 341.67 5.67-2.31m-5.24 4.36 5.61-2.42m-5.15 4.58 5.6-2.64m-4.53 4.7 5-2.61m-3.35 4.51 3.93-2.23m-1.1 3.6 1.72-1"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path914"
        d="M646 334.15c-3-4.38-10.45-1.92-12.38.86-.14.2-.63-.1-.91-.21l-.1-.05a15.3 15.3 0 0 1 1.9-2.52c3.62-2.31 9.92-2.78 12.45 1.31a.55.55 0 0 1-.17.78.56.56 0 0 1-.79-.17"
      />
      <path
        id="San_Marino_svg__path916"
        d="M595.28 336c5.22 0 9.39 3.13 9.39 8.27 0 3.65-2.1 6.3-5.16 8.13-1.14-5.4-3.31-8.13-6.61-8.13a3.8 3.8 0 0 0-.82.1c.19 5.55 4 13.88 4 22.86 0 4.56-3 6.82-4.2 6.82 0-12.46-8.21-17.09-8.21-24.95a19.3 19.3 0 0 1 .53-4.34c.62-2.52 3.39-6.59 6.68-7.85a11.8 11.8 0 0 1 4.41-.91Z"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path918"
        d="M586.07 348.22a8.23 8.23 0 0 1 6-4.85c.5-.06.9.39 1.1.95h-.23a3.8 3.8 0 0 0-.82.1c0 .41 0 .85.1 1.29-1.13.07-3.1.53-5.11 3-.93 1.14-1.42.67-1-.47Z"
      />
      <path
        id="San_Marino_svg__path920"
        d="m586.63 348.91 5.67-2.32m-5.24 4.41 5.61-2.42m-5.15 4.59 5.6-2.65m-4.53 4.7 5-2.61m-3.35 4.52 3.93-2.24m-1.1 3.61 1.72-1"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path922"
        d="M598.83 341.39c-3-4.38-10.45-1.92-12.38.86-.14.2-.63-.11-.91-.22h-.1a14.8 14.8 0 0 1 1.9-2.51c3.62-2.31 9.92-2.78 12.46 1.31a.56.56 0 0 1-.18.78.58.58 0 0 1-.79-.17Z"
      />
      <path
        id="San_Marino_svg__path924"
        d="M693.48 353.54c-.37-3.39-1.7-9.19-6.29-8.48.24 6 7.82 28.61-.85 30.16l-.29-.31c.12-10.19-10.07-21.31-8.09-30.18 1.31-5.84 5.73-9 11.62-9 10.73 0 12.21 13.34 4.37 18l-.47-.2Z"
      />
      <path
        id="San_Marino_svg__path926"
        d="M693.48 353.54c-.37-3.39-1.7-9.19-6.29-8.48.24 6 7.82 28.61-.85 30.16l-.29-.31c.12-10.19-10.07-21.31-8.09-30.18 1.31-5.84 5.73-9 11.62-9 10.73 0 12.21 13.34 4.37 18l-.47-.2Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path928"
        d="M689.56 336c5.23 0 9.39 3.13 9.39 8.27 0 3.65-2.1 6.3-5.16 8.13-1.13-5.4-3.31-8.13-6.6-8.13a3.7 3.7 0 0 0-.82.1c.18 5.55 4 13.88 4 22.86 0 4.56-3 6.82-4.2 6.82 0-12.46-8.21-17.09-8.21-24.95a18.8 18.8 0 0 1 .54-4.34c.61-2.52 3.38-6.59 6.67-7.85a11.8 11.8 0 0 1 4.39-.91"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path930"
        d="M680.35 348.22a8.23 8.23 0 0 1 6-4.85c.5-.06.9.39 1.1.95h-.22a4 4 0 0 0-.83.1c0 .41 0 .85.1 1.29-1.13.07-3.1.53-5.1 3-.98 1.12-1.47.65-1.05-.49"
      />
      <path
        id="San_Marino_svg__path932"
        d="m680.92 348.91 5.67-2.32m-5.25 4.41 5.61-2.42m-5.15 4.59 5.6-2.65m-4.53 4.7 5-2.61m-3.35 4.52 3.93-2.24m-1.1 3.61 1.72-1"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path934"
        d="M693.11 341.39c-3-4.38-10.45-1.92-12.38.86-.14.2-.63-.11-.91-.22h-.1a14.8 14.8 0 0 1 1.9-2.51c3.62-2.31 9.92-2.78 12.46 1.31a.55.55 0 0 1-.18.78.58.58 0 0 1-.79-.17Z"
      />
      <path
        id="San_Marino_svg__polygon936"
        d="m582.17 395.82-.02-9.63 10.34-4.04 10.34 2.79.02 10.88z"
      />
      <path
        id="San_Marino_svg__path938"
        d="m604.3 439.62 4.52 18.6a38.28 38.28 0 0 0-32.66.93l5.16-18.78-.11-36.55-5.05-6.06V385l7-3v8l5.16-2.06v-8l4.14-1.81 4.13 1.19v8.07l5.17 1.33v-8l7 1.85v13.23l-4.52 6.72v37.1Z"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path940"
        d="M592.49 438.18v-60l-4.14 1.82v8l-5.16 2.06v-8l-7 3v12.72l5.05 6.06.12 36.54-5.17 18.79a37.8 37.8 0 0 1 16.3-4.17z"
        className="San_Marino_svg__cls-20"
      />
      <path
        id="San_Marino_svg__path942"
        d="M592.49 438.18v-60m0 76.81v-16.81"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path944"
        d="m604.3 439.62 4.52 18.6a38.28 38.28 0 0 0-32.66.93l5.16-18.78-.11-36.55-5.05-6.06V385l7-3v8l5.16-2.06v-8l4.14-1.81 4.13 1.19v8.07l5.17 1.33v-8l7 1.85v13.23l-4.52 6.72v37.1Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__polygon946"
        d="m675.22 396.03-.03-10.88 10.34-2.89 10.34 3.41.02 10.36z"
      />
      <path
        id="San_Marino_svg__polygon948"
        d="m628.7 388.59-.03-9.85 10.34-3.72 10.34 3.21.02 10.36z"
      />
      <path
        id="San_Marino_svg__path950"
        d="m650.82 432.79 4.53 18.4a38.28 38.28 0 0 0-32.67 2.89l5.17-20.95-.12-36.79-5.05-6.19v-12.86l7-2.78v8l5.17-1.85v-8.07L639 371l4.13 1.4v8.07l5.17 1.44V374l7 2.26v13.08l-4.53 6.45v37Z"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path952"
        d="M639 448.91V371l-4.13 1.61v8.06l-5.17 1.85v-8l-7 2.78v12.86l5.05 6.18.12 36.8-5.17 20.95a37.9 37.9 0 0 1 16.3-5.16Z"
        className="San_Marino_svg__cls-20"
      />
      <path
        id="San_Marino_svg__path954"
        d="M639 448.91V371m0 77.95"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path956"
        d="m650.82 432.79 4.53 18.4a38.28 38.28 0 0 0-32.67 2.89l5.17-20.95-.12-36.79-5.05-6.19v-12.86l7-2.78v8l5.17-1.85v-8.07L639 371l4.13 1.4v8.07l5.17 1.44V374l7 2.26v13.08l-4.53 6.45v37Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path958"
        d="m697.34 440 4.53 17.76a38.3 38.3 0 0 0-32.67 1.9l5.17-20.05-.12-36.75-5-6.48v-13l7-2.26v8l5.17-1.54v-8.07l4.13-1.29 4.13 1.4v8.07l5.17 1.74v-7.89l7 2.37v12.92l-4.53 6.41Z"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path960"
        d="M685.53 438.18v-60l-4.13 1.29v8.07l-5.17 1.54v-8l-7 2.26v13l5 6.48.12 36.75-5.17 20.05a37.94 37.94 0 0 1 16.33-4.62v-16.82Z"
        className="San_Marino_svg__cls-20"
      />
      <path
        id="San_Marino_svg__path962"
        d="M685.53 438.18v-60m0 76.85v-16.85"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path964"
        d="m697.34 440 4.53 17.76a38.3 38.3 0 0 0-32.67 1.9l5.17-20.05-.12-36.75-5-6.48v-13l7-2.26v8l5.17-1.54v-8.07l4.13-1.29 4.13 1.4v8.07l5.17 1.74v-7.89l7 2.37v12.92l-4.53 6.41Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path966"
        d="M600.76 426v15.58l-5-.69v-15.74c0-1.93 1.17-3.11 2.23-3.11 1.88 0 2.73 2.11 2.73 3.94Z"
      />
      <path
        id="San_Marino_svg__path968"
        d="m592.51 391.83 16.31 4m-16.31-4-16.35 5.93"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path970"
        d="m592.51 400 11.16 2.53M592.51 400l-11.3 3.83"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path972"
        d="M647.28 419v15.57l-5-.78V418c0-1.93 1.17-3 2.23-3 1.88 0 2.73 2.11 2.73 3.94Z"
      />
      <path
        id="San_Marino_svg__path974"
        d="m639 430.84-11.16 2.29M639 384.6l16.34 4.74M639 384.6l-16.33 5.55m16.33 2.61 11.16 3m-11.16-3-11.3 3.56"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path976"
        d="M693.8 426.29v15.57l-5-.78v-15.72c0-1.94 1.17-3 2.23-3 1.88 0 2.73 2.11 2.73 3.94Z"
      />
      <path
        id="San_Marino_svg__path978"
        d="m685.55 438-11.18 1.81m11.18-48 16.32 5m-16.32-5-16.35 4.59m16.35 3.6 11.16 3.25M685.55 400l-11.3 2.9M639 398.17l11.16 2.88M639 403.61l11.16 2.73M639 409.07l11.16 2.54m-11.16 2.9 11.16 2.4M639 420l11.26 2.25M639 425.4l11.37 2.11M639 398.17l-11.31 3.4m11.31 2-11.31 3.25m11.31 2.25-11.31 3.06m11.31 2.38-11.31 2.81M639 420l-11.21 2.66M639 425.4l-11.21 2.42m18.45-33V400m-4.14-.88v5.22m4.14 1.11v5.22m-10.55-6v5.22m-5-8.89v5m5-12.14V399m49.81 6.38 11.16 3m-11.16 2.46 11.16 2.83m-11.16 2.63 11.19 2.7m-11.16 2.79 11.16 2.5m-11.16 2.93 11.26 2.36m-11.26 3.1 11.37 2.11m-11.37-29.34-11.31 2.77m11.31 2.67-11.31 2.63m11.31 2.83-11.31 2.44m11.31 3L674.22 424m11.31 3.14-11.21 2.16m11.21 3.3-11.21 1.9m18.45-32.36v5.12m-4.14-1v5.22m4.14 1.21V418m-10.55-6.33v5.22m0 5.59v5.22m-5 1.29v5m0-26.22v5m5-11.94v5.22m-46.5 20.11v5.22m49.21 12.23-11.81 1.81m-42.36-28.81v5m8.08 20.39-13.71 2.63M639 442l14 1.78m-14.55-7.36-11.45 2.2m58.4 10.53-13.91 2.18m14.12-2.18 14.12 1.85"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path980"
        d="M610.05 458.13c.1.41-1 0-1.39-.15a38 38 0 0 0-32.32.91c-.4.21-1.53.58-1.41.15l6-18.73-.14-36.31-4.95-6a1.2 1.2 0 0 1-.1-.26V385a.6.6 0 0 1 .25-.38l7-3a.38.38 0 0 1 .58.38v7.37l4.34-1.72V380a.6.6 0 0 1 .25-.38l4.14-1.81a1.2 1.2 0 0 1 .27 0l4.14 1.19a.54.54 0 0 1 .3.4v7.75l4.34 1.12v-7.46a.39.39 0 0 1 .52-.4l7 1.85a.5.5 0 0 1 .31.4v13.12a2 2 0 0 1-.07.24l-4.46 6.61v36.93l5.34 18.56Zm-1.62-.61a39.72 39.72 0 0 0-31.84.85l5.13-17.9-.1-36.65-.09-.27-5-5.94v-12.29l6.2-2.64v7.37a.38.38 0 0 0 .57.38l5.17-2.06a.55.55 0 0 0 .26-.38v-7.69l3.75-1.64 3.69 1.06v7.76a.5.5 0 0 0 .31.4l5.17 1.33a.39.39 0 0 0 .52-.39v-7.47l6.2 1.63v12.69l-4.37 6.61a2 2 0 0 0-.07.24v37.1l4.55 17.9Zm48.15-6.44c.09.4-1 0-1.38-.13a38 38 0 0 0-32.31 2.86c-.4.23-1.55.61-1.44.17l6-20.9-.12-36.6-4.95-6.07a1.2 1.2 0 0 1-.1-.26v-12.86a.57.57 0 0 1 .27-.39l7-2.78a.39.39 0 0 1 .57.39v7.4l4.34-1.55v-7.77a.55.55 0 0 1 .27-.39l4.13-1.6a1.3 1.3 0 0 1 .28 0l4.14 1.4a.53.53 0 0 1 .27.39v7.76l4.35 1.2V374a.39.39 0 0 1 .54-.39l7 2.26a.53.53 0 0 1 .29.4v13.08a1 1 0 0 1-.08.24l-4.45 6.35v36.81l5.34 18.34Zm-1.61-.54a39.8 39.8 0 0 0-12.92-2.14 39.35 39.35 0 0 0-18.95 4.84l5.15-20-.11-36.89a1.3 1.3 0 0 0-.09-.26l-5-6.07v-12.45l6.2-2.45v7.38a.39.39 0 0 0 .56.39L635 381a.58.58 0 0 0 .27-.39v-7.78l3.73-1.45 3.71 1.25v7.78a.5.5 0 0 0 .3.4l5.17 1.44a.4.4 0 0 0 .53-.4v-7.33l6.2 2v12.65l-4.45 6.35a2 2 0 0 0-.08.23v37l4.62 17.79Zm48.12 7.15c.11.4-1 0-1.38-.14a38 38 0 0 0-32.31 1.88c-.4.22-1.34-.23-1.22-.67l5.82-19.17-.16-36.59-5-6.36a1.1 1.1 0 0 1-.09-.26v-13a.53.53 0 0 1 .29-.39l7-2.26a.38.38 0 0 1 .54.39v7.43l4.34-1.29v-7.76a.53.53 0 0 1 .29-.39l4.14-1.29h.25l4.14 1.39a.56.56 0 0 1 .28.4v7.77l4.34 1.47v-7.32a.39.39 0 0 1 .55-.39l7 2.36a.56.56 0 0 1 .28.4v12.92a1 1 0 0 1-.08.24l-4.45 6.3V440l5.34 17.71Zm-1.62-.58a39.74 39.74 0 0 0-31.84 1.77l5.14-19.14-.11-36.85a1.3 1.3 0 0 0-.09-.26l-5-6.36v-12.58l6.2-2v7.42a.39.39 0 0 0 .54.39l5.16-1.54a.5.5 0 0 0 .3-.4v-7.76l3.72-1.16 3.72 1.26v7.78a.54.54 0 0 0 .28.39l5.17 1.75a.39.39 0 0 0 .55-.4v-7.31l6.2 2.08v12.5L697 403a2 2 0 0 0-.08.24V440l4.55 17.08Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path982"
        d="m592.31 438-11 2.32m11.18 8.74 14.39 1.55m-14.59-1.55L579 451.93m12.92-8.25-11.83 2.41m12.39-40.66 11.16 2.36m-11.16 3.06 11.16 2.32m-11.16 3.14 11.16 2.13m-11.16 3.31 11.16 2m-11.16 3.45 11.27 1.8m-11.26 3.61 11.37 1.7m-11.37-28.91-11.32 3.66m11.32 1.76-11.32 3.45m11.32 2-11.32 3.27m11.32 2.17-11.32 3m11.32 2.41L581.28 430m11.21 2.69-11.21 2.52m18.45-33.39v5.12m-4.14-.78v5.22m4.14 1.11v5.22M589.18 412v5.22m0 5.48v5.22m-5 1.82v4.81m0-25.91v4.81m5-12.15v5.23"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path984"
        d="M599.78 352c-.87-3.83-3-8.82-7.79-8l-.32.41c.22 6.41 8.26 25.91.61 29.35-.21-11.16-10.27-18.4-7.68-28.87.71-2.9 3.61-6.5 6.42-7.56a11.7 11.7 0 0 1 4.25-.88c9.69.19 12.2 10.23 4.51 15.52Zm47.14-7.24c-.87-3.83-3-8.82-7.79-8l-.32.42c.22 6.41 8.26 25.9.61 29.34-.2-11.16-10.26-18.4-7.68-28.87.71-2.9 3.61-6.5 6.42-7.56a12 12 0 0 1 4.26-.88c9.68.21 12.19 10.25 4.5 15.53Zm47.15 7.24c-.88-3.83-3-8.82-7.8-8l-.32.41c.22 6.41 8.26 25.91.61 29.35-.2-11.16-10.27-18.4-7.68-28.87.71-2.9 3.61-6.5 6.42-7.56a11.8 11.8 0 0 1 4.26-.88c9.68.19 12.19 10.23 4.51 15.52Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path986"
        d="m604.58 281.84 28.66 13.41a9.1 9.1 0 0 1 14.27 0l28.66-13.41 1.77 42.39-30.36-18.09c-2.29 2.4-4.05 3.64-7.2 3.64s-5.21-1.51-7.21-3.64L602.61 324l2-42.19Z"
      />
      <path
        id="San_Marino_svg__path988"
        d="m604.58 281.84 28.66 13.41a9.1 9.1 0 0 1 14.27 0l28.66-13.41 1.77 42.39-30.36-18.09c-2.29 2.4-4.05 3.64-7.2 3.64s-5.21-1.51-7.21-3.64L602.61 324l2-42.19Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path990"
        d="M749.9 376.75c0-45.58-18.09-95-54-95-12.27 0-25.42 6.34-25.42 18.3s7 20.77 17.51 20.77 13.72-4.82 13.72-4.82c4.36 2.87 19.76 11.53 22 60.88 4.44 96.18-77.4 152.3-77.4 152.3S749.9 485.05 749.9 376.75"
      />
      <path
        id="San_Marino_svg__path992"
        d="M749.9 376.75c0-45.58-18.09-95-54-95-12.27 0-25.42 6.34-25.42 18.3s7 20.77 17.51 20.77 13.72-4.82 13.72-4.82c4.36 2.87 19.76 11.53 22 60.88 4.44 96.18-77.4 152.3-77.4 152.3S749.9 485.05 749.9 376.75"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path994"
        d="M749.9 376.75c0-45.58-18.09-95-54-95-12.27 0-25.42 6.34-25.42 18.3s7 20.77 17.51 20.77 14.33-6.13 14.33-6.13c4.36 2.87 20.18 12.77 22.46 62.12 4.44 96.18-78.44 152.3-78.44 152.3S749.9 485.05 749.9 376.75"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path996"
        d="M694.86 305.58c12.69 1.55 24.09 16.42 28.91 36 .11.5 0 1-.43 1.11s-.77-.15-1-.79c-5.44-21.12-16.34-32.9-27.65-34.37z"
      />
      <path
        id="San_Marino_svg__path998"
        d="M737.08 343.23c.1.52-.07 1-.51 1.08s-.77-.3-.87-.79c-6.26-29.76-21.06-51.66-44.22-51.66a32 32 0 0 0-21 7.68 16 16 0 0 1 .22-2.14 33.15 33.15 0 0 1 20.76-7.09c24.4 0 39.6 23.09 45.6 52.92Z"
      />
      <path
        id="San_Marino_svg__path1000"
        d="M732 342.52c.14.55.09 1-.4 1.13s-.75-.2-.88-.78c-6.36-27.19-20-45.84-38.93-45.84-8.15 0-15.11 2-20.86 8-.11-.63-.2-1.26-.27-1.91 5.91-5.7 12.94-7.6 21.13-7.6 20.18 0 34.21 19.92 40.21 47"
      />
      <path
        id="San_Marino_svg__path1002"
        d="M749.9 376.75c0-45.58-18.09-95-54-95-12.27 0-25.42 6.34-25.42 18.3s7 20.77 17.51 20.77 14.33-6.13 14.33-6.13c4.36 2.87 20.18 12.77 22.46 62.12 4.44 96.18-78.44 152.3-78.44 152.3S749.9 485.05 749.9 376.75"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1004"
        d="M530.23 376.75c0-45.58 18.09-95 54-95 12.26 0 25.41 6.34 25.41 18.3s-7 20.77-17.51 20.77-13.71-4.82-13.71-4.82c-4.36 2.87-19.76 11.53-22 60.88-4.44 96.18 77.4 152.3 77.4 152.3s-103.59-44.13-103.59-152.43"
      />
      <path
        id="San_Marino_svg__path1006"
        d="M530.23 376.75c0-45.58 18.09-95 54-95 12.26 0 25.41 6.34 25.41 18.3s-7 20.77-17.51 20.77-13.71-4.82-13.71-4.82c-4.36 2.87-19.76 11.53-22 60.88-4.44 96.18 77.4 152.3 77.4 152.3s-103.59-44.13-103.59-152.43"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1008"
        d="m598.79 280.76 41.59 18.07v2.06l-35.93 21.24s4.77-12.23 4-20.23c-.88-9-9.65-21.14-9.65-21.14Z"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path1010"
        d="M614.94 315.93c1-1.15 3.9-5.32 3.9-13.7m.4 11.16c.91-1.22 3.1-4.81 3.1-11.16m1.15 8.65a15.9 15.9 0 0 0 2.34-8.65m1.8 6.2a14.16 14.16 0 0 0 1.49-6.2"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1012"
        d="m598.79 280.76 41.59 18.07v2.06l-35.93 21.24s4.77-12.23 4-20.23c-.88-9-9.65-21.14-9.65-21.14Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1014"
        d="m674.09 313.49-.89-1.28c2.94-9.07 8.39-13.37 18.68-13.4 16.58.07 29.31 18.75 35.92 43.13.14.48.05 1-.38 1.08a.8.8 0 0 1-.88-.69c-6.63-24.06-19.26-41.58-34.56-41.66-9.84 0-14.83 3.59-17.89 12.82"
      />
      <path
        id="San_Marino_svg__path1016"
        d="m682 280.76-41.58 18.07v2.06l35.92 21.24s-4.77-12.23-4-20.23c.86-9.02 9.66-21.14 9.66-21.14"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path1018"
        d="M665.82 315.93c-1-1.15-3.91-5.32-3.91-13.7m-.39 11.16c-.92-1.22-3.11-4.81-3.11-11.16m-1.14 8.65a15.84 15.84 0 0 1-2.35-8.65m-1.8 6.2a14.3 14.3 0 0 1-1.49-6.2"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1020"
        d="m682 280.76-41.58 18.07v2.06l35.92 21.24s-4.77-12.23-4-20.23c.86-9.02 9.66-21.14 9.66-21.14"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1022"
        d="M530.23 376.75c0-45.58 18.09-95 54-95 12.26 0 25.41 6.34 25.41 18.3s-7 20.77-17.51 20.77-14.33-6.13-14.33-6.13c-4.36 2.87-20.18 12.77-22.46 62.12-4.44 96.18 78.44 152.3 78.44 152.3s-103.55-44.06-103.55-152.36"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path1024"
        d="M606 313.36c-3.07-9.16-8.09-12.69-17.85-12.69-12.88 0-23.49 11.7-30.49 29.4-.17.4-.47.64-.86.51s-.38-.57-.23-1c6.82-18 17.76-30.79 31.58-30.79 10.25 0 15.73 4.21 18.7 13.14-.27.49-.55 1-.85 1.41Z"
      />
      <path
        id="San_Marino_svg__path1026"
        d="M588.36 296.56c-15.38 0-27.37 13-34.93 32.05-.21.45-.52.7-.95.52s-.36-.62-.19-1c7.17-19.29 19.76-33 36.07-33a29.1 29.1 0 0 1 21.09 8.27c-.07.62-.16 1.24-.27 1.84a27.8 27.8 0 0 0-20.82-8.67Z"
      />
      <path
        id="San_Marino_svg__path1028"
        d="M588.36 291.81c-17.63 0-30.71 12.41-39.54 35.31a.9.9 0 0 1-1.05.6c-.34-.13-.38-.62-.23-1.07 8.84-23.33 22.32-36.29 40.82-36.29 8 0 15 2 20.91 6.34a16 16 0 0 1 .32 2.15c-6-4.84-13-7-21.23-7Z"
      />
      <path
        id="San_Marino_svg__path1030"
        d="M578.76 309c-7.21 4.66-13.74 13.48-17.39 22.58-.21.48-.52.62-.83.51s-.4-.51-.27-.91a53 53 0 0 1 18.05-24.26z"
      />
      <path
        id="San_Marino_svg__path1032"
        d="M530.23 376.75c0-45.58 18.09-95 54-95 12.26 0 25.41 6.34 25.41 18.3s-7 20.77-17.51 20.77-14.33-6.13-14.33-6.13c-4.36 2.87-20.18 12.77-22.46 62.12-4.44 96.18 78.44 152.3 78.44 152.3s-103.55-44.06-103.55-152.36"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1034"
        d="M632.11 300.89a8.27 8.27 0 1 1 8.27 8.27 8.27 8.27 0 0 1-8.27-8.27"
        className="San_Marino_svg__cls-8"
      />
      <path
        id="San_Marino_svg__path1036"
        d="M632.18 299a8.43 8.43 0 0 1 16-1.37m.45 5.42a8.5 8.5 0 0 1-16.15.93m10.08 2.17a5.4 5.4 0 0 1-2.17.44 5.65 5.65 0 0 1-5.65-5.43m10.51 2.66a5.6 5.6 0 0 1-2.69 2.33m-1.56-2.58a2.7 2.7 0 0 1-.58.07 2.75 2.75 0 0 1-2.73-2.47m-2.82-1.65a3.9 3.9 0 0 1 .63-1.4"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1038"
        d="M590.11 300.23a4 4 0 0 1-.05-.45v-.65s.12-.1.16-.1a.6.6 0 0 1 .23 0c6 .7 10 4.67 10.16 10.36.11 3.23-1.51 7.73-3.71 9.75a.23.23 0 0 1-.3 0l-.83-.92a.21.21 0 0 1 0-.29c1.87-1.71 3.17-5.75 3.07-8.47-.18-5.08-3.65-8.4-8.61-9a.6.6 0 0 1-.09-.23Z"
      />
      <path
        id="San_Marino_svg__path1040"
        d="M689.91 300.23v-1.1s-.11-.1-.15-.1a.6.6 0 0 0-.23 0c-6 .7-10 4.67-10.16 10.36-.12 3.23 1.5 7.73 3.71 9.75a.21.21 0 0 0 .29 0l.84-.92a.23.23 0 0 0 0-.29c-1.87-1.71-3.17-5.75-3.08-8.47.18-5.08 3.65-8.4 8.61-9a.5.5 0 0 0 .1-.23Z"
      />
      <path
        id="San_Marino_svg__path1042"
        d="M632.18 299c0-3.9 3.41-7.15 8.2-7.15 3.65 0 7.79 2.57 7.79 5.78m.45 5.42c0 3.6-4.29 6.78-8.24 6.78-3.61 0-7.91-2.62-7.91-5.85"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1044"
        d="M609 318.21a23.29 23.29 0 0 1-18.64 9.44c-9.86 0-17.38-6.14-17.38-15.94.23-5.19 3.74-11.61 12-11.61 5.39 0 10 5.2 10 10.59a9.68 9.68 0 0 1-2.4 7c7.38-2.37 12.27-6.31 12.27-14.69 0-8.59-5.7-14.75-15-15.52-31.2-2.59-50.26 32-53.94 79.9-5.23 68.27 31.59 122.7 87.57 153.78 7.81 4.34 13.94 7.8 16.59 8.93v8.49c-21.32-8.15-46-23.87-61.43-37.94-29.34-26.81-57.33-72.15-53.09-133.21 2.69-38.57 14.7-64.43 29.44-77.21 25.2-21.85 59.57-13.12 59.57 12.78a24.7 24.7 0 0 1-5.56 15.21"
      />
      <path
        id="San_Marino_svg__path1046"
        d="M609 318.21a23.29 23.29 0 0 1-18.64 9.44c-9.86 0-17.38-6.14-17.38-15.94.23-5.19 3.74-11.61 12-11.61 5.39 0 10 5.2 10 10.59a9.68 9.68 0 0 1-2.4 7c7.38-2.37 12.27-6.31 12.27-14.69 0-8.59-5.7-14.75-15-15.52-31.2-2.59-50.26 32-53.94 79.9-5.23 68.27 31.59 122.7 87.57 153.78 7.81 4.34 13.94 7.8 16.59 8.93v8.49c-21.32-8.15-46-23.87-61.43-37.94-29.34-26.81-57.33-72.15-53.09-133.21 2.69-38.57 14.7-64.43 29.44-77.21 25.2-21.85 59.57-13.12 59.57 12.78a24.7 24.7 0 0 1-5.56 15.21"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1048"
        d="M671.14 318.21a23.29 23.29 0 0 0 18.63 9.44c9.87 0 17.39-6.14 17.39-15.94-.23-5.19-3.74-11.61-12-11.61-5.39 0-10 5.2-10 10.59a9.68 9.68 0 0 0 2.4 7c-7.38-2.37-12.27-6.31-12.27-14.69 0-8.59 5.7-14.75 15-15.52 31.19-2.59 50.26 32 53.93 79.9 5.23 68.27-31.59 122.7-87.57 153.78-7.81 4.34-13.93 7.8-16.59 8.93v8.49c21.32-8.15 46-23.87 61.43-37.94 29.34-26.81 57.33-72.15 53.09-133.21-2.69-38.57-14.7-64.43-29.44-77.21-25.2-21.85-59.56-13.12-59.56 12.78a24.7 24.7 0 0 0 5.56 15.19Z"
      />
      <path
        id="San_Marino_svg__path1050"
        d="M671.14 318.21a23.29 23.29 0 0 0 18.63 9.44c9.87 0 17.39-6.14 17.39-15.94-.23-5.19-3.74-11.61-12-11.61-5.39 0-10 5.2-10 10.59a9.68 9.68 0 0 0 2.4 7c-7.38-2.37-12.27-6.31-12.27-14.69 0-8.59 5.7-14.75 15-15.52 31.19-2.59 50.26 32 53.93 79.9 5.23 68.27-31.59 122.7-87.57 153.78-7.81 4.34-13.93 7.8-16.59 8.93v8.49c21.32-8.15 46-23.87 61.43-37.94 29.34-26.81 57.33-72.15 53.09-133.21-2.69-38.57-14.7-64.43-29.44-77.21-25.2-21.85-59.56-13.12-59.56 12.78a24.7 24.7 0 0 0 5.56 15.19Z"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1052"
        d="M640.06 538c-21.31-8.15-46-24.91-61.42-39-29.34-26.8-55.47-71.11-51.23-132.18 2.69-38.56 14.08-63 28.82-75.75 25.2-21.85 57.71-11.9 57.71 11.95a23.81 23.81 0 0 1-23.79 23.8c-7.95 0-16.35-6.45-15.52-16.14a9.76 9.76 0 0 1 19.51.42c0 3-1.95 5.85-4 7.65 8.3-.3 15.57-7.35 15.57-15.73 0-8.59-6.52-15.78-15.86-16.55-31.19-2.6-51.35 32.86-54.76 80.93-4.83 68.31 32.42 123.53 88.39 154.61a172 172 0 0 0 16.63 8.11 171 171 0 0 0 16.58-8.12c56-31.08 93.23-86.3 88.39-154.61-3.4-48.07-23.56-83.53-54.76-80.93-9.33.77-15.85 8-15.85 16.55 0 8.38 7.27 15.43 15.57 15.73-2.1-1.8-4-4.67-4-7.65a9.76 9.76 0 0 1 19.51-.42c.83 9.69-7.57 16.14-15.52 16.14A23.8 23.8 0 0 1 666.2 303c0-23.85 32.5-33.8 57.7-11.95 14.74 12.78 26.13 37.19 28.81 75.75 4.29 61.09-21.88 105.4-51.22 132.2-15.41 14.07-40.11 30.83-61.43 39"
        className="San_Marino_svg__cls-9"
      />
      <path
        id="San_Marino_svg__path1054"
        d="M640.06 538c-21.31-8.15-46-24.91-61.42-39-29.34-26.8-55.47-71.11-51.23-132.18 2.69-38.56 14.08-63 28.82-75.75 25.2-21.85 57.71-11.9 57.71 11.95a23.81 23.81 0 0 1-23.79 23.8c-7.95 0-16.35-6.45-15.52-16.14a9.76 9.76 0 0 1 19.51.42c0 3-1.95 5.85-4 7.65 8.3-.3 15.57-7.35 15.57-15.73 0-8.59-6.52-15.78-15.86-16.55-31.19-2.6-51.35 32.86-54.76 80.93-4.83 68.31 32.42 123.53 88.39 154.61a172 172 0 0 0 16.63 8.11 171 171 0 0 0 16.58-8.12c56-31.08 93.23-86.3 88.39-154.61-3.4-48.07-23.56-83.53-54.76-80.93-9.33.77-15.85 8-15.85 16.55 0 8.38 7.27 15.43 15.57 15.73-2.1-1.8-4-4.67-4-7.65a9.76 9.76 0 0 1 19.51-.42c.83 9.69-7.57 16.14-15.52 16.14A23.8 23.8 0 0 1 666.2 303c0-23.85 32.5-33.8 57.7-11.95 14.74 12.78 26.13 37.19 28.81 75.75 4.29 61.09-21.88 105.4-51.22 132.2-15.41 14.07-40.11 30.83-61.43 39"
        className="San_Marino_svg__cls-4"
      />
      <path
        id="San_Marino_svg__path1056"
        d="M642.27 564.94a137.4 137.4 0 0 0 26.73-2.83c-2.07 7-6.21 20.42 10.33 20.42 12 0 24.81-7.24 37.21-.88 27.1 13.9 47.56 4 64.1-14.63a112.4 112.4 0 0 1-24.81 2.07s9.42-8 10.34-18.61c-8.28 6.2-16.55 7.11-24.82 7.11s-13.55-5-24.38-6.71c.61-3.74 1.26-7.55 2.24-12.8 1.06-5.74-.52-10.4-8.87-11.38-18.16-2.13-35.75 8.35-67.89 8.85-32.36-.5-54.54-11-72.7-8.85-8.35 1-9.93 5.64-8.87 11.38 1 5.25 1.63 9.06 2.24 12.8-10.83 1.71-16.12 6.71-24.38 6.71s-16.54-.91-24.82-7.11c.92 10.57 10.34 18.61 10.34 18.61a112.4 112.4 0 0 1-24.79-2.09c16.54 18.61 37 28.53 64.1 14.63 12.4-6.36 25.18.88 37.21.88 16.54 0 12.4-13.39 10.33-20.42a161.3 161.3 0 0 0 31.16 2.91Z"
        className="San_Marino_svg__cls-1"
      />
      <path
        id="San_Marino_svg__path1058"
        d="M558.32 572.7c-1.21.55-1.82-.22-.47-.91 1.1-.56 7.13-3.41 10.34-3.63a.83.83 0 0 1 .87.56.57.57 0 0 1-.57.74c-2.89.19-9 2.7-10.17 3.24"
      />
      <path
        id="San_Marino_svg__path1060"
        d="M600.65 572.55c-6.67-.69-15.53-3-24-3.34a.68.68 0 0 1-.71-.65.62.62 0 0 1 .72-.61c8.52.38 17.48 2.41 24.18 3.1 2.47.26 5.18-.23 6.48-1.39.39-.36 1.39 1 1 1.3-1.73 1.54-5 1.87-7.67 1.59"
      />
      <path
        id="San_Marino_svg__path1062"
        d="M582.2 576.53a39.45 39.45 0 0 0-22.39 3.47 2.1 2.1 0 0 1-.76.22c-.16 0-.41 0-.51-.18a.32.32 0 0 1 0-.3.7.7 0 0 1 .15-.22 2.6 2.6 0 0 1 .64-.44 39.2 39.2 0 0 1 23.31-3.8c6.3.71 11.83 2.07 17.86 2.53.52 0 .66.51.8.92s.35 1.06-1.53.86c-6-.63-11.43-2.06-17.56-3Z"
      />
      <path
        id="San_Marino_svg__path1064"
        d="M600.71 569.53c-3.52-.37-7.52-1.15-11.77-1.85a.66.66 0 0 1-.56-.77.66.66 0 0 1 .78-.55c4.21.68 8.19 1.47 11.69 1.83a8.45 8.45 0 0 0 3.91-.5.63.63 0 0 1 .86.38.64.64 0 0 1-.38.86 9.5 9.5 0 0 1-4.53.6"
      />
      <path
        id="San_Marino_svg__path1066"
        d="M555.16 557.51a1.3 1.3 0 0 1-.55.12.39.39 0 0 1-.38-.23.42.42 0 0 1 .1-.43 1.2 1.2 0 0 1 .43-.3 31.2 31.2 0 0 1 8.79-2.67.68.68 0 0 1 .77.39.51.51 0 0 1-.43.7 39 39 0 0 0-8.73 2.42"
      />
      <path
        id="San_Marino_svg__path1068"
        d="M555.86 561.51a1.8 1.8 0 0 1-.58.14.39.39 0 0 1-.4-.23.45.45 0 0 1 .12-.42 1.8 1.8 0 0 1 .47-.3 39 39 0 0 1 8.49-2.9.57.57 0 0 1 .74.41.6.6 0 0 1-.47.72 54 54 0 0 0-8.37 2.58"
      />
      <path
        id="San_Marino_svg__path1070"
        d="M600.7 576.24c-5.16-.53-11.25-2.09-17.71-3-8.18-1.14-15.3-.72-23.81 3.14a2.1 2.1 0 0 1-.9.24.39.39 0 0 1-.45-.27.52.52 0 0 1 .2-.47 2.2 2.2 0 0 1 .56-.37c7.92-4 16.22-4.78 24.54-3.65 6.45.88 12.6 2.23 17.75 2.77 2.89.29 6.19-.19 7.28-1.94.29-.45 1.11.53.84 1-1.65 2.64-5.49 2.88-8.3 2.58Z"
      />
      <path
        id="San_Marino_svg__path1072"
        d="M557.59 569.05c-1.2.56-1.82-.22-.47-.91a40.3 40.3 0 0 1 8.32-3.22.23.23 0 0 1 .24.13l.3.8a.19.19 0 0 1-.16.27 43 43 0 0 0-8.23 2.93"
      />
      <path
        id="San_Marino_svg__path1074"
        d="M556.89 565.12c-1.2.56-1.81-.22-.46-.91a40.7 40.7 0 0 1 8.11-2.89.2.2 0 0 1 .24.18l.11.8a.21.21 0 0 1-.17.23 41 41 0 0 0-7.83 2.59"
      />
      <path
        id="San_Marino_svg__path1076"
        d="M588.68 551.68c-2.16-.18-5.64-.38-5.64-.38l-1.26-17.18 4.18.49.87 13.41c.42 0 2.3.15 3.55.29 1.42.15 3.71.52 3.71.52l.26 3.45s-3.5-.42-5.67-.6"
      />
      <path
        id="San_Marino_svg__path1078"
        d="M628.7 557.47c-2.23-.21-5.79-.71-5.79-.71l-.16-8.24-.16-8.28 9.5 1v3.28l-5.31-.55.07 3.4 5.58.58.06 3.07-5.58-.57.06 3.49c.43.07 2.34.36 3.62.48 1.44.13 3.81.18 3.81.18l.07 3.28s-3.6-.18-5.83-.39Z"
      />
      <path
        id="San_Marino_svg__polygon1080"
        d="m666.6 542.27-5.2.72.07 13.19-4.19.58-.08-13.19-5.2.72-.02-3.27 14.61-2.02z"
      />
      <path
        id="San_Marino_svg__path1082"
        d="M691.09 551.91a10.07 10.07 0 0 1-5.35-1.07l1.15-3.07a10.5 10.5 0 0 0 4.21.7c2 0 2.94-.65 2.95-1.55 0-.6-.45-1-1.22-1.39s-1.82-.7-2.86-1.1c-2.08-.81-4.22-2-4.18-4.86.06-3.23 3.68-4.88 6.58-4.94a11.76 11.76 0 0 1 5.33 1l-1.05 3a14.2 14.2 0 0 0-4.22-.62c-1.63 0-2.58.87-2.59 1.48s.45.84 1.25 1.22 1.85.71 2.9 1.16c2.12.88 4.3 2.17 4.25 4.85-.07 3.68-3.76 5.13-7.15 5.19"
      />
      <path
        id="San_Marino_svg__path1084"
        d="m610.4 545 1.43.24c2.13.36 2.29-.37 2.28-1.27 0-1.08-.53-1.74-2.68-2.11l-1.09-.19zm.15 6.58 2 .34c2.32.4 2.88 0 2.86-1.19 0-1.34-.83-2.14-3.33-2.56l-1.59-.28.07 3.69Zm2.45 3.69-6.67-1.14-.3-16.36 6 1c4.12.7 6.34 2.5 6.4 5.61a2.9 2.9 0 0 1-1.53 2.62 5.3 5.3 0 0 1 2.85 4.3c0 3-1.79 4.79-6.75 3.94Z"
      />
      <path
        id="San_Marino_svg__polygon1086"
        d="m601.9 553.29-4.2-.65-.95-16.57 4.21.65z"
      />
      <path
        id="San_Marino_svg__path1088"
        d="M640.05 565.16c-13.8 0-22.82-2.11-35.14-4.34-28.71-5.2-34.95-1.25-34.95 3.72a1.72 1.72 0 0 0 2.54 1.58 2.9 2.9 0 0 0 1-1.16c-1 0-1.67-.41-1.46-1.66.62-3.63 8.07-5.28 32.88-1.24 12.36 2 21.36 3.72 35.15 3.72v-.62Zm0 0c13.8 0 22.81-2.11 35.14-4.34 28.71-5.2 34.95-1.25 34.95 3.72a1.72 1.72 0 0 1-2.54 1.58 2.9 2.9 0 0 1-1-1.16c1 0 1.67-.41 1.46-1.66-.61-3.63-8.07-5.28-32.88-1.24-12.36 2-21.35 3.72-35.16 3.72v-.62Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path1090"
        d="M563.12 551.1a63 63 0 0 0-13 3.95c-11.62 4.57-24.94 3.87-35.27-3.47a26.86 26.86 0 0 0 6.36 13.74c.81 1 3.32 3.45 3.32 3.45.42.44.34.71-.25.73a97.7 97.7 0 0 1-22.86-1.21c18.35 20.19 36.8 25.21 61.94 13 13.21-6.41 24.21.83 37.4.83 14 0 12.68-9.16 9.6-19.51l1.68.19c2.25 6.35 5.79 22-11.28 20.77-13.15-1-23.68-7.68-36.93-1.35-20.4 9.73-35.15 9.59-52.9-3.58-3.62-2.69-9.45-7.52-11.94-11.2-.6-.89 0-1.43.91-1.15 6.74 2.09 16.94 2.1 22.14 2-4.21-4.23-8.94-12.08-8.73-17.71 0-.73.37-.86 1-.55 9.62 5 13.22 7 24.44 7 6.6 0 20.1-7.46 24.11-6.69l.25.82Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path1092"
        d="M721.81 572.7c1.21.55 1.82-.22.47-.91-1.1-.56-7.13-3.41-10.35-3.63a.83.83 0 0 0-.86.56.57.57 0 0 0 .57.74c2.89.19 9 2.7 10.17 3.24"
      />
      <path
        id="San_Marino_svg__path1094"
        d="M679.48 572.55c6.67-.69 15.53-3 24-3.34a.69.69 0 0 0 .71-.65.62.62 0 0 0-.72-.61c-8.52.38-17.48 2.41-24.18 3.1-2.47.26-5.18-.23-6.47-1.39-.39-.36-1.4 1-1 1.3 1.73 1.54 5 1.87 7.67 1.59Z"
      />
      <path
        id="San_Marino_svg__path1096"
        d="M697.93 576.53a39.44 39.44 0 0 1 22.39 3.47 2.1 2.1 0 0 0 .76.22c.16 0 .41 0 .51-.18a.32.32 0 0 0 0-.3.7.7 0 0 0-.15-.22 2.6 2.6 0 0 0-.64-.44 39.2 39.2 0 0 0-23.31-3.8c-6.3.71-11.83 2.07-17.85 2.53-.53 0-.67.51-.81.92s-.35 1.06 1.53.86c6-.63 11.43-2.06 17.56-3Z"
      />
      <path
        id="San_Marino_svg__path1098"
        d="M679.42 569.53c3.52-.37 7.53-1.15 11.77-1.85a.66.66 0 0 0 .56-.77.66.66 0 0 0-.78-.55c-4.21.68-8.19 1.47-11.68 1.83a8.4 8.4 0 0 1-3.91-.5.67.67 0 1 0-.49 1.24 9.5 9.5 0 0 0 4.53.6"
      />
      <path
        id="San_Marino_svg__path1100"
        d="M725 557.51a1.3 1.3 0 0 0 .55.12.39.39 0 0 0 .38-.23.42.42 0 0 0-.1-.43 1.1 1.1 0 0 0-.43-.3 31.2 31.2 0 0 0-8.79-2.67.67.67 0 0 0-.77.39.51.51 0 0 0 .43.7 38.8 38.8 0 0 1 8.73 2.42"
      />
      <path
        id="San_Marino_svg__path1102"
        d="M724.27 561.51a1.8 1.8 0 0 0 .58.14.39.39 0 0 0 .4-.23.43.43 0 0 0-.14-.43 1.8 1.8 0 0 0-.47-.3 38.8 38.8 0 0 0-8.49-2.9.56.56 0 0 0-.74.41.6.6 0 0 0 .47.72 53.7 53.7 0 0 1 8.39 2.59"
      />
      <path
        id="San_Marino_svg__path1104"
        d="M679.43 576.24c5.16-.53 11.25-2.09 17.71-3 8.18-1.14 15.3-.72 23.82 3.14a2.06 2.06 0 0 0 .9.24.38.38 0 0 0 .44-.27.52.52 0 0 0-.2-.47 2.2 2.2 0 0 0-.56-.37c-7.92-4-16.22-4.78-24.54-3.65-6.46.88-12.6 2.23-17.75 2.77-2.89.29-6.19-.19-7.28-1.94-.29-.45-1.11.53-.84 1 1.65 2.64 5.49 2.88 8.3 2.58Z"
      />
      <path
        id="San_Marino_svg__path1106"
        d="M722.54 569.05c1.21.56 1.82-.22.47-.91a40.3 40.3 0 0 0-8.32-3.22.24.24 0 0 0-.24.13l-.3.8a.19.19 0 0 0 .16.27 43 43 0 0 1 8.23 2.93"
      />
      <path
        id="San_Marino_svg__path1108"
        d="M723.23 565.12c1.21.56 1.83-.22.47-.91a40.7 40.7 0 0 0-8.11-2.89.2.2 0 0 0-.24.18l-.11.8a.22.22 0 0 0 .17.23 40.7 40.7 0 0 1 7.82 2.59"
      />
      <path
        id="San_Marino_svg__path1110"
        d="M717 551.1a63 63 0 0 1 13 3.95c11.62 4.57 24.94 3.87 35.27-3.47a26.86 26.86 0 0 1-6.36 13.74c-.81 1-3.32 3.45-3.32 3.45-.42.44-.34.71.25.73a97.8 97.8 0 0 0 22.87-1.21c-18.36 20.19-36.81 25.21-62 13-13.21-6.41-24.21.83-37.4.83-14 0-12.68-9.16-9.6-19.51l-1.67.19c-2.26 6.35-5.79 22 11.27 20.77 13.15-1 23.68-7.68 36.93-1.35 20.4 9.73 35.15 9.59 52.9-3.58 3.62-2.69 9.45-7.52 11.94-11.2.61-.89 0-1.43-.91-1.15-6.74 2.09-16.94 2.1-22.14 2 4.21-4.23 8.94-12.08 8.73-17.71 0-.73-.37-.86-1-.55-9.61 5-13.22 7-24.44 7-6.61 0-20.09-7.46-24.11-6.69Z"
      />
      <path
        id="San_Marino_svg__path1112"
        d="M717 551.1a63 63 0 0 1 13 3.95c11.62 4.57 24.94 3.87 35.27-3.47a26.86 26.86 0 0 1-6.36 13.74c-.81 1-3.32 3.45-3.32 3.45-.42.44-.34.71.25.73a97.8 97.8 0 0 0 22.87-1.21c-18.36 20.19-36.81 25.21-62 13-13.21-6.41-24.21.83-37.4.83-14 0-12.68-9.16-9.6-19.51l-1.67.19c-2.26 6.35-5.79 22 11.27 20.77 13.15-1 23.68-7.68 36.93-1.35 20.4 9.73 35.15 9.59 52.9-3.58 3.62-2.69 9.45-7.52 11.94-11.2.61-.89 0-1.43-.91-1.15-6.74 2.09-16.94 2.1-22.14 2 4.21-4.23 8.94-12.08 8.73-17.71 0-.73-.37-.86-1-.55-9.61 5-13.22 7-24.44 7-6.61 0-20.09-7.46-24.11-6.69Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path1114"
        d="M639.3 535.57c-15.78.11-29.09-2.76-40.19-5.26-9.21-2.08-19.93-4.45-29.36-3.2-6.88.92-9.68 4-8.51 10.89 1.46 8.61 2.75 17.3 4.31 25.88.91 5 3.55 5.62 8.2 4.8 6.71-1.18 28.22-6 33 .11 4.63 5.86.11 10.09-6.34 10.2-.9 0-.61-.62-.31-.62 6.18 0 10.52-3.57 6.53-9-4.2-5.77-24.32-1.54-32.51.37-5.21 1.22-8.68.55-9.63-5.85a247 247 0 0 0-4.93-26.27c-4.73-19.27 29.66-10.35 39.57-8 13.51 3.13 24.78 5.15 40.8 5.63 16-.48 27.33-2.5 40.83-5.63 9.91-2.31 44.3-11.23 39.58 8a242 242 0 0 0-4.93 26.27c-1 6.4-4.42 7.07-9.63 5.85-8.2-1.91-28.32-6.14-32.52-.37-4 5.48.36 9 6.53 9 .31 0 .6.63-.3.62-6.46-.11-11-4.34-6.34-10.2 4.83-6.1 26.34-1.29 33-.11 4.66.82 7.3.16 8.2-4.8 1.56-8.58 2.85-17.27 4.31-25.88 1.18-6.93-1.63-10-8.51-10.89-9.43-1.25-20.15 1.12-29.35 3.2-11.11 2.5-24.42 5.37-40.19 5.26Z"
        className="San_Marino_svg__cls-3"
      />
      <path
        id="San_Marino_svg__path1116"
        d="M642.56 549c2.22 0 3.19-1 3.16-2.49s-.71-2.25-2.72-2.21h-1.87l.09 4.7zm9.29 8.57c-3.28-.11-5-1.75-6.77-3.69l-1.83-2h-1.91l.1 5.78-4.11.06-.28-16.52 6.38-.11c3.66-.06 6.36 1.58 6.42 5.25a4.94 4.94 0 0 1-2.46 4.42l1.58 1.66a6.86 6.86 0 0 0 3.64 2l-.76 3.19Z"
      />
      <path
        id="San_Marino_svg__path1118"
        d="M675.52 541c-.5 1.79-1 3.58-1.58 5.36a18.3 18.3 0 0 0 3.45-.65c-.49-1.59-1-3.18-1.43-4.8zm4.48 12-1.63-4.44a13.5 13.5 0 0 1-2.72.65c-.94.14-1.89.23-2.79.37l-1.77 5.09-4.25.8 5.16-14.21-1.8.34v-3.27c3.8-.62 7.49-1.31 11.16-2.09l.15 3.24-1.81.34 4.73 12.33z"
      />
    </g>
  </svg>
);
export default SvgSanMarino;
